import * as i0 from '@angular/core';
import { Injectable, Input, Directive, EventEmitter, Output, Pipe, Component, HostBinding, ViewChild, Inject, ChangeDetectionStrategy, HostListener, ViewEncapsulation, ElementRef, ViewChildren, NgModule } from '@angular/core';
import { InputPin, OutputPin, WorkflowType } from '@azavista/workflow-builder-shared';
import * as i5$3 from '@syncfusion/ej2-angular-diagrams';
import { ConnectorConstraints, PortConstraints, PortVisibility, NodeConstraints, SnapConstraints, DiagramConstraints, DiagramTools, Node, Connector, DiagramModule, SymbolPaletteModule } from '@syncfusion/ej2-angular-diagrams';
import * as i17 from '@azavista/components/exported-element';
import { AzavistaExportedElementExporterDirective, AzavistaExportedElementModule } from '@azavista/components/exported-element';
import { getCanvasWorkflow } from '@azavista/workflow-builder-shared/lib/factory';
import * as i2 from '@angular/forms';
import { FormGroup, FormArray, FormControl, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CrmStatus } from '@azavista/azavista-types';
import { BehaviorSubject, firstValueFrom, filter, map, Subject, of, debounceTime, takeUntil, startWith } from 'rxjs';
import * as i1 from '@azavista/components/shared';
import { getAzavistaMemoryCache, pick, delay as delay$1, jsonParse as jsonParse$1 } from '@azavista/components/shared';
import { fieldType, flatSearchToRecursive } from '@azavista/advanced-search';
import * as i7 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import * as i1$1 from '@azavista/servicelib';
import { AzavistaApiService, AzavistaServicelibModule } from '@azavista/servicelib';
import * as i1$2 from 'ng-resize-observer';
import { ngResizeObserverProviders } from 'ng-resize-observer';
import { isAdvancedQueryConditionConfigured, AzavistaFlowBuilderModule } from '@azavista/components/flow-builder';
import { AzavistaGroupedFieldsComponent } from '@azavista/components/grouped-fields';
import * as i4 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i4$2 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i7$2 from '@angular/material/progress-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import * as i4$4 from '@azavista/components/button';
import { AzavistaButtonModule } from '@azavista/components/button';
import * as i5 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i4$1 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i6 from '@angular/cdk/text-field';
import * as i5$1 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as i6$1 from '@azavista/components/duration';
import { AzavistaDurationModule } from '@azavista/components/duration';
import * as i7$1 from '@angular/material/expansion';
import { MatExpansionModule } from '@angular/material/expansion';
import * as i4$3 from '@angular/material/select';
import { MatSelectModule } from '@angular/material/select';
import * as i9 from '@angular/material/list';
import { MatListModule } from '@angular/material/list';
import * as i2$1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import * as i5$2 from '@azavista/components/table';
import { AzavistaTableModule } from '@azavista/components/table';
import * as i6$2 from '@azavista/components/input-field';
import { AzavistaInputFieldModule } from '@azavista/components/input-field';
import * as i2$2 from '@angular/material/slide-toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import * as i7$3 from '@angular/platform-browser';
import * as i11 from '@angular/material/button-toggle';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import * as i14 from '@angular/material/tabs';
import { MatTabsModule } from '@angular/material/tabs';
import { firstValueFrom as firstValueFrom$1 } from 'rxjs/internal/firstValueFrom';
import { debounceTime as debounceTime$1 } from 'rxjs/internal/operators/debounceTime';
import { StateMachine } from '@azavista/workflow-builder-shared/lib/builder';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AzavistaJobsStatusModule } from '@azavista/components/jobs-status';

/**
 * Please place the code according to the `// #region` comment tag
 *
 * For example `// #region General utils` `// #region Diagram utils`
 */
// #region General utils
function WorkflowBuilderNodeFormHeaderComponent_ng_container_1_button_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵlistener("click", function WorkflowBuilderNodeFormHeaderComponent_ng_container_1_button_5_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.toggleEditMode(true));
    });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "create");
    i0.ɵɵelementEnd()();
  }
}
function WorkflowBuilderNodeFormHeaderComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 2)(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "apply");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, WorkflowBuilderNodeFormHeaderComponent_ng_container_1_button_5_Template, 3, 0, "button", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 4);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "apply");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(4, 3, ctx_r1.formGroup.value.name, ctx_r1.getWorkflowName));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.disableEditMode);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(8, 6, ctx_r1.formGroup.value.description, ctx_r1.getWorkflowDescription), " ");
  }
}
function WorkflowBuilderNodeFormHeaderComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 2)(2, "mat-form-field");
    i0.ɵɵelement(3, "input", 6);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementStart(5, "mat-icon", 7);
    i0.ɵɵlistener("click", function WorkflowBuilderNodeFormHeaderComponent_ng_container_2_Template_mat_icon_click_5_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggleEditMode(false));
    });
    i0.ɵɵtext(6, "create");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(7, "div", 4)(8, "mat-form-field");
    i0.ɵɵelement(9, "textarea", 8);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("formControl", ctx_r1.formGroup.controls.name)("placeholder", i0.ɵɵpipeBind1(4, 4, "NAME"));
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("formControl", ctx_r1.formGroup.controls.description)("placeholder", i0.ɵɵpipeBind1(10, 6, "DESCRIPTION"));
  }
}
function WorkflowBuilderNodeFormFieldTextComponent_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-label", 3);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "azavista-duration", 4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵlistener("valueChanged", function WorkflowBuilderNodeFormFieldTextComponent_ng_container_0_ng_container_1_Template_azavista_duration_valueChanged_4_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.setValue($event));
    })("click", function WorkflowBuilderNodeFormFieldTextComponent_ng_container_0_ng_container_1_Template_azavista_duration_click_4_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.fieldClick.emit());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 3, ctx_r1.property.label), " :");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(5, 5, "VALUE"))("seconds", ctx_r1.control == null ? null : ctx_r1.control.value);
  }
}
function WorkflowBuilderNodeFormFieldTextComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, WorkflowBuilderNodeFormFieldTextComponent_ng_container_0_ng_container_1_Template, 6, 7, "ng-container", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const componentType_r3 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", componentType_r3 === "duration" && ctx_r1.property);
  }
}
function WorkflowBuilderNodeFormFieldTextComponent_ng_template_1_mat_form_field_0_input_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 9);
    i0.ɵɵlistener("focus", function WorkflowBuilderNodeFormFieldTextComponent_ng_template_1_mat_form_field_0_input_8_Template_input_focus_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onFocus($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("formControl", ctx_r1.control)("required", ctx_r1.property.mandatory);
  }
}
function WorkflowBuilderNodeFormFieldTextComponent_ng_template_1_mat_form_field_0_input_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 10);
    i0.ɵɵlistener("focus", function WorkflowBuilderNodeFormFieldTextComponent_ng_template_1_mat_form_field_0_input_9_Template_input_focus_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onFocus($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("formControl", ctx_r1.control)("required", ctx_r1.property.mandatory);
  }
}
function WorkflowBuilderNodeFormFieldTextComponent_ng_template_1_mat_form_field_0_mat_error_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const errorMessage_r7 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(errorMessage_r7);
  }
}
function WorkflowBuilderNodeFormFieldTextComponent_ng_template_1_mat_form_field_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field", 6);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "apply");
    i0.ɵɵpipe(3, "apply");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵlistener("click", function WorkflowBuilderNodeFormFieldTextComponent_ng_template_1_mat_form_field_0_Template_mat_form_field_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.fieldClick.emit());
    });
    i0.ɵɵelementStart(5, "mat-label");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, WorkflowBuilderNodeFormFieldTextComponent_ng_template_1_mat_form_field_0_input_8_Template, 1, 2, "input", 7)(9, WorkflowBuilderNodeFormFieldTextComponent_ng_template_1_mat_form_field_0_input_9_Template, 1, 2, "input", 8)(10, WorkflowBuilderNodeFormFieldTextComponent_ng_template_1_mat_form_field_0_mat_error_10_Template, 2, 1, "mat-error", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("mat-form-field-mandatory", ctx_r1.property.mandatory)("mat-form-field-not-empty", ctx_r1.control.value)("mat-form-field-hide-label", ctx_r1.hideLabel);
    i0.ɵɵproperty("hideRequiredMarker", !ctx_r1.control.invalid)("matTooltip", i0.ɵɵpipeBind1(1, 13, ctx_r1.property.label) + i0.ɵɵpipeBind2(2, 15, ctx_r1.control.valid, ctx_r1.getLabelTooltipAsterisk))("matTooltipDisabled", i0.ɵɵpipeBind1(4, 21, i0.ɵɵpipeBind2(3, 18, null, ctx_r1.isLabelEllipsisActive)) === false);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 23, ctx_r1.property.label));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.property.type === "text");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.property.type === "number");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.getErrorMessage(ctx_r1.control));
  }
}
function WorkflowBuilderNodeFormFieldTextComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, WorkflowBuilderNodeFormFieldTextComponent_ng_template_1_mat_form_field_0_Template, 11, 25, "mat-form-field", 5);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r1.property && ctx_r1.control);
  }
}
const _c0 = ["selectElement"];
function WorkflowBuilderNodeFormFieldSelectComponent_mat_expansion_panel_1_mat_list_option_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-list-option", 9);
    i0.ɵɵlistener("click", function WorkflowBuilderNodeFormFieldSelectComponent_mat_expansion_panel_1_mat_list_option_2_Template_mat_list_option_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onItemSelected(null));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("value", null)("selected", ctx_r1.control.value === null);
  }
}
function WorkflowBuilderNodeFormFieldSelectComponent_mat_expansion_panel_1_mat_list_option_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-list-option", 10);
    i0.ɵɵpipe(1, "apply");
    i0.ɵɵpipe(2, "apply");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵlistener("click", function WorkflowBuilderNodeFormFieldSelectComponent_mat_expansion_panel_1_mat_list_option_3_Template_mat_list_option_click_0_listener() {
      const item_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onItemSelected(item_r5));
    });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r5 = ctx.$implicit;
    const index_r6 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(i0.ɵɵpipeBind2(1, 8, index_r6, ctx_r1.getListOptionClassName));
    i0.ɵɵproperty("value", item_r5.value)("selected", ctx_r1.control.value == null ? null : ctx_r1.control.value.includes == null ? null : ctx_r1.control.value.includes(item_r5.value))("matTooltip", item_r5.trans[ctx_r1.currentLang])("matTooltipDisabled", i0.ɵɵpipeBind1(3, 14, i0.ɵɵpipeBind2(2, 11, index_r6, ctx_r1.isListOptionEllipsisActive)) === false);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", item_r5.trans[ctx_r1.currentLang], " ");
  }
}
function WorkflowBuilderNodeFormFieldSelectComponent_mat_expansion_panel_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-expansion-panel", 5);
    i0.ɵɵtwoWayListener("expandedChange", function WorkflowBuilderNodeFormFieldSelectComponent_mat_expansion_panel_1_Template_mat_expansion_panel_expandedChange_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.isExpanded, $event) || (ctx_r1.isExpanded = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementStart(1, "mat-selection-list", 6);
    i0.ɵɵtemplate(2, WorkflowBuilderNodeFormFieldSelectComponent_mat_expansion_panel_1_mat_list_option_2_Template, 1, 2, "mat-list-option", 7)(3, WorkflowBuilderNodeFormFieldSelectComponent_mat_expansion_panel_1_mat_list_option_3_Template, 5, 16, "mat-list-option", 8);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("mat-expansion-panel-field-not-empty", ctx_r1.property.type === "multiselect" ? ctx_r1.control.value.length > 0 : ctx_r1.control.value)("mat-expansion-panel-field-valid", ctx_r1.control.valid)("mat-expansion-panel-hide-label", ctx_r1.hideLabel)("mat-expansion-panel-hide-border", !ctx_r1.hideLabel && !ctx_r1.isExpanded);
    i0.ɵɵtwoWayProperty("expanded", ctx_r1.isExpanded);
    i0.ɵɵproperty("disabled", !!(ctx_r1.fieldState == null ? null : ctx_r1.fieldState.disabled));
    i0.ɵɵadvance();
    i0.ɵɵproperty("multiple", ctx_r1.property.type === "multiselect");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.property.mandatory && ctx_r1.property.type === "select");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.attributeTranslations)("ngForTrackBy", ctx_r1.trackByAttributeTranslations);
  }
}
function WorkflowBuilderNodeFormFieldSelectComponent_ng_template_2_mat_form_field_0_mat_icon_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵstyleProp("color", ctx_r1.dataSourceColor[ctx_r1.property.datasource] + " !important");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.dataSourceIcon[ctx_r1.property.datasource]);
  }
}
function WorkflowBuilderNodeFormFieldSelectComponent_ng_template_2_mat_form_field_0_mat_select_10_mat_option_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-option", 20);
    i0.ɵɵlistener("click", function WorkflowBuilderNodeFormFieldSelectComponent_ng_template_2_mat_form_field_0_mat_select_10_mat_option_4_Template_mat_option_click_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.onItemSelected(null));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("value", null);
  }
}
function WorkflowBuilderNodeFormFieldSelectComponent_ng_template_2_mat_form_field_0_mat_select_10_mat_option_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-option", 20);
    i0.ɵɵlistener("click", function WorkflowBuilderNodeFormFieldSelectComponent_ng_template_2_mat_form_field_0_mat_select_10_mat_option_5_Template_mat_option_click_0_listener() {
      const item_r10 = i0.ɵɵrestoreView(_r9).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.onItemSelected(item_r10));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r10 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("value", item_r10.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r10.trans[ctx_r1.currentLang]);
  }
}
function WorkflowBuilderNodeFormFieldSelectComponent_ng_template_2_mat_form_field_0_mat_select_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-select", 17, 2);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "apply");
    i0.ɵɵlistener("opened", function WorkflowBuilderNodeFormFieldSelectComponent_ng_template_2_mat_form_field_0_mat_select_10_Template_mat_select_opened_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onSelectOpen());
    });
    i0.ɵɵtemplate(4, WorkflowBuilderNodeFormFieldSelectComponent_ng_template_2_mat_form_field_0_mat_select_10_mat_option_4_Template, 1, 1, "mat-option", 18)(5, WorkflowBuilderNodeFormFieldSelectComponent_ng_template_2_mat_form_field_0_mat_select_10_mat_option_5_Template, 2, 2, "mat-option", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(2, 10, ctx_r1.property.label));
    i0.ɵɵproperty("required", ctx_r1.property.mandatory)("value", ctx_r1.control.value)("multiple", ctx_r1.property.type === "multiselect")("panelClass", i0.ɵɵpipeBind2(3, 12, ctx_r1.useInlineExpandedOptions, ctx_r1.getMatSelectPanelClass))("disabled", !!(ctx_r1.fieldState == null ? null : ctx_r1.fieldState.disabled))("errorStateMatcher", ctx_r1.matSelectErrorStateMatcher);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r1.property.mandatory && ctx_r1.property.type === "select");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.attributeTranslations)("ngForTrackBy", ctx_r1.trackByAttributeTranslations);
  }
}
function WorkflowBuilderNodeFormFieldSelectComponent_ng_template_2_mat_form_field_0_mat_error_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const errorMessage_r11 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(errorMessage_r11);
  }
}
function WorkflowBuilderNodeFormFieldSelectComponent_ng_template_2_mat_form_field_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-form-field", 12, 1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "apply");
    i0.ɵɵpipe(4, "apply");
    i0.ɵɵpipe(5, "async");
    i0.ɵɵelementStart(6, "mat-label");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, WorkflowBuilderNodeFormFieldSelectComponent_ng_template_2_mat_form_field_0_mat_icon_9_Template, 2, 3, "mat-icon", 13)(10, WorkflowBuilderNodeFormFieldSelectComponent_ng_template_2_mat_form_field_0_mat_select_10_Template, 6, 15, "mat-select", 14)(11, WorkflowBuilderNodeFormFieldSelectComponent_ng_template_2_mat_form_field_0_mat_error_11_Template, 2, 1, "mat-error", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("mat-form-field-mandatory", ctx_r1.property.mandatory)("mat-form-field-not-empty", ctx_r1.property.type === "multiselect" ? ctx_r1.control.value.length > 0 : ctx_r1.control.value)("mat-form-field-hide-label", ctx_r1.hideLabel)("mat-form-field-arrow-rotated", ctx_r1.isExpanded);
    i0.ɵɵproperty("hideRequiredMarker", !ctx_r1.control.invalid)("matTooltip", i0.ɵɵpipeBind1(2, 15, ctx_r1.property.label) + i0.ɵɵpipeBind2(3, 17, ctx_r1.control.valid, ctx_r1.getLabelTooltipAsterisk))("matTooltipDisabled", ctx_r1.isExpanded || !(ctx_r1.controlValue === null || (ctx_r1.controlValue == null ? null : ctx_r1.controlValue.length) === 0) || i0.ɵɵpipeBind1(5, 23, i0.ɵɵpipeBind2(4, 20, null, ctx_r1.isLabelEllipsisActive)) === false);
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 25, ctx_r1.property.label));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.property.type === "multiselect" ? ctx_r1.control.value.length > 0 : ctx_r1.control.value);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.matSelectErrorStateMatcher);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.getErrorMessage(ctx_r1.control));
  }
}
function WorkflowBuilderNodeFormFieldSelectComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, WorkflowBuilderNodeFormFieldSelectComponent_ng_template_2_mat_form_field_0_Template, 12, 27, "mat-form-field", 11);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r1.attributeTranslations && ctx_r1.property && ctx_r1.control);
  }
}
const _c1 = ["addValueEl"];
const _c2 = ["addValueField"];
const _c3 = ["tableEl"];
function WorkflowBuilderNodeFormFieldSelectCapacityCapacityTableDialogComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelementContainer(1, 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const templateRef_r2 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", templateRef_r2);
  }
}
function WorkflowBuilderNodeFormFieldSelectCapacityCapacityTableDialogComponent_span_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 17);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function WorkflowBuilderNodeFormFieldSelectCapacityCapacityTableDialogComponent_ng_template_28_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 4)(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 7)(5, "div", 8);
    i0.ɵɵelement(6, "azavista-input-field", 19, 3);
    i0.ɵɵelementStart(8, "azavista-button", 20);
    i0.ɵɵlistener("click", function WorkflowBuilderNodeFormFieldSelectCapacityCapacityTableDialogComponent_ng_template_28_ng_container_0_Template_azavista_button_click_8_listener() {
      i0.ɵɵrestoreView(_r3);
      const addValueField_r4 = i0.ɵɵreference(7);
      const ctx_r4 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r4.addRows(addValueField_r4 == null ? null : addValueField_r4.value));
    });
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const field_r6 = ctx.ngIf;
    const addValueField_r4 = i0.ɵɵreference(7);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(field_r6.label);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("field", field_r6)("canEdit", true)("editMode", true)("fullWidth", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", !(addValueField_r4 == null ? null : addValueField_r4.value == null ? null : addValueField_r4.value.length));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 7, "ADD"));
  }
}
function WorkflowBuilderNodeFormFieldSelectCapacityCapacityTableDialogComponent_ng_template_28_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, WorkflowBuilderNodeFormFieldSelectCapacityCapacityTableDialogComponent_ng_template_28_ng_container_0_Template, 11, 9, "ng-container", 18);
    i0.ɵɵpipe(1, "apply");
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind2(1, 1, ctx_r4.rows, ctx_r4.getAddValueField));
  }
}
const _c4 = ["selectFieldEl"];
const _c5 = () => ({});
function WorkflowBuilderNodeFormFieldSelectCapacityComponent_div_2_mat_icon_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 6);
    i0.ɵɵtext(1, "error");
    i0.ɵɵelementEnd();
  }
}
function WorkflowBuilderNodeFormFieldSelectCapacityComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "azavista-button", 4);
    i0.ɵɵlistener("click", function WorkflowBuilderNodeFormFieldSelectCapacityComponent_div_2_Template_azavista_button_click_1_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.configureCapacity());
    });
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, WorkflowBuilderNodeFormFieldSelectCapacityComponent_div_2_mat_icon_5_Template, 2, 0, "mat-icon", 5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", !(ctx_r2.control == null ? null : ctx_r2.control.value == null ? null : ctx_r2.control.value.select_field_id));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 3, "CONFIGURE_CAPACITY"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r2.objectKeys((ctx_r2.control == null ? null : ctx_r2.control.value == null ? null : ctx_r2.control.value.limit_map) || i0.ɵɵpureFunction0(5, _c5)).length);
  }
}
function WorkflowBuilderNodeFormFieldToggleComponent_mat_slide_toggle_0_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function WorkflowBuilderNodeFormFieldToggleComponent_mat_slide_toggle_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-slide-toggle", 1);
    i0.ɵɵlistener("change", function WorkflowBuilderNodeFormFieldToggleComponent_mat_slide_toggle_0_Template_mat_slide_toggle_change_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.updateValue($event.checked));
    })("click", function WorkflowBuilderNodeFormFieldToggleComponent_mat_slide_toggle_0_Template_mat_slide_toggle_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.fieldClick.emit());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtemplate(3, WorkflowBuilderNodeFormFieldToggleComponent_mat_slide_toggle_0_span_3_Template, 2, 0, "span", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("checked", ctx_r1.control.value)("disabled", !!(ctx_r1.fieldState == null ? null : ctx_r1.fieldState.disabled));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 4, ctx_r1.property.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.control.invalid);
  }
}
function WorkflowBuilderNodeFormFieldProcessComponent_ng_container_0_mat_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, "add");
    i0.ɵɵelementEnd();
  }
}
function WorkflowBuilderNodeFormFieldProcessComponent_ng_container_0_mat_icon_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, "settings");
    i0.ɵɵelementEnd();
  }
}
function WorkflowBuilderNodeFormFieldProcessComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 1);
    i0.ɵɵlistener("click", function WorkflowBuilderNodeFormFieldProcessComponent_ng_container_0_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.openSteps());
    });
    i0.ɵɵtemplate(2, WorkflowBuilderNodeFormFieldProcessComponent_ng_container_0_mat_icon_2_Template, 2, 0, "mat-icon", 0)(3, WorkflowBuilderNodeFormFieldProcessComponent_ng_container_0_mat_icon_3_Template, 2, 0, "mat-icon", 0);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassProp("has-steps", ctx_r1.control == null ? null : ctx_r1.control.value == null ? null : ctx_r1.control.value.length);
    i0.ɵɵproperty("disabled", !!(ctx_r1.fieldState == null ? null : ctx_r1.fieldState.disabled));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !(ctx_r1.control == null ? null : ctx_r1.control.value == null ? null : ctx_r1.control.value.length));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control == null ? null : ctx_r1.control.value == null ? null : ctx_r1.control.value.length);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 6, ctx_r1.property.label), " ");
  }
}
function WorkflowBuilderNodeFormFieldAdvancedQueryComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 1);
    i0.ɵɵlistener("click", function WorkflowBuilderNodeFormFieldAdvancedQueryComponent_ng_container_0_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.openCondition());
    });
    i0.ɵɵelementStart(2, "mat-icon");
    i0.ɵɵtext(3, "add");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mat-icon", 2);
    i0.ɵɵtext(5, "filter_alt");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassProp("is-configured", ctx_r1.isAdvancedQueryConditionConfigured(ctx_r1.getCondition()));
    i0.ɵɵproperty("disabled", !!(ctx_r1.fieldState == null ? null : ctx_r1.fieldState.disabled));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 4, ctx_r1.property.label), " ");
  }
}
const _c6 = ["workflowSettingsGroupedField"];
const _c7 = ["formContainer"];
const _c8 = ["formHeader"];
function WorkflowBuilderNodeFormComponent_div_0_azavista_workflow_builder_node_form_header_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-workflow-builder-node-form-header", 11, 1);
    i0.ɵɵlistener("canvasChanges", function WorkflowBuilderNodeFormComponent_div_0_azavista_workflow_builder_node_form_header_2_Template_azavista_workflow_builder_node_form_header_canvasChanges_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onUpdateCanvasFields($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("canvas", ctx_r1.controllerData)("workflowType", ctx_r1.controllerData.factory.type);
  }
}
function WorkflowBuilderNodeFormComponent_div_0_ng_container_4_ng_container_1_ng_container_1_azavista_workflow_builder_node_form_field_select_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-workflow-builder-node-form-field-select", 17);
    i0.ɵɵpipe(1, "apply");
    i0.ɵɵlistener("outputPinUpdate", function WorkflowBuilderNodeFormComponent_div_0_ng_container_4_ng_container_1_ng_container_1_azavista_workflow_builder_node_form_field_select_1_Template_azavista_workflow_builder_node_form_field_select_outputPinUpdate_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.outputPinUpdate.emit($event));
    })("fieldClick", function WorkflowBuilderNodeFormComponent_div_0_ng_container_4_ng_container_1_ng_container_1_azavista_workflow_builder_node_form_field_select_1_Template_azavista_workflow_builder_node_form_field_select_fieldClick_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const property_r4 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.fieldClick.emit(property_r4));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const formControl_r5 = i0.ɵɵnextContext().ngIf;
    const property_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("workflow-builder-node-form-field--disabled", ctx_r1.fieldState == null ? null : ctx_r1.fieldState[property_r4.attribute] == null ? null : ctx_r1.fieldState[property_r4.attribute].disabled);
    i0.ɵɵproperty("eventId", ctx_r1.eventId)("workflowId", ctx_r1.workflowId)("property", property_r4)("hideLabel", ctx_r1.autoHideFieldLabel)("control", formControl_r5)("workflowItemDestroyed", ctx_r1.workflowItemDestroyed)("addFormFieldObservableCallback", ctx_r1.addFormFieldObservableCallback)("fieldState", ctx_r1.fieldState == null ? null : ctx_r1.fieldState[property_r4.attribute])("propertyOptions", i0.ɵɵpipeBind2(1, 11, property_r4.attribute, ctx_r1.getAttributePropertyOptions));
  }
}
function WorkflowBuilderNodeFormComponent_div_0_ng_container_4_ng_container_1_ng_container_1_azavista_workflow_builder_node_form_field_select_capacity_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-workflow-builder-node-form-field-select-capacity", 17);
    i0.ɵɵpipe(1, "apply");
    i0.ɵɵlistener("outputPinUpdate", function WorkflowBuilderNodeFormComponent_div_0_ng_container_4_ng_container_1_ng_container_1_azavista_workflow_builder_node_form_field_select_capacity_2_Template_azavista_workflow_builder_node_form_field_select_capacity_outputPinUpdate_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.outputPinUpdate.emit($event));
    })("fieldClick", function WorkflowBuilderNodeFormComponent_div_0_ng_container_4_ng_container_1_ng_container_1_azavista_workflow_builder_node_form_field_select_capacity_2_Template_azavista_workflow_builder_node_form_field_select_capacity_fieldClick_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const property_r4 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.fieldClick.emit(property_r4));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const formControl_r5 = i0.ɵɵnextContext().ngIf;
    const property_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("workflow-builder-node-form-field--disabled", ctx_r1.fieldState == null ? null : ctx_r1.fieldState[property_r4.attribute] == null ? null : ctx_r1.fieldState[property_r4.attribute].disabled);
    i0.ɵɵproperty("eventId", ctx_r1.eventId)("workflowId", ctx_r1.workflowId)("property", property_r4)("hideLabel", ctx_r1.autoHideFieldLabel)("control", formControl_r5)("workflowItemDestroyed", ctx_r1.workflowItemDestroyed)("addFormFieldObservableCallback", ctx_r1.addFormFieldObservableCallback)("fieldState", ctx_r1.fieldState == null ? null : ctx_r1.fieldState[property_r4.attribute])("propertyOptions", i0.ɵɵpipeBind2(1, 11, property_r4.attribute, ctx_r1.getAttributePropertyOptions));
  }
}
function WorkflowBuilderNodeFormComponent_div_0_ng_container_4_ng_container_1_ng_container_1_azavista_workflow_builder_node_form_field_text_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-workflow-builder-node-form-field-text", 18);
    i0.ɵɵpipe(1, "apply");
    i0.ɵɵlistener("outputPinUpdate", function WorkflowBuilderNodeFormComponent_div_0_ng_container_4_ng_container_1_ng_container_1_azavista_workflow_builder_node_form_field_text_3_Template_azavista_workflow_builder_node_form_field_text_outputPinUpdate_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.outputPinUpdate.emit($event));
    })("fieldClick", function WorkflowBuilderNodeFormComponent_div_0_ng_container_4_ng_container_1_ng_container_1_azavista_workflow_builder_node_form_field_text_3_Template_azavista_workflow_builder_node_form_field_text_fieldClick_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const property_r4 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.fieldClick.emit(property_r4));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const formControl_r5 = i0.ɵɵnextContext().ngIf;
    const property_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("workflow-builder-node-form-field--disabled", ctx_r1.fieldState == null ? null : ctx_r1.fieldState[property_r4.attribute] == null ? null : ctx_r1.fieldState[property_r4.attribute].disabled);
    i0.ɵɵproperty("eventId", ctx_r1.eventId)("workflowId", ctx_r1.workflowId)("hideLabel", ctx_r1.autoHideFieldLabel)("property", property_r4)("control", formControl_r5)("workflowItemDestroyed", ctx_r1.workflowItemDestroyed)("addFormFieldObservableCallback", ctx_r1.addFormFieldObservableCallback)("fieldState", ctx_r1.fieldState == null ? null : ctx_r1.fieldState[property_r4.attribute])("propertyOptions", i0.ɵɵpipeBind2(1, 11, property_r4.attribute, ctx_r1.getAttributePropertyOptions));
  }
}
function WorkflowBuilderNodeFormComponent_div_0_ng_container_4_ng_container_1_ng_container_1_azavista_workflow_builder_node_form_field_toggle_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-workflow-builder-node-form-field-toggle", 18);
    i0.ɵɵpipe(1, "apply");
    i0.ɵɵlistener("outputPinUpdate", function WorkflowBuilderNodeFormComponent_div_0_ng_container_4_ng_container_1_ng_container_1_azavista_workflow_builder_node_form_field_toggle_4_Template_azavista_workflow_builder_node_form_field_toggle_outputPinUpdate_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.outputPinUpdate.emit($event));
    })("fieldClick", function WorkflowBuilderNodeFormComponent_div_0_ng_container_4_ng_container_1_ng_container_1_azavista_workflow_builder_node_form_field_toggle_4_Template_azavista_workflow_builder_node_form_field_toggle_fieldClick_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const property_r4 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.fieldClick.emit(property_r4));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const formControl_r5 = i0.ɵɵnextContext().ngIf;
    const property_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("workflow-builder-node-form-field--disabled", ctx_r1.fieldState == null ? null : ctx_r1.fieldState[property_r4.attribute] == null ? null : ctx_r1.fieldState[property_r4.attribute].disabled);
    i0.ɵɵproperty("eventId", ctx_r1.eventId)("workflowId", ctx_r1.workflowId)("hideLabel", ctx_r1.autoHideFieldLabel)("property", property_r4)("control", formControl_r5)("workflowItemDestroyed", ctx_r1.workflowItemDestroyed)("addFormFieldObservableCallback", ctx_r1.addFormFieldObservableCallback)("fieldState", ctx_r1.fieldState == null ? null : ctx_r1.fieldState[property_r4.attribute])("propertyOptions", i0.ɵɵpipeBind2(1, 11, property_r4.attribute, ctx_r1.getAttributePropertyOptions));
  }
}
function WorkflowBuilderNodeFormComponent_div_0_ng_container_4_ng_container_1_ng_container_1_azavista_workflow_builder_node_form_field_process_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-workflow-builder-node-form-field-process", 19);
    i0.ɵɵpipe(1, "apply");
    i0.ɵɵpipe(2, "apply");
    i0.ɵɵlistener("outputPinUpdate", function WorkflowBuilderNodeFormComponent_div_0_ng_container_4_ng_container_1_ng_container_1_azavista_workflow_builder_node_form_field_process_5_Template_azavista_workflow_builder_node_form_field_process_outputPinUpdate_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.outputPinUpdate.emit($event));
    })("fieldClick", function WorkflowBuilderNodeFormComponent_div_0_ng_container_4_ng_container_1_ng_container_1_azavista_workflow_builder_node_form_field_process_5_Template_azavista_workflow_builder_node_form_field_process_fieldClick_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const property_r4 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.fieldClick.emit(property_r4));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const formControl_r5 = i0.ɵɵnextContext().ngIf;
    const property_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("workflow-builder-node-form-field--disabled", ctx_r1.fieldState == null ? null : ctx_r1.fieldState[property_r4.attribute] == null ? null : ctx_r1.fieldState[property_r4.attribute].disabled);
    i0.ɵɵproperty("eventId", ctx_r1.eventId)("workflowId", ctx_r1.workflowId)("property", property_r4)("hideLabel", ctx_r1.autoHideFieldLabel)("control", formControl_r5)("workflowItemDestroyed", ctx_r1.workflowItemDestroyed)("addFormFieldObservableCallback", ctx_r1.addFormFieldObservableCallback)("fieldState", ctx_r1.fieldState == null ? null : ctx_r1.fieldState[property_r4.attribute])("propertyOptions", i0.ɵɵpipeBind2(1, 13, property_r4.attribute, ctx_r1.getAttributePropertyOptions))("updateProcessCallback", ctx_r1.updateProcessCallback)("isNewBuilderCompatible", i0.ɵɵpipeBind2(2, 16, property_r4.attribute, ctx_r1.isBuilderCompatible));
  }
}
function WorkflowBuilderNodeFormComponent_div_0_ng_container_4_ng_container_1_ng_container_1_azavista_workflow_builder_node_form_field_advanced_query_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-workflow-builder-node-form-field-advanced-query", 20);
    i0.ɵɵpipe(1, "apply");
    i0.ɵɵlistener("outputPinUpdate", function WorkflowBuilderNodeFormComponent_div_0_ng_container_4_ng_container_1_ng_container_1_azavista_workflow_builder_node_form_field_advanced_query_6_Template_azavista_workflow_builder_node_form_field_advanced_query_outputPinUpdate_0_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.outputPinUpdate.emit($event));
    })("fieldClick", function WorkflowBuilderNodeFormComponent_div_0_ng_container_4_ng_container_1_ng_container_1_azavista_workflow_builder_node_form_field_advanced_query_6_Template_azavista_workflow_builder_node_form_field_advanced_query_fieldClick_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const property_r4 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.fieldClick.emit(property_r4));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const formControl_r5 = i0.ɵɵnextContext().ngIf;
    const property_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("workflow-builder-node-form-field--disabled", ctx_r1.fieldState == null ? null : ctx_r1.fieldState[property_r4.attribute] == null ? null : ctx_r1.fieldState[property_r4.attribute].disabled);
    i0.ɵɵproperty("eventId", ctx_r1.eventId)("workflowId", ctx_r1.workflowId)("property", property_r4)("hideLabel", ctx_r1.autoHideFieldLabel)("updateAdvancedQueryCallback", ctx_r1.updateAdvancedQueryCallback)("control", formControl_r5)("workflowItemDestroyed", ctx_r1.workflowItemDestroyed)("addFormFieldObservableCallback", ctx_r1.addFormFieldObservableCallback)("fieldState", ctx_r1.fieldState == null ? null : ctx_r1.fieldState[property_r4.attribute])("propertyOptions", i0.ɵɵpipeBind2(1, 12, property_r4.attribute, ctx_r1.getAttributePropertyOptions));
  }
}
function WorkflowBuilderNodeFormComponent_div_0_ng_container_4_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, WorkflowBuilderNodeFormComponent_div_0_ng_container_4_ng_container_1_ng_container_1_azavista_workflow_builder_node_form_field_select_1_Template, 2, 14, "azavista-workflow-builder-node-form-field-select", 13)(2, WorkflowBuilderNodeFormComponent_div_0_ng_container_4_ng_container_1_ng_container_1_azavista_workflow_builder_node_form_field_select_capacity_2_Template, 2, 14, "azavista-workflow-builder-node-form-field-select-capacity", 13)(3, WorkflowBuilderNodeFormComponent_div_0_ng_container_4_ng_container_1_ng_container_1_azavista_workflow_builder_node_form_field_text_3_Template, 2, 14, "azavista-workflow-builder-node-form-field-text", 14)(4, WorkflowBuilderNodeFormComponent_div_0_ng_container_4_ng_container_1_ng_container_1_azavista_workflow_builder_node_form_field_toggle_4_Template, 2, 14, "azavista-workflow-builder-node-form-field-toggle", 14)(5, WorkflowBuilderNodeFormComponent_div_0_ng_container_4_ng_container_1_ng_container_1_azavista_workflow_builder_node_form_field_process_5_Template, 3, 19, "azavista-workflow-builder-node-form-field-process", 15)(6, WorkflowBuilderNodeFormComponent_div_0_ng_container_4_ng_container_1_ng_container_1_azavista_workflow_builder_node_form_field_advanced_query_6_Template, 2, 15, "azavista-workflow-builder-node-form-field-advanced-query", 16);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const property_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", property_r4.type === "select" || property_r4.type === "multiselect");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", property_r4.type === "select-limit");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", property_r4.type === "text" || property_r4.type === "number");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", property_r4.type === "boolean");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", property_r4.type === "process");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", property_r4.type === "advanced-query");
  }
}
function WorkflowBuilderNodeFormComponent_div_0_ng_container_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, WorkflowBuilderNodeFormComponent_div_0_ng_container_4_ng_container_1_ng_container_1_Template, 7, 6, "ng-container", 7);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const property_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.formGroup == null ? null : ctx_r1.formGroup.controls == null ? null : ctx_r1.formGroup.controls[property_r4.attribute]);
  }
}
function WorkflowBuilderNodeFormComponent_div_0_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, WorkflowBuilderNodeFormComponent_div_0_ng_container_4_ng_container_1_Template, 2, 1, "ng-container", 12);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.properties)("ngForTrackBy", ctx_r1.trackByWorkflowProperty);
  }
}
function WorkflowBuilderNodeFormComponent_div_0_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21)(1, "azavista-button", 22);
    i0.ɵɵlistener("click", function WorkflowBuilderNodeFormComponent_div_0_div_5_Template_azavista_button_click_1_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.toggleExpandPanels());
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, ctx_r1.workflowSettingsGroupedFieldData.expandPanels ? "CLOSE" : ctx_r1.isWorkflowValid ? "OPEN" : "SETUP_REQUIRED"));
  }
}
function WorkflowBuilderNodeFormComponent_div_0_button_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 23);
    i0.ɵɵlistener("click", function WorkflowBuilderNodeFormComponent_div_0_button_7_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r12);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.removeNode.emit());
    });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "delete");
    i0.ɵɵelementEnd()();
  }
}
function WorkflowBuilderNodeFormComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4, 0);
    i0.ɵɵtemplate(2, WorkflowBuilderNodeFormComponent_div_0_azavista_workflow_builder_node_form_header_2_Template, 2, 2, "azavista-workflow-builder-node-form-header", 5);
    i0.ɵɵelementStart(3, "div", 6);
    i0.ɵɵtemplate(4, WorkflowBuilderNodeFormComponent_div_0_ng_container_4_Template, 2, 2, "ng-container", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, WorkflowBuilderNodeFormComponent_div_0_div_5_Template, 4, 3, "div", 8);
    i0.ɵɵelementStart(6, "div", 9);
    i0.ɵɵtemplate(7, WorkflowBuilderNodeFormComponent_div_0_button_7_Template, 3, 0, "button", 10);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("workflow-builder-node-item--valid", ctx_r1.isWorkflowValid);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.showFormEditHeader && ctx_r1.controllerData && (ctx_r1.controllerData == null ? null : ctx_r1.controllerData.factory == null ? null : ctx_r1.controllerData.factory.type));
    i0.ɵɵadvance();
    i0.ɵɵclassProp("workflow-builder-node-item__fields--expanded", ctx_r1.workflowSettingsGroupedFieldData.expandPanels);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.workflowSettingsGroupedFieldData.expandPanels);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.alwaysExpandPanels && ctx_r1.workflowSettingsGroupedFieldData.fieldsWithEntity.fields.length > 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !(ctx_r1.formHeader == null ? null : ctx_r1.formHeader.editMode) && ctx_r1.canDelete);
  }
}
function WorkflowBuilderNodeFormComponent_mat_progress_bar_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-progress-bar", 24);
  }
}
const _c9 = () => ["aza-cmp-flex-row", "aza-cmp-flex-item-grow"];
function WorkflowBuilderNodeItemEditDialogComponent_azavista_workflow_builder_node_form_header_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-workflow-builder-node-form-header", 10, 1);
    i0.ɵɵlistener("canvasChanges", function WorkflowBuilderNodeItemEditDialogComponent_azavista_workflow_builder_node_form_header_4_Template_azavista_workflow_builder_node_form_header_canvasChanges_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.updateResult("canvasChanges", $event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("canvas", ctx_r2.data.controllerData)("workflowType", ctx_r2.data.controllerData.factory.type);
  }
}
const _c10 = ["formHeaderEl"];
const _c11 = (a0, a1) => ({
  "aza-cmp-cursor-hand": a0,
  "aza-cmp-cursor-hand-to-children": a1
});
function WorkflowBuilderNodeItemComponent_div_1_azavista_flat_button_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-flat-button", 11);
    i0.ɵɵlistener("click", function WorkflowBuilderNodeItemComponent_div_1_azavista_flat_button_6_Template_azavista_flat_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.toggleCanvasLocked(true));
    });
    i0.ɵɵelementStart(1, "mat-icon", 12);
    i0.ɵɵtext(2, "lock");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-icon", 13);
    i0.ɵɵtext(4, "lock_open");
    i0.ɵɵelementEnd()();
  }
}
function WorkflowBuilderNodeItemComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "azavista-flat-button", 8);
    i0.ɵɵlistener("click", function WorkflowBuilderNodeItemComponent_div_1_Template_azavista_flat_button_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.openEditDialog());
    });
    i0.ɵɵelementStart(2, "mat-icon");
    i0.ɵɵtext(3, "drive_file_rename_outline");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, WorkflowBuilderNodeItemComponent_div_1_azavista_flat_button_6_Template, 5, 0, "azavista-flat-button", 9);
    i0.ɵɵelementStart(7, "azavista-flat-button", 10);
    i0.ɵɵlistener("click", function WorkflowBuilderNodeItemComponent_div_1_Template_azavista_flat_button_click_7_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.removeNode.emit());
    });
    i0.ɵɵelementStart(8, "mat-icon");
    i0.ɵɵtext(9, "delete");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 2, "EDIT_DETAILS"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !(ctx_r1.controllerData == null ? null : ctx_r1.controllerData.locked));
  }
}
function WorkflowBuilderNodeItemComponent_azavista_workflow_builder_node_form_header_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "azavista-workflow-builder-node-form-header", 14, 0);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("canvas", ctx_r1.formHeaderCanvas)("workflowType", ctx_r1.controllerData.factory.type)("disableEditMode", true);
  }
}
function WorkflowBuilderNodeItemComponent_azavista_flat_button_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-flat-button", 15);
    i0.ɵɵlistener("click", function WorkflowBuilderNodeItemComponent_azavista_flat_button_5_Template_azavista_flat_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggleCanvasLocked(false));
    });
    i0.ɵɵelementStart(1, "mat-icon", 16);
    i0.ɵɵtext(2, "lock");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-icon", 17);
    i0.ɵɵtext(4, "lock_open");
    i0.ɵɵelementEnd()();
  }
}
function AzavistaWorkflowBuilderZoomSelectComponent_mat_option_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 3);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "number");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const factor_r1 = ctx.$implicit;
    i0.ɵɵproperty("value", factor_r1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind2(2, 2, factor_r1 * 100, "1.0-0"), " %");
  }
}
const _c12 = ["diagram"];
function WorkflowBuilderComponent_azavista_button_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-button", 20);
    i0.ɵɵlistener("click", function WorkflowBuilderComponent_azavista_button_11_Template_azavista_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.dataProvider.revertPublishedBuilderData(ctx_r2.eventId));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "REVERT_TO_PUBLISHED"));
  }
}
function WorkflowBuilderComponent_strong_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "strong");
    i0.ɵɵtext(1, " This is a demo version and does not save data ");
    i0.ɵɵelementEnd();
  }
}
function WorkflowBuilderComponent_ng_template_17_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-workflow-builder-node-item", 21);
    i0.ɵɵlistener("workflowSettingsChanges", function WorkflowBuilderComponent_ng_template_17_Template_azavista_workflow_builder_node_item_workflowSettingsChanges_0_listener($event) {
      const data_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.updateWorkflowSettings(data_r5.id, $event));
    })("canvasChanges", function WorkflowBuilderComponent_ng_template_17_Template_azavista_workflow_builder_node_item_canvasChanges_0_listener($event) {
      const data_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.updateWorkflowCanvas(data_r5.id, $event));
    })("outputPinUpdate", function WorkflowBuilderComponent_ng_template_17_Template_azavista_workflow_builder_node_item_outputPinUpdate_0_listener($event) {
      const data_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.updateNextWorkflow(data_r5.id, $event));
    })("removeNode", function WorkflowBuilderComponent_ng_template_17_Template_azavista_workflow_builder_node_item_removeNode_0_listener() {
      const data_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.deleteNode(data_r5));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const data_r5 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("valid-next-workflow-target", ctx_r2.ongoingValidNextWorkflowIdMap == null ? null : ctx_r2.ongoingValidNextWorkflowIdMap[data_r5.id]);
    i0.ɵɵproperty("node", data_r5)("diagramEl", ctx_r2.diagramEl)("eventId", ctx_r2.eventId)("stateCallbackMap", ctx_r2.stateCallbackMap)("updateAdvancedQueryCallback", ctx_r2.updateAdvancedQueryCallback)("propertyOptions", ctx_r2.propertyOptions)("autoHideFieldLabel", ctx_r2.autoHideFieldLabel)("updateProcessCallback", ctx_r2.updateProcessCallback);
  }
}
function WorkflowBuilderComponent_div_33_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22)(1, "mat-tab-group")(2, "mat-tab", 23);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "azavista-workflow-builder-workflow-builder-palette", 24);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 25)(6, "button", 26);
    i0.ɵɵlistener("click", function WorkflowBuilderComponent_div_33_Template_button_click_6_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.toggleIsHidingPalette(true));
    });
    i0.ɵɵelementStart(7, "mat-icon");
    i0.ɵɵtext(8, "cancel");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(3, 2, "WORK_BLOCKS"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("workflowTypeCategories", ctx_r2.workflowTypeCategories);
  }
}
function WorkflowBuilderComponent_div_34_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 27);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r2.getConnectorPortsStyles(ctx_r2.diagramEl.connectors), i0.ɵɵsanitizeHtml);
  }
}
function WorkflowBuilderWithStateComponent_azavista_workflow_builder_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-workflow-builder", 1);
    i0.ɵɵlistener("nodeItemsLoaded", function WorkflowBuilderWithStateComponent_azavista_workflow_builder_0_Template_azavista_workflow_builder_nodeItemsLoaded_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.builderEvent.emit({
        type: "nodeItemsLoaded",
        nodeItems: $event
      }));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("dataProvider", ctx_r1.dataProvider)("eventId", ctx_r1.eventId)("debugMode", ctx_r1.debugMode)("isDemo", ctx_r1.isDemo)("stateCallbackMap", ctx_r1.stateCallbackMap)("propertyOptions", ctx_r1.propertyOptions)("autoHideFieldLabel", ctx_r1.autoHideFieldLabel)("updateProcessCallback", ctx_r1.updateProcessCallback)("updateAdvancedQueryCallback", ctx_r1.updateAdvancedQueryCallback)("deleteWorkflowConfirmation", ctx_r1.deleteWorkflowConfirmation)("hidePaletteList", ctx_r1.hidePaletteList)("workflowTypeCategories", ctx_r1.workflowTypeCategories)("scrollSettings", ctx_r1.defaultScrollSettings);
  }
}
const omit = (data, properties) => {
  const result = {
    ...data
  };
  properties.forEach(key => delete result[key]);
  return result;
};
const objectKeys = o => {
  return Object.keys(o);
};
const delay = milliSeconds => {
  return new Promise(resolve => {
    setTimeout(resolve, milliSeconds);
  });
};
const getGroupByValue = (rows, fieldName) => {
  return rows.reduce((group, row) => {
    group[row[fieldName]] = [...(group[row[fieldName]] ?? []), row];
    return group;
  }, {});
};
const getMapByValue = (rows, fieldName) => {
  return rows.reduce((group, row) => {
    group[row[fieldName]] = row;
    return group;
  }, {});
};
const getMapByValueFromFn = (rows, fn) => {
  return rows.reduce((group, row) => {
    group[fn(row)] = row;
    return group;
  }, {});
};
const isObject = item => {
  return item && typeof item === 'object' && !Array.isArray(item);
};
/**
 *
 * @param target
 * @param source
 * @returns new object that merged both `target` & `source` with properties from `source` replacing existing `target`'s properties
 */
const mergeDeep = (target, source) => {
  const output = {
    ...target
  };
  if (isObject(target) && isObject(source)) {
    objectKeys(source).forEach(key => {
      if (isObject(source[key])) {
        if (!(key in target)) Object.assign(output, {
          [key]: source[key]
        });else output[key] = mergeDeep(target[key], source[key]);
      } else {
        Object.assign(output, {
          [key]: source[key]
        });
      }
    });
  }
  return output;
};
// #endregion
// #region HTML template utils
const trackByWorkflowProperty = (index, item) => {
  return item.attribute;
};
const trackBy = attribute => (index, item) => item[attribute];
const trackByAttributeTranslations = (index, item) => {
  return item.value;
};
// #endregion
// #region Diagram utils
const getOutputPinTranslationKey = (workflowType, outputPin) => {
  return OUTPUT_PIN_TRANSLATIONS_CUSTOM_BY_WORKFLOW_TYPE[workflowType]?.[outputPin] ?? OUTPUT_PIN_TRANSLATIONS[outputPin];
};
const getConnectorAnnotation = (outputPin, workflow, sharedSvc) => {
  const translationKey = getOutputPinTranslationKey(workflow.type, outputPin);
  return translationKey ? [{
    content: sharedSvc.translate(translationKey)
  }] : [];
};
const getConnectorAnnotationColor = (workflowType, outputPin) => {
  return OUTPUT_PIN_TRANSLATIONS_COLOR_CUSTOM_BY_WORKFLOW_TYPE[workflowType]?.[outputPin] ?? OUTPUT_PIN_TRANSLATIONS_COLOR[outputPin];
};
const getNodeIdFromWorkflowId = workflowId => {
  return workflowId.startsWith(PREFIX_NODE) ? workflowId : `${PREFIX_NODE}${workflowId}`;
};
const getConnectorId = (workflowId, outputType) => {
  return `${PREFIX_CONNECTOR}${workflowId}_${outputType}`;
};
const getNodeOutputPortId = outputType => {
  return `${PREFIX_PORT}_${outputType}_pin`;
};
const getConnectorFromWorkflowOutputPin = (workflow, outputType, outputPinWorkflowId, sharedSvc) => {
  return {
    ...DEFAULT_CONNECTOR,
    id: getConnectorId(workflow.getId(), outputType),
    sourceID: getNodeIdFromWorkflowId(workflow.getId()),
    sourcePortID: getNodeOutputPortId(outputType),
    targetID: getNodeIdFromWorkflowId(outputPinWorkflowId),
    targetPortID: `${PREFIX_PORT}_${OUTPUT_PIN_PAIR[outputType]}_pin`,
    annotations: getConnectorAnnotation(outputType, workflow, sharedSvc),
    constraints: ConnectorConstraints.Default - ConnectorConstraints.DragSourceEnd
  };
};
const getValidConnectorsFromWorkflowFactory = (workflows, sharedSvc) => workflows.reduce((result, workflow) => {
  const nextWorkflows = workflow.getNextWorkflows();
  const nextWorkflowsConnectors = objectKeys(nextWorkflows).map(outputType => {
    const outputPinWorkflowId = workflow.getNextWorkflows()[outputType];
    return outputPinWorkflowId ? getConnectorFromWorkflowOutputPin(workflow, outputType, outputPinWorkflowId, sharedSvc) : null;
  });
  result.push(...nextWorkflowsConnectors.filter(item => item != null));
  return result;
}, []);
const getDefaultInputPinPort = type => {
  const inputPinOffsetMap = {
    [InputPin.INPUT]: {
      x: 0,
      y: 0.5
    },
    [InputPin.CANCELLATION_INPUT]: {
      x: 0.5,
      y: 0
    },
    [InputPin.DECLINE_INPUT]: {
      x: 0.5,
      y: 0
    }
  };
  return {
    id: `${PREFIX_PORT}_${type}_pin`,
    offset: inputPinOffsetMap[type],
    visibility: PortVisibility.Visible,
    constraints: PortConstraints.InConnect,
    style: {
      fill: '#fff',
      strokeColor: '#ccc',
      strokeWidth: DEFAULT_PORT_STROKE_WIDTH,
      opacity: 0.8
    },
    shape: 'Circle',
    height: DEFAULT_PORT_SIZE,
    width: DEFAULT_PORT_SIZE
  };
};
const getDefaultOutputPinPort = (type, workflowType, sharedSvc) => {
  const outputPinOffsetMap = {
    [OutputPin.OUTPUT]: {
      x: 1,
      y: 0.5
    },
    [OutputPin.EXISTING_CONTACT]: {
      x: 1,
      y: 0.5
    },
    [OutputPin.INVITED_CONTACT]: {
      x: 1,
      y: 0.5
    },
    [OutputPin.NEW_CONTACT]: {
      x: 1,
      y: 0.5
    },
    [OutputPin.CANCELLATION_OUTPUT]: {
      x: 0.5,
      y: 1
    },
    [OutputPin.DECLINE_OUTPUT]: {
      x: 0.5,
      y: 1
    },
    [OutputPin.SPLITTER_OUTPUT1]: {
      x: 1,
      y: 0.1
    },
    [OutputPin.SPLITTER_OUTPUT2]: {
      x: 1,
      y: 0.5
    },
    [OutputPin.APPROVAL_DENY_OUTPUT]: {
      x: 1,
      y: 0.7
    },
    [OutputPin.SUBPARTICIPANT_OUTPUT]: {
      x: 1,
      y: 0.7
    }
  };
  const customOutputPinOffsetMapByType = {
    [WorkflowType.SPLITTER]: {
      [OutputPin.OUTPUT]: {
        x: 1,
        y: 0.9
      }
    },
    [WorkflowType.STAGE_ACTION]: {
      [OutputPin.OUTPUT]: {
        x: 1,
        y: 0.3
      }
    },
    [WorkflowType.MULTI_REGISTRATION]: {
      [OutputPin.OUTPUT]: {
        x: 1,
        y: 0.3
      }
    }
  };
  const translationKey = getOutputPinTranslationKey(workflowType, type);
  return {
    id: `${PREFIX_PORT}_${type}_pin`,
    offset: customOutputPinOffsetMapByType?.[workflowType]?.[type] ?? outputPinOffsetMap[type],
    visibility: PortVisibility.Visible,
    style: {
      fill: '#fff',
      strokeColor: '#aaa',
      strokeWidth: DEFAULT_PORT_STROKE_WIDTH
    },
    shape: 'Circle',
    height: DEFAULT_PORT_SIZE,
    width: DEFAULT_PORT_SIZE,
    tooltip: translationKey ? {
      content: sharedSvc.translate(translationKey),
      relativeMode: 'Object'
    } : undefined,
    constraints: PortConstraints.Draw | PortConstraints.OutConnect | PortConstraints.ToolTip
  };
};
const getDefaultNodeConstraint = () => {
  return NodeConstraints.Default - NodeConstraints.Rotate - NodeConstraints.Resize - NodeConstraints.HideThumbs - NodeConstraints.Delete;
};
const getDefaultNode = sharedSvc => ({
  shape: {
    type: 'HTML'
  },
  ports: [getDefaultInputPinPort(InputPin.INPUT), getDefaultOutputPinPort(OutputPin.OUTPUT, WorkflowType.REGISTRATION, sharedSvc)],
  width: DEFAULT_NODE_WIDTH,
  height: DEFAULT_NODE_HEIGHT,
  annotations: [],
  constraints: getDefaultNodeConstraint()
});
const getDiagramNodeInstance = (diagramEl, nodeId) => {
  return diagramEl.nodes.find(({
    id
  }) => id === nodeId);
};
const getNodeConstraints = canvasLocked => {
  return canvasLocked ? getDefaultNodeConstraint() - NodeConstraints.Drag : getDefaultNodeConstraint();
};
// #endregion
// #region Workflow data utils
const getWorkflowIdFromNodeId = nodeId => {
  return nodeId.replace(PREFIX_NODE, '');
};
const getOutputSidePins = pins => {
  return pins.filter(pin => OUTPUT_PIN_PAIR[pin] === InputPin.INPUT);
};
const getOutputNonSidePins = pins => {
  return pins.filter(pin => OUTPUT_PIN_PAIR[pin] !== InputPin.INPUT);
};
const getMultipleOutputPorts = (pins, workflowType, sharedSvc) => {
  const sidePins = getOutputSidePins(pins);
  const nonSidePins = getOutputNonSidePins(pins);
  return sidePins.map(pin => {
    const port = getDefaultOutputPinPort(pin, workflowType, sharedSvc);
    return port;
  }).concat(nonSidePins.map(pin => getDefaultOutputPinPort(pin, workflowType, sharedSvc)));
};
const getNodePortsFromFactory = (factory, sharedSvc) => {
  return [...factory.inputPin.map(inputPin => getDefaultInputPinPort(inputPin)), ...getMultipleOutputPorts(factory.outputPin, factory.type, sharedSvc)].filter(port => !!port);
};
const getNodeFromCanvasControllerData = (data, sharedSvc) => {
  const {
    coordinate,
    factory
  } = data;
  return {
    ...getDefaultNode(sharedSvc),
    id: getNodeIdFromWorkflowId(factory.getId()),
    offsetX: coordinate.x,
    offsetY: coordinate.y,
    ports: getNodePortsFromFactory(factory, sharedSvc),
    constraints: getNodeConstraints(data.locked)
  };
};
const getNodeAndConnectorsFromCanvasControllerData = (canvasItems, sharedSvc) => ({
  nodes: canvasItems.map(data => getNodeFromCanvasControllerData(data, sharedSvc)),
  connectors: [...getValidConnectorsFromWorkflowFactory(canvasItems.map(({
    factory
  }) => factory), sharedSvc)]
});
const getWorkflowFactory = (type, data) => {
  const factory = getCanvasWorkflow(type);
  try {
    if (data) {
      factory.setWorkflow(data);
      objectKeys(data.custom_processes).forEach(processKey => factory.setCustomProcess(processKey, data.custom_processes[processKey]));
    }
  } catch (e) {
    console.error(e);
  }
  return factory;
};
const copyWorkflowFactory = originalFactory => {
  return getWorkflowFactory(originalFactory.type, originalFactory.getWorkflow());
};
const getWorkflowTypeArray = () => {
  return objectKeys(WorkflowType).reduce((result, data) => {
    const workflowType = WorkflowType[data];
    // eslint-disable-next-line eqeqeq
    if (workflowType != undefined) {
      result.push(workflowType);
    }
    return result;
  }, []);
};
const validateWorkflowProperty = (property, factory, stateCallbackMap, value) => {
  const duplicatedFactory = copyWorkflowFactory(factory);
  if (value !== undefined) {
    duplicatedFactory.setValues({
      [property.attribute]: value
    });
  }
  const isPropertyDisabled = stateCallbackMap[duplicatedFactory.type]?.disabled?.some(item => item.callback(duplicatedFactory) && item.attributeNames.includes(property.attribute));
  if (isPropertyDisabled) {
    return {
      result: true,
      errormsg: ''
    };
  }
  return duplicatedFactory.validateAttribute(property);
};
const workflowTypeArray = getWorkflowTypeArray();
const mockAllWorkflowTypes = workflowTypeArray.map(workflowType => {
  const workflow = getWorkflowFactory(workflowType);
  workflow.getId();
  return workflow;
});
const mockAllWorkflowTypesMap = getMapByValue(mockAllWorkflowTypes, 'id');
const getPossibleNextWorkflowTypes = (sourceWorkflow, outputType) => {
  const workflowIds = sourceWorkflow?.factory.getPossibleWorkflows(outputType, mockAllWorkflowTypes) ?? [];
  return workflowIds.map(id => mockAllWorkflowTypesMap[id]?.type).filter(type => type !== undefined);
};
const getOutputPinFromConnector = connector => {
  const sourcePin = connector.sourcePortID;
  return sourcePin?.replace(`${PREFIX_PORT}_`, ``).replace('_pin', '');
};
const reorderWorkflowsByPaletteCategory = workflows => {
  return {
    mainWorkflows: workflows.filter(workflow => WORKFLOW_TYPE_CATEGORIES[workflow.type][0] !== 'CANCELLATION_WORKFLOWS').sort((workflowA, workflowB) => WORKFLOW_TYPE_ORDER[workflowA.type] - WORKFLOW_TYPE_ORDER[workflowB.type]),
    cancellationWorkflows: workflows.filter(workflow => WORKFLOW_TYPE_CATEGORIES[workflow.type][0] === 'CANCELLATION_WORKFLOWS').sort((workflowA, workflowB) => WORKFLOW_TYPE_ORDER[workflowA.type] - WORKFLOW_TYPE_ORDER[workflowB.type])
  };
};
const getOrderedIEventWorkflows = workflows => {
  const gap = 80;
  const {
    mainWorkflows,
    cancellationWorkflows
  } = reorderWorkflowsByPaletteCategory(workflows);
  const workflowToCanvasItem = (workflow, position) => ({
    canvas: {
      coordinate: {
        x: gap + position.x * (DEFAULT_NODE_WIDTH + gap),
        y: gap + position.y * (DEFAULT_NODE_HEIGHT + gap)
      },
      name: '',
      description: ''
    },
    workflow: {
      custom_processes: [],
      id: workflow.id,
      settings: workflow.settings,
      type: workflow.type
    }
  });
  return [...mainWorkflows.map((workflow, index) => workflowToCanvasItem(workflow, {
    x: index,
    y: 0
  })), ...cancellationWorkflows.map((workflow, index) => workflowToCanvasItem(workflow, {
    x: index,
    y: 1
  }))];
};
/** This function is needed because Backend sometimes return empty coordinate azavista3.0#5063 */
const fixWorkflowBuilderData = value => {
  const {
    noCoordinate,
    withCoordinate
  } = value.workflows.reduce((record, item) => {
    if (item.canvas.coordinate) {
      record.withCoordinate.push(item);
    } else {
      record.noCoordinate.push(item);
    }
    return record;
  }, {
    withCoordinate: [],
    noCoordinate: []
  });
  const fixedCoordinate = getOrderedIEventWorkflows(noCoordinate.map(item => item.workflow));
  const getMapKey = item => item.workflow.id;
  const fixedCoordinateMap = getMapByValueFromFn(fixedCoordinate, getMapKey);
  const fixedWorkflowBuilder = {
    workflows: withCoordinate.concat(noCoordinate.map(item => {
      const fixedCoordinateItem = fixedCoordinateMap[getMapKey(item)];
      if (fixedCoordinateItem) {
        item.canvas.coordinate = fixedCoordinateItem.canvas.coordinate;
      }
      return item;
    })),
    isEmptyCoordinateFixed: noCoordinate?.length > 0
  };
  return fixedWorkflowBuilder;
};
// #endregion
// #region Forms utils
const getFormDirtyValues = form => {
  const dirtyValues = {};
  objectKeys(form.controls).forEach(key => {
    const abstractControl = form.controls[key];
    if (abstractControl.dirty || abstractControl.touched) {
      if (abstractControl instanceof FormGroup) {
        dirtyValues[key] = getFormDirtyValues(abstractControl);
      } else {
        dirtyValues[key] = abstractControl.value;
      }
    }
  });
  return dirtyValues;
};
function createFormGroupFromData(data) {
  if (Array.isArray(data)) {
    const formArray = new FormArray(data.map(row => createFormGroupFromData(row)));
    return formArray;
  }
  if (typeof data === 'object' && !!data) {
    const formGroup = new FormGroup({});
    objectKeys(data).forEach(key => {
      formGroup.addControl(key,
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      createFormGroupFromData(data[key]));
    });
    return formGroup;
  }
  return new FormControl(data);
}
// Palette Utils
const getNodeModelForPaletteFromWorkflowType = (workflowType, sharedSvc) => {
  const factory = getCanvasWorkflow(workflowType);
  const outputPins = factory.outputPin;
  const sideOutputPins = getOutputSidePins(outputPins);
  const svgIcon = WORKFLOW_TYPE_PALETTE_SVG[workflowType];
  const getWorkflowPinIcon = () => `<i class="material-icons-outlined palette-item__icon">dataset</i>
          ${factory.inputPin.map(inputPin =>
  // eslint-disable-next-line prettier/prettier
  `<div class="palette-item__${inputPin}"></div>`)}${getOutputNonSidePins(outputPins).map(outputPin =>
  // eslint-disable-next-line prettier/prettier
  `<div class="palette-item__${outputPin}"></div>`)}${sideOutputPins.map((outputPin, index) => {
    const top = (index + 1) * 100 / (sideOutputPins.length + 1);
    return `<div class="palette-item__${outputPin} palette-item__output" style="top: ${Math.round(top)}%;"></div>`;
  })}`;
  return {
    ...getDefaultNode(sharedSvc),
    addInfo: {
      type: workflowType,
      label: workflowType
    },
    ports: getNodePortsFromFactory(factory, sharedSvc) ?? [],
    id: workflowType,
    constraints: NodeConstraints.Default & ~NodeConstraints.Tooltip,
    padding: {
      left: 0,
      right: 0,
      bottom: 0,
      top: 0
    },
    margin: {
      left: 0,
      right: 0,
      bottom: 0,
      top: 0
    },
    shape: {
      type: 'HTML',
      content: `<div class="palette-item">
            <div class="palette-item__inner">
              ${svgIcon ? `<svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">${svgIcon}</svg>` : getWorkflowPinIcon()}
            </div>
            <div class="palette-item__title">${` ${sharedSvc.translate(WORKFLOW_NAME_TRANSLATIONS[workflowType])}`}</div>
          </div>`
    }
  };
};
// eslint-disable-next-line max-len
const nodeModelForPaletteCreateWorkBlock = sharedSvc => ({
  ...getDefaultNode(sharedSvc),
  addInfo: {
    type: 'create-work-block',
    label: 'CREATE_WORKBLOCK'
  },
  ports: [],
  id: 'create-work-block',
  constraints: NodeConstraints.None,
  shape: {
    type: 'HTML',
    content: `<div class="palette-item">
            <div class="palette-item__inner">
              <svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.502 5C15.502 3.58579 15.502 2.87868 16.0144 2.43934C16.5267 2 17.3515 2 19.0008 2C20.6502 2 21.475 2 21.9873 2.43934C22.4997 2.87868 22.4997 3.58579 22.4997 5C22.4997 6.41421 22.4997 7.12132 21.9873 7.56066C21.475 8 20.6502 8 19.0008 8C17.3515 8 16.5267 8 16.0144 7.56066C15.502 7.12132 15.502 6.41421 15.502 5Z" stroke="black" stroke-width="1.5"/>
                <path d="M15.502 19C15.502 17.5858 15.502 16.8787 16.0144 16.4393C16.5267 16 17.3515 16 19.0008 16C20.6502 16 21.475 16 21.9873 16.4393C22.4997 16.8787 22.4997 17.5858 22.4997 19C22.4997 20.4142 22.4997 21.1213 21.9873 21.5607C21.475 22 20.6502 22 19.0008 22C17.3515 22 16.5267 22 16.0144 21.5607C15.502 21.1213 15.502 20.4142 15.502 19Z" stroke="black" stroke-width="1.5"/>
                <path d="M7.5224 10V14.0001M9.51297 12.0001H5.48828" stroke="#008FFB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7.52803 17.0364C10.3049 17.0364 12.5561 14.7846 12.5561 12.0068C12.5561 9.22901 10.3049 6.97717 7.52803 6.97717M7.52803 17.0364C4.75113 17.0364 2.5 14.7846 2.5 12.0068C2.5 9.22901 4.75113 6.97717 7.52803 6.97717M7.52803 17.0364C7.45809 19.1663 9.06235 19.9524 10.1753 19.9932H12.5021M7.52803 6.97717C7.45737 4.8171 9.04755 4.05751 10.1753 4.00977H12.5021" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>


            </div>
            <div class="palette-item__title">${` ${sharedSvc.translate('CREATE_WORKBLOCK')}`}</div>
          </div>`
  }
});
const getNodeModelForPalette = (paletteSymbol, sharedSvc) => {
  if (paletteSymbol === 'create-work-block') {
    return nodeModelForPaletteCreateWorkBlock(sharedSvc);
  }
  return getNodeModelForPaletteFromWorkflowType(paletteSymbol, sharedSvc);
};
// local storage tools
const jsonParse = jsonText => {
  let myResponse;
  if (jsonText == null) {
    return undefined;
  }
  try {
    myResponse = JSON.parse(jsonText);
  } catch (e) {
    myResponse = undefined;
    throw new Error('Error occured: ', e);
  }
  return myResponse;
};
const getBuilderWorkflowLocalStorageKey = eventId => `azavista-workflow-builder-${eventId}`;
const getBuilderWorkflowFromLocalStorage = eventId => {
  const content = localStorage.getItem(getBuilderWorkflowLocalStorageKey(eventId));
  return jsonParse(content);
};
const saveBuilderWorkflowToLocalStorage = (eventId, data) => {
  localStorage.setItem(getBuilderWorkflowLocalStorageKey(eventId), JSON.stringify(data));
};
const PROPERTY_ATTRIBUTE_TO_OUTPUT_PINS_DEPENDENTS = {
  [WorkflowType.SPLITTER]: {
    condition1: [OutputPin.SPLITTER_OUTPUT1],
    condition2: [OutputPin.SPLITTER_OUTPUT2]
  }
};
const getConditionFromSplitterOutput = (outputType, workflowType) => {
  const workflowPropertiesDependents = PROPERTY_ATTRIBUTE_TO_OUTPUT_PINS_DEPENDENTS[workflowType];
  return workflowPropertiesDependents && objectKeys(workflowPropertiesDependents).find(propertyName => workflowPropertiesDependents[propertyName]?.includes(outputType));
};
const getSplitterOutputFromCondition = (workflowType, propertyName) => {
  const workflowPropertiesDependents = PROPERTY_ATTRIBUTE_TO_OUTPUT_PINS_DEPENDENTS[workflowType];
  return workflowPropertiesDependents?.[propertyName];
};
const WORKFLOW_WARNING_NO_POSSIBLE_NEXT_WORKFLOW = {
  [WorkflowType.CANCELLATION]: true,
  [WorkflowType.DECLINE]: true
};
const getCrmStatusArray = () => {
  return objectKeys(CrmStatus).reduce((result, data) => {
    const crmStatus = CrmStatus[data];
    // eslint-disable-next-line eqeqeq
    if (crmStatus != undefined) {
      result.push(crmStatus);
    }
    return result;
  }, []);
};
const crmStatusArray = getCrmStatusArray();
let AzavistaWorkflowBuilderController = /*#__PURE__*/(() => {
  class AzavistaWorkflowBuilderController {
    constructor() {
      this.dataMap = {};
      this.validityMap = {};
      this.initStatus$ = new BehaviorSubject(undefined);
    }
    async initFromProvider(dataProvider, eventId, stateCallbackMap) {
      this.initStatus$.next('processing');
      this.eventId = eventId;
      this.dataProvider = dataProvider;
      this.stateCallbackMap = stateCallbackMap;
      this.dataMap = {};
      this.validityMap = {};
      this.init({
        workflows: await this.dataProvider.getAllWorkflowsForInit(eventId)
      });
      this.initStatus$.next('completed');
    }
    init(workflowData) {
      workflowData?.workflows.forEach(({
        workflow,
        canvas
      }) => {
        this.addWorkflowToLocal(workflow.type, canvas, workflow);
      });
    }
    addWorkflow(type, canvas, data) {
      const createdData = this.addWorkflowToLocal(type, canvas, data);
      this.save();
      return createdData;
    }
    addWorkflowToLocal(type, canvas, data) {
      const factory = getWorkflowFactory(type, data);
      const createdData = {
        factory,
        ...canvas
      };
      this.dataMap[factory.getId()] = createdData;
      this.updateValidityMap(factory);
      return createdData;
    }
    updateWorkflowSettings(workflowId, data) {
      const {
        factory
      } = this.dataMap[workflowId];
      factory?.setValues(data);
      this.updateValidityMap(factory);
      this.save();
    }
    updateWorkflowCoordinate(workflowId, coordinate) {
      if (this.dataMap[workflowId]?.coordinate) {
        this.dataMap[workflowId].coordinate = coordinate;
        this.save();
      }
    }
    updateWorkflowNextWorkflow(outputType, sourceWorkflowId, targetWorkflowId) {
      if (!sourceWorkflowId) {
        return;
      }
      const {
        factory
      } = this.dataMap[sourceWorkflowId];
      factory?.setNextWorkflow(outputType, targetWorkflowId);
      this.updateValidityMap(factory);
      this.save();
    }
    updateWorkflowCanvas(workflowId, data) {
      if (this.dataMap[workflowId]) {
        this.dataMap[workflowId] = {
          ...this.dataMap[workflowId],
          ...data
        };
        this.save();
      }
    }
    updateWorkflowProcess(workflowId, attribute, steps) {
      const {
        factory
      } = this.dataMap[workflowId];
      factory?.setCustomProcess(attribute, steps);
      this.updateValidityMap(factory);
      this.save();
    }
    isValidNextWorkflow(outputType, sourceWorkflowId, targetWorkflowId, isNewConnection = false) {
      const isTargetingSelf = sourceWorkflowId === targetWorkflowId;
      const sourceWorkflow = sourceWorkflowId ? this.dataMap[sourceWorkflowId] : null;
      const possibleWorkflows = this.getPossibleNextWorkflowIds(sourceWorkflow, outputType);
      const noOutputPin = possibleWorkflows.length === 0;
      const inValidTargetPin = targetWorkflowId && !possibleWorkflows.includes(targetWorkflowId);
      const isAddingMultipleConnection = !!(isNewConnection && sourceWorkflow?.factory.getNextWorkflows()[outputType]);
      const isAddingEmptySourceConnection = isNewConnection && !sourceWorkflowId;
      if (noOutputPin || inValidTargetPin || isTargetingSelf || isAddingMultipleConnection || isAddingEmptySourceConnection) {
        this.log('isValidNextWorkflow', {
          isTargetingSelf,
          sourceWorkflow,
          possibleWorkflows,
          noOutputPin,
          inValidTargetPin,
          isAddingMultipleConnection,
          isAddingEmptySourceConnection
        });
        return false;
      }
      return true;
    }
    getPossibleNextWorkflowIds(sourceWorkflow, outputType) {
      return sourceWorkflow?.factory.getPossibleWorkflows(outputType, Object.values(this.dataMap).map(({
        factory
      }) => factory)) ?? [];
    }
    deleteWorkflow(workflowId) {
      if (!this.dataMap[workflowId]) {
        return;
      }
      delete this.dataMap[workflowId];
      delete this.validityMap[workflowId];
      this.validityMap = {
        ...this.validityMap
      };
      this.save();
    }
    getCurrentState() {
      const workflows = Object.entries(this.dataMap).reduce((result, [, {
        factory,
        coordinate,
        description,
        name,
        locked
      }]) => {
        return result.concat([{
          canvas: {
            coordinate,
            description,
            name,
            locked
          },
          workflow: factory.getWorkflow()
        }]);
      }, []);
      return {
        workflows
      };
    }
    async save() {
      this.log('save', {
        eventId: this.eventId,
        getCurrentState: this.getCurrentState()
      });
      if (this.eventId) {
        this.dataProvider?.saveBuilderData(this.eventId, this.getCurrentState());
      }
    }
    async publish() {
      if (this.eventId) {
        this.dataProvider?.publishBuilderData(this.eventId, this.getCurrentState());
      }
    }
    async getInitializedWorkflowsMap() {
      return firstValueFrom(this.initStatus$.pipe(filter(status => status === 'completed'), map(() => this.dataMap)));
    }
    log(logName, ...params) {
      if (this.isDebugCallback?.()) {
        // eslint-disable-next-line no-console
        console.groupCollapsed(logName);
        // eslint-disable-next-line no-console
        console.trace(params);
        // eslint-disable-next-line no-console
        console.groupEnd();
      }
    }
    updateValidityMap(factory) {
      const properties = factory.getProperties();
      this.validityMap = {
        ...this.validityMap,
        [factory.getId()]: properties.every(property => validateWorkflowProperty(property, factory, this.stateCallbackMap ?? {}).result)
      };
    }
    static {
      this.ɵfac = function AzavistaWorkflowBuilderController_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaWorkflowBuilderController)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AzavistaWorkflowBuilderController,
        factory: AzavistaWorkflowBuilderController.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AzavistaWorkflowBuilderController;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let WorkflowBuilderProviderAbstract = /*#__PURE__*/(() => {
  class WorkflowBuilderProviderAbstract {
    constructor(workflowController) {
      this.workflowController = workflowController;
    }
    async getBuilderData(eventId) {
      const unformattedWorkflows = await this.getAllWorkflowsForInit(eventId);
      return {
        draftConnectors: [],
        workflows: unformattedWorkflows
      };
    }
    async getAllWorkflowsForDataSource(skippedWorkflowIds) {
      const dataMap = await this.workflowController.getInitializedWorkflowsMap();
      return Object.values(dataMap).filter(data => !skippedWorkflowIds.includes(data.factory.getId())).map(data => data.factory);
    }
    static {
      this.ɵfac = function WorkflowBuilderProviderAbstract_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WorkflowBuilderProviderAbstract)(i0.ɵɵinject(AzavistaWorkflowBuilderController));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: WorkflowBuilderProviderAbstract,
        factory: WorkflowBuilderProviderAbstract.ɵfac
      });
    }
  }
  return WorkflowBuilderProviderAbstract;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable no-use-before-define */
const PREFIX_NODE = 'node_';
const PREFIX_PORT = 'port_';
const PREFIX_CONNECTOR = 'connector_';
const DEFAULT_NODE_WIDTH = 250;
const DEFAULT_NODE_HEIGHT = 40;
const DEFAULT_STROKE_WIDTH = 2;
const DEFAULT_STROKE_COLOR = '#aaa';
const DEFAULT_PORT_SIZE = 16;
const DEFAULT_PORT_STROKE_WIDTH = 2;
const DEFAULT_SELECTED_STROKE_COLOR = 'blue';
const DEFAULT_ERROR_STROKE_COLOR = '#f00';
const ASYNC_VALIDATOR_DELAY = 500;
const DEFAULT_CONNECTOR = {
  cornerRadius: 8,
  allowNodeOverlap: false,
  type: 'Orthogonal',
  segments: [{
    type: 'Orthogonal'
  }],
  style: {
    strokeColor: DEFAULT_STROKE_COLOR,
    strokeWidth: DEFAULT_STROKE_WIDTH,
    fill: DEFAULT_STROKE_COLOR
  },
  targetDecorator: {
    style: {
      fill: DEFAULT_STROKE_COLOR,
      strokeColor: DEFAULT_STROKE_COLOR,
      strokeWidth: DEFAULT_STROKE_WIDTH
    },
    pivot: {
      x: -0.3
    }
  },
  sourcePortID: 'port__output_pin',
  targetPortID: 'port__input_pin',
  constraints: ConnectorConstraints.Default & ~ConnectorConstraints.Tooltip
  // margin: {
  //     right: DEFAULT_PIN_SIZE * 2,
  //     bottom: DEFAULT_PIN_SIZE * 2,
  //     left: DEFAULT_PIN_SIZE * 2,
  //     top: DEFAULT_PIN_SIZE * 2,
  // },
};
/**
 * Configure the workflow's output pin to its input pin. This const is used to find the correct PIN-PAIR whenever it draws a workflow connection based on workflow-data.
 * Meanwhile, to validate whenever user start dragging a connection, it uses `src\workflow\CanvasWorkflow.ts -- getPossibleWorkflows()`
 *
 * @OutputPin.OUTPUT is the common workflow's output pin
 */
const OUTPUT_PIN_PAIR = {
  [OutputPin.OUTPUT]: InputPin.INPUT,
  [OutputPin.CANCELLATION_OUTPUT]: InputPin.CANCELLATION_INPUT,
  [OutputPin.DECLINE_OUTPUT]: InputPin.DECLINE_INPUT,
  [OutputPin.EXISTING_CONTACT]: InputPin.INPUT,
  [OutputPin.INVITED_CONTACT]: InputPin.INPUT,
  [OutputPin.NEW_CONTACT]: InputPin.INPUT,
  [OutputPin.SPLITTER_OUTPUT1]: InputPin.INPUT,
  [OutputPin.SPLITTER_OUTPUT2]: InputPin.INPUT,
  [OutputPin.APPROVAL_DENY_OUTPUT]: InputPin.INPUT,
  [OutputPin.SUBPARTICIPANT_OUTPUT]: InputPin.INPUT
};
const OUTPUT_PIN_TRANSLATIONS = {
  [OutputPin.OUTPUT]: null,
  [OutputPin.CANCELLATION_OUTPUT]: 'CANCELLATION',
  [OutputPin.DECLINE_OUTPUT]: 'DECLINE',
  [OutputPin.EXISTING_CONTACT]: 'EXISTING_CONTACT',
  [OutputPin.INVITED_CONTACT]: 'INVITED_CONTACT',
  [OutputPin.NEW_CONTACT]: 'NEW_CONTACT',
  [OutputPin.SPLITTER_OUTPUT1]: 'SPLITTER_OUTPUT1',
  [OutputPin.SPLITTER_OUTPUT2]: 'SPLITTER_OUTPUT2',
  [OutputPin.APPROVAL_DENY_OUTPUT]: 'DENIED',
  [OutputPin.SUBPARTICIPANT_OUTPUT]: 'SUB_PARTICIPANT'
};
const OUTPUT_PIN_TRANSLATIONS_COLOR = {
  'cancellation-output': 'warn',
  'decline-output': 'warn',
  'approval-deny-output': 'warn',
  'existing-contact': 'primary',
  'invited-contact': 'primary',
  'new-contact': 'primary',
  'splitter-output1': 'primary',
  'splitter-output2': 'primary',
  'subparticipant-output': 'primary'
};
const OUTPUT_PIN_TRANSLATIONS_CUSTOM_BY_WORKFLOW_TYPE = {
  [WorkflowType.SPLITTER]: {
    [OutputPin.OUTPUT]: 'OTHER'
  },
  [WorkflowType.STAGE_ACTION]: {
    [OutputPin.OUTPUT]: 'APPROVED'
  },
  [WorkflowType.MULTI_REGISTRATION]: {
    [OutputPin.OUTPUT]: 'MAIN_PARTICIPANT'
  }
};
const OUTPUT_PIN_TRANSLATIONS_COLOR_CUSTOM_BY_WORKFLOW_TYPE = {
  'splitter-workflow': {
    output: 'primary'
  },
  'stage-action-workflow': {
    output: 'success'
  },
  'multi-registration-workflow': {
    output: 'primary'
  }
};
const WORKFLOW_NAME_TRANSLATIONS = {
  [WorkflowType.ARRIVAL]: 'ARRIVAL_WORKFLOW_NAME',
  [WorkflowType.CANCELLATION]: 'CANCELLATION_WORKFLOW_NAME',
  [WorkflowType.EVENT_CANCELLATION]: 'EVENT_CANCELLATION_WORKFLOW_NAME',
  [WorkflowType.INVITATION]: 'INVITATION_WORKFLOW_NAME',
  [WorkflowType.MULTI_REGISTRATION]: 'MULTI_REGISTRATION_WORKFLOW_NAME',
  [WorkflowType.PAYMENT]: 'PAYMENT_WORKFLOW_NAME',
  [WorkflowType.PAYMENT_WAITINGLIST]: 'PAYMENT_WAITINGLIST_WORKFLOW_NAME',
  [WorkflowType.PRE_ARRIVAL]: 'PRE_ARRIVAL_WORKFLOW_NAME',
  [WorkflowType.PROFILE]: 'PROFILE_WORKFLOW_NAME',
  [WorkflowType.PUBLIC_REGISTRATION]: 'PUBLIC_REGISTRATION_WORKFLOW_NAME',
  [WorkflowType.REGISTRATION]: 'REGISTRATION_WORKFLOW_NAME',
  [WorkflowType.REGISTRAION_WAITINGLIST]: 'REGISTRATION_WAITINGLIST_WORKFLOW_NAME',
  [WorkflowType.CATEGORY_WAITINGLIST]: 'REGISTRATION_WAITINGLIST_CAPACITY_BY_CATEGORY_WORKFLOW_NAME',
  [WorkflowType.STAGE_ACTION]: 'STAGE_ACTION_WORKFLOW_NAME',
  [WorkflowType.DECLINE]: 'DECLINE_WORKFLOW_NAME',
  [WorkflowType.SPLITTER]: 'SPLITTER_WORKFLOW_NAME',
  [WorkflowType.SURVEY]: 'SURVEY_WORKFLOW_NAME',
  'create-work-block': 'CREATE_WORKBLOCK_NAME'
};
const WORKFLOW_EXPLANATION_TRANSLATIONS = {
  [WorkflowType.ARRIVAL]: 'ARRIVAL_WORKFLOW_EXPLANATION',
  [WorkflowType.CANCELLATION]: 'CANCELLATION_WORKFLOW_EXPLANATION',
  [WorkflowType.EVENT_CANCELLATION]: 'EVENT_CANCELLATION_WORKFLOW_EXPLANATION',
  [WorkflowType.INVITATION]: 'INVITATION_WORKFLOW_EXPLANATION',
  [WorkflowType.MULTI_REGISTRATION]: 'MULTI_REGISTRATION_WORKFLOW_EXPLANATION',
  [WorkflowType.PAYMENT]: 'PAYMENT_WORKFLOW_EXPLANATION',
  [WorkflowType.PAYMENT_WAITINGLIST]: 'PAYMENT_WAITING_LIST_WORKFLOW_EXPLANATION',
  [WorkflowType.PRE_ARRIVAL]: 'PRE_ARRIVAL_WORKFLOW_EXPLANATION',
  [WorkflowType.PROFILE]: 'PROFILE_WORKFLOW_EXPLANATION',
  [WorkflowType.PUBLIC_REGISTRATION]: 'PUBLIC_REGISTRATION_WORKFLOW_EXPLANATION',
  [WorkflowType.REGISTRATION]: 'REGISTRATION_WORKFLOW_EXPLANATION',
  [WorkflowType.REGISTRAION_WAITINGLIST]: 'REGISTRATION_WAITING_LIST_WORKFLOW_EXPLANATION',
  [WorkflowType.CATEGORY_WAITINGLIST]: 'REGISTRATION_WAITING_LIST_CAPACITY_BY_CATEGORY_WORKFLOW_EXPLANATION',
  [WorkflowType.STAGE_ACTION]: 'STAGE_ACTION_WORKFLOW_EXPLANATION',
  [WorkflowType.DECLINE]: 'DECLINE_WORKFLOW_EXPLANATION',
  [WorkflowType.SPLITTER]: 'SPLITTER_WORKFLOW_EXPLANATION',
  [WorkflowType.SURVEY]: 'SURVEY_WORKFLOW_EXPLANATION'
};
// TODO: Remove this when we have API endpoint with constants
const ISO_LANGUAGES = [{
  id: 'en-US',
  label: 'English (United States)'
}, {
  id: 'en-GB',
  label: 'English (Great Britain)'
}, {
  id: 'de-DE',
  label: 'German'
}, {
  id: 'nl-NL',
  label: 'Dutch'
}, {
  id: 'fr-FR',
  label: 'French'
}, {
  id: 'es-ES',
  label: 'Spanish'
}, {
  id: 'ca-ES',
  label: 'Catalan (Spain)'
}, {
  id: 'da-DK',
  label: 'Danish'
}, {
  id: 'it-IT',
  label: 'Italian'
}, {
  id: 'pt-PT',
  label: 'Portuguese'
}, {
  id: 'pt-BR',
  label: 'Portuguese (Brazilizan)'
}, {
  id: 'sv-SE',
  label: 'Swedish'
}, {
  id: 'cs-CZ',
  label: 'Czech'
}, {
  id: 'el-GR',
  label: 'Greek'
}, {
  id: 'he-IL',
  label: 'Hebrew'
}, {
  id: 'hr-HR',
  label: 'Croatian'
}, {
  id: 'hu-HU',
  label: 'Hungarian'
}, {
  id: 'ja-JP',
  label: 'Japanese'
}, {
  id: 'ko-KR',
  label: 'Korean'
}, {
  id: 'nn-NO',
  label: 'Norwegian'
}, {
  id: 'pl-PL',
  label: 'Polish'
}, {
  id: 'ro-RO',
  label: 'Romanian'
}, {
  id: 'ru-RU',
  label: 'Russian'
}, {
  id: 'fi-FI',
  label: 'Finnish'
}, {
  id: 'zh-CN',
  label: 'Chinese (Simplified)'
}, {
  id: 'vi-VN',
  label: 'Vietnamese'
}, {
  id: 'sk-SK',
  label: 'Slovak'
}, {
  id: 'bg-BG',
  label: 'Bulgarian'
}, {
  id: 'tr-TR',
  label: 'Turkish'
}, {
  id: 'ur-PK',
  label: 'Urdu'
}, {
  id: 'hi-IN',
  label: 'Hindi'
}, {
  id: 'th-TH',
  label: 'Thai'
}, {
  id: 'ms-MY',
  label: 'Malay'
}, {
  id: 'id-ID',
  label: 'Indonesian'
}, {
  id: 'fil-PH',
  label: 'Filipino'
}, {
  id: 'sr-Latn',
  label: 'Serbian'
}, {
  id: 'ar-AE',
  label: 'Arabic'
}];
const PALETTE_CATEGORIES_ORDER = ['INVITATION_WORKFLOWS', 'REGISTRATION_WORKFLOWS', 'WAITING_LIST_WORKFLOWS', 'CANCELLATION_WORKFLOWS', 'PAYMENT_WORKFLOWS', 'OTHER_WORKFLOWS'];
const PALETTE_CATEGORIES_INDEX = {
  INVITATION_WORKFLOWS: 1,
  REGISTRATION_WORKFLOWS: 2,
  PAYMENT_WORKFLOWS: 3,
  WAITING_LIST_WORKFLOWS: 4,
  OTHER_WORKFLOWS: 5,
  CANCELLATION_WORKFLOWS: 0
};
const WORKFLOW_TYPE_CATEGORIES = {
  'create-work-block': ['OTHER_WORKFLOWS'],
  [WorkflowType.ARRIVAL]: ['REGISTRATION_WORKFLOWS'],
  [WorkflowType.CANCELLATION]: ['CANCELLATION_WORKFLOWS'],
  [WorkflowType.DECLINE]: ['CANCELLATION_WORKFLOWS'],
  [WorkflowType.EVENT_CANCELLATION]: ['CANCELLATION_WORKFLOWS'],
  [WorkflowType.INVITATION]: ['INVITATION_WORKFLOWS'],
  [WorkflowType.MULTI_REGISTRATION]: ['REGISTRATION_WORKFLOWS'],
  [WorkflowType.PAYMENT]: ['PAYMENT_WORKFLOWS'],
  [WorkflowType.PAYMENT_WAITINGLIST]: ['PAYMENT_WORKFLOWS', 'WAITING_LIST_WORKFLOWS'],
  [WorkflowType.PRE_ARRIVAL]: ['REGISTRATION_WORKFLOWS'],
  [WorkflowType.PROFILE]: ['OTHER_WORKFLOWS'],
  [WorkflowType.PUBLIC_REGISTRATION]: ['REGISTRATION_WORKFLOWS'],
  [WorkflowType.REGISTRAION_WAITINGLIST]: ['WAITING_LIST_WORKFLOWS'],
  [WorkflowType.CATEGORY_WAITINGLIST]: ['WAITING_LIST_WORKFLOWS'],
  [WorkflowType.REGISTRATION]: ['REGISTRATION_WORKFLOWS'],
  [WorkflowType.STAGE_ACTION]: ['OTHER_WORKFLOWS'],
  [WorkflowType.SPLITTER]: ['OTHER_WORKFLOWS'],
  [WorkflowType.SURVEY]: ['OTHER_WORKFLOWS']
};
const WORKFLOW_TYPE_ORDER = {
  [WorkflowType.DECLINE]: 0,
  [WorkflowType.CANCELLATION]: 1,
  [WorkflowType.EVENT_CANCELLATION]: 2,
  [WorkflowType.INVITATION]: 3,
  [WorkflowType.PUBLIC_REGISTRATION]: 4,
  [WorkflowType.REGISTRAION_WAITINGLIST]: 5,
  [WorkflowType.CATEGORY_WAITINGLIST]: 6,
  [WorkflowType.REGISTRATION]: 7,
  [WorkflowType.MULTI_REGISTRATION]: 8,
  [WorkflowType.PAYMENT]: 9,
  [WorkflowType.PAYMENT_WAITINGLIST]: 10,
  [WorkflowType.PRE_ARRIVAL]: 12,
  [WorkflowType.ARRIVAL]: 13,
  [WorkflowType.PROFILE]: 14,
  [WorkflowType.STAGE_ACTION]: 15,
  [WorkflowType.SPLITTER]: 16,
  [WorkflowType.SURVEY]: 16
};
const WORKFLOW_TYPE_PALETTE_SVG = {
  [WorkflowType.INVITATION]: `<path d="M16.5 2V4M11.5 2V4M6.5 2V4" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M20 10C20 6.70017 20 5.05025 18.9749 4.02513C17.9497 3 16.2998 3 13 3H10C6.70017 3 5.05025 3 4.02513 4.02513C3 5.05025 3 6.70017 3 10V15C3 18.2998 3 19.9497 4.02513 20.9749C5.05025 22 6.70017 22 10 22H13" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M18 14V22M22 18H14" stroke="#008FFB" stroke-width="1.5" stroke-linecap="round"/>
<path d="M7.5 15H11.5" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
<path d="M7.5 10H15.5" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
`,
  [WorkflowType.ARRIVAL]: `<path d="M2 22H22" stroke="#008FFB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2 10H22" stroke="#008FFB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8.00232 4.5C8.00232 5.34389 7.91895 6.31789 8.75232 6.79904C9.10039 7 9.5677 7 10.5023 7H13.5023C14.4369 7 14.9042 7 15.2523 6.79904C16.0857 6.31789 16.0023 5.34389 16.0023 4.5C16.0023 3.65611 16.0857 2.68211 15.2523 2.20096C14.9042 2 14.4369 2 13.5023 2H10.5023C9.5677 2 9.10039 2 8.75232 2.20096C7.91895 2.68211 8.00232 3.65611 8.00232 4.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.00232 16.5C5.00232 17.3439 4.91895 18.3179 5.75232 18.799C6.10039 19 6.5677 19 7.50232 19H16.5023C17.4369 19 17.9042 19 18.2523 18.799C19.0857 18.3179 19.0023 17.3439 19.0023 16.5C19.0023 15.6561 19.0857 14.6821 18.2523 14.201C17.9042 14 17.4369 14 16.5023 14H7.50232C6.5677 14 6.10039 14 5.75232 14.201C4.91895 14.6821 5.00232 15.6561 5.00232 16.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
`,
  [WorkflowType.MULTI_REGISTRATION]: `<path d="M12 13L17 17.5M12 13L7 17.5M12 13V8" stroke="#008FFB" stroke-width="1.5"/>
<path d="M18.1915 16.4456C18.7081 16.1485 18.9664 16 19.25 16C19.5336 16 19.7919 16.1485 20.3085 16.4456L20.9415 16.8097C21.4581 17.1068 21.7164 17.2553 21.8582 17.5C22 17.7447 22 18.0418 22 18.6359V19.3641C22 19.9582 22 20.2553 21.8582 20.5C21.7164 20.7447 21.4581 20.8932 20.9415 21.1903L20.3085 21.5544C19.7919 21.8515 19.5336 22 19.25 22C18.9664 22 18.7081 21.8515 18.1915 21.5544L17.5585 21.1903C17.0419 20.8932 16.7836 20.7447 16.6418 20.5C16.5 20.2553 16.5 19.9582 16.5 19.3641V18.6359C16.5 18.0418 16.5 17.7447 16.6418 17.5C16.7836 17.2553 17.0419 17.1068 17.5585 16.8097L18.1915 16.4456Z" stroke="black" stroke-width="1.5"/>
<path d="M3.69152 16.4456C4.2081 16.1485 4.46638 16 4.75 16C5.03362 16 5.2919 16.1485 5.80848 16.4456L6.44152 16.8097C6.9581 17.1068 7.21638 17.2553 7.35819 17.5C7.5 17.7447 7.5 18.0418 7.5 18.6359V19.3641C7.5 19.9582 7.5 20.2553 7.35819 20.5C7.21638 20.7447 6.9581 20.8932 6.44152 21.1903L5.80848 21.5544C5.2919 21.8515 5.03362 22 4.75 22C4.46638 22 4.2081 21.8515 3.69152 21.5544L3.05848 21.1903C2.5419 20.8932 2.28362 20.7447 2.14181 20.5C2 20.2553 2 19.9582 2 19.3641V18.6359C2 18.0418 2 17.7447 2.14181 17.5C2.28362 17.2553 2.5419 17.1068 3.05848 16.8097L3.69152 16.4456Z" stroke="black" stroke-width="1.5"/>
<path d="M10.9415 2.44563C11.4581 2.14854 11.7164 2 12 2C12.2836 2 12.5419 2.14854 13.0585 2.44563L13.6915 2.8097C14.2081 3.10679 14.4664 3.25533 14.6082 3.5C14.75 3.74467 14.75 4.04175 14.75 4.63593V5.36407C14.75 5.95825 14.75 6.25533 14.6082 6.5C14.4664 6.74467 14.2081 6.89321 13.6915 7.1903L13.0585 7.55437C12.5419 7.85146 12.2836 8 12 8C11.7164 8 11.4581 7.85146 10.9415 7.55437L10.3085 7.1903C9.7919 6.89321 9.53362 6.74467 9.39181 6.5C9.25 6.25533 9.25 5.95825 9.25 5.36407V4.63593C9.25 4.04175 9.25 3.74467 9.39181 3.5C9.53362 3.25533 9.7919 3.10679 10.3085 2.8097L10.9415 2.44563Z" stroke="black" stroke-width="1.5"/>`,
  [WorkflowType.PRE_ARRIVAL]: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.25 10.5C8.59721 10.5 10.5 8.59721 10.5 6.25C10.5 3.90279 8.59721 2 6.25 2C3.90279 2 2 3.90279 2 6.25C2 8.59721 3.90279 10.5 6.25 10.5Z" stroke="black" stroke-width="1.5"/>
<path d="M18 9.35714V10.5M18 9.35714C16.9878 9.35714 16.0961 8.85207 15.573 8.08517M18 9.35714C19.0122 9.35714 19.9039 8.85207 20.427 8.08517M15.573 8.08517L14.5004 8.78571M15.573 8.08517C15.2637 7.63159 15.0833 7.08643 15.0833 6.5C15.0833 5.91364 15.2636 5.36854 15.5729 4.915M20.427 8.08517L21.4996 8.78571M20.427 8.08517C20.7363 7.63159 20.9167 7.08643 20.9167 6.5C20.9167 5.91364 20.7364 5.36854 20.4271 4.915M18 3.64286C19.0123 3.64286 19.9041 4.148 20.4271 4.915M18 3.64286C16.9877 3.64286 16.0959 4.148 15.5729 4.915M18 3.64286V2.5M20.4271 4.915L21.5 4.21429M15.5729 4.915L14.5 4.21429" stroke="#008FFB" stroke-width="1.5" stroke-linecap="round"/>
<path d="M17.75 22C20.0972 22 22 20.0972 22 17.75C22 15.4028 20.0972 13.5 17.75 13.5C15.4028 13.5 13.5 15.4028 13.5 17.75C13.5 20.0972 15.4028 22 17.75 22Z" stroke="black" stroke-width="1.5"/>
<path d="M6.25 22C8.59721 22 10.5 20.0972 10.5 17.75C10.5 15.4028 8.59721 13.5 6.25 13.5C3.90279 13.5 2 15.4028 2 17.75C2 20.0972 3.90279 22 6.25 22Z" stroke="black" stroke-width="1.5"/>
`,
  [WorkflowType.PUBLIC_REGISTRATION]: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20 5.69899C19.0653 5.76636 17.8681 6.12824 17.0379 7.20277C15.5385 9.14361 14.039 9.30556 13.0394 8.65861C11.5399 7.6882 12.8 6.11636 11.0401 5.26215C9.89313 4.70542 9.73321 3.19045 10.3716 2" stroke="#008FFB" stroke-width="1.5" stroke-linejoin="round"/>
<path d="M2 11C2.7625 11.6621 3.83046 12.2682 5.08874 12.2682C7.68843 12.2682 8.20837 12.7649 8.20837 14.7518C8.20837 16.7387 8.20837 16.7387 8.72831 18.2288C9.06651 19.1981 9.18472 20.1674 8.5106 21" stroke="#008FFB" stroke-width="1.5" stroke-linejoin="round"/>
<path d="M22 13.4523C21.1129 12.9411 20 12.7308 18.8734 13.5405C16.7177 15.0898 15.2314 13.806 14.5619 15.0889C13.5765 16.9775 17.0957 17.5711 14 22" stroke="#008FFB" stroke-width="1.5" stroke-linejoin="round"/>
<path d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z" stroke="black" stroke-width="1.5"/>
`,
  [WorkflowType.REGISTRAION_WAITINGLIST]: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 5.5H21" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
<path d="M12 12H21" stroke="#008FFB" stroke-width="1.5" stroke-linecap="round"/>
<path d="M12 18.5H21" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
<path d="M8 5.5H3M4.04167 8L6.95833 3M6.95833 8L4.04167 3" stroke="#008FFB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8 18.5H3M4.04167 21L6.95833 16M6.95833 21L4.04167 16" stroke="#008FFB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
`,
  [WorkflowType.CATEGORY_WAITINGLIST]: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 5.5H21" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
<path d="M12 12H21" stroke="#008FFB" stroke-width="1.5" stroke-linecap="round"/>
<path d="M12 18.5H21" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
<path d="M8 5.5H3M4.04167 8L6.95833 3M6.95833 8L4.04167 3" stroke="#008FFB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8 18.5H3M4.04167 21L6.95833 16M6.95833 21L4.04167 16" stroke="#008FFB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
`,
  [WorkflowType.REGISTRATION]: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15 17.625C14.9264 19.4769 13.3831 21.0494 11.3156 20.9988C10.8346 20.9871 10.2401 20.8194 9.05112 20.484C6.18961 19.6769 3.70555 18.3204 3.10956 15.2816C3 14.723 3 14.0944 3 12.8373V11.1627C3 9.90564 3 9.27707 3.10956 8.71848C3.70555 5.67966 6.18961 4.32317 9.05112 3.51603C10.2401 3.18065 10.8346 3.01296 11.3156 3.00119C13.3831 2.95061 14.9264 4.52308 15 6.37502" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
<path d="M10 12H21M10 12C10 11.2998 11.9943 9.99153 12.5 9.5M10 12C10 12.7002 11.9943 14.0085 12.5 14.5" stroke="#008FFB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
`,
  [WorkflowType.PAYMENT_WAITINGLIST]: `
<path d="M4.5 18.6458V8.05426C4.5 5.20025 4.5 3.77325 5.37868 2.88663C6.25736 2 7.67157 2 10.5 2H14.5C17.3284 2 18.7426 2 19.6213 2.88663C20.5 3.77325 20.5 5.20025 20.5 8.05426V18.6458C20.5 20.1575 20.5 20.9133 20.038 21.2108C19.2831 21.6971 18.1161 20.6774 17.5291 20.3073C17.0441 20.0014 16.8017 19.8485 16.5325 19.8397C16.2417 19.8301 15.9949 19.9768 15.4709 20.3073L13.56 21.5124C13.0445 21.8374 12.7868 22 12.5 22C12.2132 22 11.9555 21.8374 11.44 21.5124L9.52913 20.3073C9.04415 20.0014 8.80166 19.8485 8.53253 19.8397C8.24172 19.8301 7.99493 19.9768 7.47087 20.3073C6.88395 20.6774 5.71687 21.6971 4.96195 21.2108C4.5 20.9133 4.5 20.1575 4.5 18.6458Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M11.5 11H8.5" stroke="#008FFB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14.5 7H8.5" stroke="#008FFB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
`,
  [WorkflowType.CANCELLATION]: `
<path d="M15.4994 15L9.5 9M9.50064 15L15.5 9" stroke="#008FFB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M22.5 12C22.5 6.47715 18.0228 2 12.5 2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22C18.0228 22 22.5 17.5228 22.5 12Z" stroke="black" stroke-width="1.5"/>
`,
  [WorkflowType.DECLINE]: `
<path d="M12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47715 18.0228 2 12.5 2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22Z" stroke="black" stroke-width="1.5"/>
<path d="M12.4922 15H12.5012" stroke="#008FFB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12.5 12V8" stroke="#008FFB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
`,
  [WorkflowType.EVENT_CANCELLATION]: `
<path d="M18.5 2V4M6.5 2V4" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M11.55 22C7.51949 22 5.50424 22 4.25212 20.6464C3 19.2927 3 17.1141 3 12.7568V12.2432C3 7.88594 3 5.70728 4.25212 4.35364C5.50424 3 7.51949 3 11.55 3H13.45C17.4805 3 19.4958 3 20.7479 4.35364C21.9765 5.68186 21.9996 7.80438 22 12" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M3.5 8H21.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15 15L18.5 18.5M18.5 18.5L22 22M18.5 18.5L22 15M18.5 18.5L15 22" stroke="#008FFB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
`,
  [WorkflowType.PAYMENT]: `
<path d="M15.5 7.5C15.5 7.5 16 7.5 16.5 8.5C16.5 8.5 18.0882 6 19.5 5.5" stroke="#008FFB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M22.5 7C22.5 9.76142 20.2614 12 17.5 12C14.7386 12 12.5 9.76142 12.5 7C12.5 4.23858 14.7386 2 17.5 2C20.2614 2 22.5 4.23858 22.5 7Z" stroke="#008FFB" stroke-width="1.5" stroke-linecap="round"/>
<path d="M23.25 13.2445C23.2493 12.8302 22.9129 12.495 22.4987 12.4958C22.0845 12.4965 21.7493 12.8329 21.75 13.2471L23.25 13.2445ZM9.56582 6.75292C9.98003 6.75057 10.3139 6.41289 10.3116 5.99869C10.3092 5.58448 9.97154 5.2506 9.55734 5.25294L9.56582 6.75292ZM14 21.2504H11V22.7504H14V21.2504ZM11 21.2504C9.10311 21.2504 7.74353 21.2493 6.69895 21.1313C5.66816 21.0148 5.04359 20.7931 4.57229 20.4209L3.64263 21.5981C4.426 22.2168 5.36842 22.4905 6.53058 22.6218C7.67896 22.7515 9.13832 22.7504 11 22.7504V21.2504ZM1.75 14.0004C1.75 15.7493 1.74857 17.1321 1.88762 18.2226C2.02932 19.3337 2.32681 20.2394 2.99298 20.9866L4.11262 19.9884C3.72599 19.5547 3.49708 18.9856 3.37558 18.0328C3.25143 17.0593 3.25 15.789 3.25 14.0004H1.75ZM4.57229 20.4209C4.40545 20.2892 4.2517 20.1444 4.11262 19.9884L2.99298 20.9866C3.19068 21.2084 3.40811 21.4129 3.64263 21.5981L4.57229 20.4209ZM21.75 14.0004C21.75 15.789 21.7486 17.0593 21.6244 18.0328C21.5029 18.9856 21.274 19.5547 20.8874 19.9884L22.007 20.9866C22.6732 20.2394 22.9707 19.3337 23.1124 18.2226C23.2514 17.1321 23.25 15.7493 23.25 14.0004H21.75ZM14 22.7504C15.8617 22.7504 17.321 22.7515 18.4694 22.6218C19.6316 22.4905 20.574 22.2168 21.3574 21.5981L20.4277 20.4209C19.9564 20.7931 19.3318 21.0148 18.301 21.1313C17.2565 21.2493 15.8969 21.2504 14 21.2504V22.7504ZM20.8874 19.9884C20.7483 20.1444 20.5946 20.2892 20.4277 20.4209L21.3574 21.5981C21.5919 21.4129 21.8093 21.2084 22.007 20.9866L20.8874 19.9884ZM3.25 14.0004C3.25 12.2118 3.25143 10.9415 3.37558 9.96799C3.49708 9.01519 3.72599 8.44606 4.11262 8.0124L2.99298 7.0142C2.32681 7.76141 2.02932 8.66709 1.88762 9.77825C1.74857 10.8687 1.75 12.2515 1.75 14.0004H3.25ZM3.64263 6.40268C3.40811 6.58789 3.19068 6.79245 2.99298 7.0142L4.11262 8.0124C4.2517 7.8564 4.40545 7.71161 4.57229 7.57986L3.64263 6.40268ZM23.25 14.0004C23.25 13.7412 23.2504 13.4875 23.25 13.2445L21.75 13.2471C21.7504 13.4885 21.75 13.7376 21.75 14.0004H23.25ZM9.55734 5.25294C8.14978 5.26091 7.00411 5.29333 6.06558 5.44144C5.11301 5.59178 4.31862 5.86882 3.64263 6.40268L4.57229 7.57986C4.97956 7.25822 5.50124 7.04907 6.29942 6.92311C7.11164 6.79492 8.15139 6.76092 9.56582 6.75292L9.55734 5.25294Z" fill="black"/>
<path d="M10.5 18H12" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15 18H18.5" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M3 11H10.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
`,
  [WorkflowType.PROFILE]: `
<path d="M12.5 2C18.0237 2 22.5 6.47778 22.5 12C22.5 17.5222 18.0237 22 12.5 22" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9.5 21.5C8.31163 21.0953 7.19532 20.5107 6.22302 19.7462M6.22302 4.25385C7.19532 3.50059 8.31163 2.90473 9.5 2.5M2.5 10.2461C2.71607 9.08813 3.16019 7.96386 3.79638 6.94078M2.5 13.7539C2.71607 14.9119 3.16019 16.0361 3.79638 17.0592" stroke="#008FFB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8.5 16.5C10.5726 14.302 14.4051 14.1986 16.5 16.5M14.7179 9.75C14.7179 10.9926 13.7215 12 12.4925 12C11.2634 12 10.2671 10.9926 10.2671 9.75C10.2671 8.50736 11.2634 7.5 12.4925 7.5C13.7215 7.5 14.7179 8.50736 14.7179 9.75Z" stroke="black" stroke-width="1.5" stroke-linecap="round"/>`,
  [WorkflowType.STAGE_ACTION]: `
<path d="M9.14298 3.14559L7.43816 3.93362C4.81272 5.14719 3.5 5.75397 3.5 6.75C3.5 7.74603 4.81272 8.35281 7.43817 9.56638L9.14298 10.3544C10.7952 11.1181 11.6214 11.5 12.5 11.5C13.3786 11.5 14.2048 11.1181 15.857 10.3544L17.5618 9.56638C20.1873 8.35281 21.5 7.74603 21.5 6.75C21.5 5.75397 20.1873 5.14719 17.5618 3.93362L15.857 3.14559C14.2048 2.38186 13.3786 2 12.5 2C11.6214 2 10.7952 2.38186 9.14298 3.14559Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M21.288 11.0977C21.4293 11.2964 21.5 11.5036 21.5 11.7314C21.5 12.7132 20.1873 13.3114 17.5618 14.5077L15.857 15.2845C14.2048 16.0373 13.3786 16.4138 12.5 16.4138C11.6214 16.4138 10.7952 16.0373 9.14298 15.2845L7.43817 14.5077C4.81272 13.3114 3.5 12.7132 3.5 11.7314C3.5 11.5036 3.57067 11.2964 3.712 11.0977" stroke="#008FFB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M20.8767 16.2656C21.2922 16.5966 21.5 16.9265 21.5 17.3171C21.5 18.299 20.1873 18.8971 17.5618 20.0934L15.857 20.8702C14.2048 21.6231 13.3786 21.9995 12.5 21.9995C11.6214 21.9995 10.7952 21.6231 9.14298 20.8702L7.43817 20.0934C4.81272 18.8971 3.5 18.299 3.5 17.3171C3.5 16.9265 3.70778 16.5966 4.12334 16.2656" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
`,
  [WorkflowType.SPLITTER]: `<path d="M15.5 5C15.5 6.65685 14.1569 8 12.5 8C10.8431 8 9.5 6.65685 9.5 5C9.5 3.34315 10.8431 2 12.5 2C14.1569 2 15.5 3.34315 15.5 5Z" stroke="black" stroke-width="1.5"/>
<path d="M12.5 8V9M12.5 9C12.5 9.93188 12.5 10.3978 12.6776 10.7654C12.9144 11.2554 13.3687 11.6448 13.9404 11.8478C14.3692 12 14.9128 12 16 12C17.0872 12 17.6308 12 18.0596 12.1522C18.6313 12.3552 19.0856 12.7446 19.3224 13.2346C19.5 13.6022 19.5 14.0681 19.5 15V16M12.5 9C12.5 9.93188 12.5 10.3978 12.3224 10.7654C12.0856 11.2554 11.6313 11.6448 11.0596 11.8478C10.6308 12 10.0872 12 9 12C7.9128 12 7.3692 12 6.94041 12.1522C6.36867 12.3552 5.91443 12.7446 5.67761 13.2346C5.5 13.6022 5.5 14.0681 5.5 15V16" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8.5 19C8.5 20.6569 7.15685 22 5.5 22C3.84315 22 2.5 20.6569 2.5 19C2.5 17.3431 3.84315 16 5.5 16C7.15685 16 8.5 17.3431 8.5 19Z" stroke="#008FFB" stroke-width="1.5"/>
<path d="M22.5 19C22.5 20.6569 21.1569 22 19.5 22C17.8431 22 16.5 20.6569 16.5 19C16.5 17.3431 17.8431 16 19.5 16C21.1569 16 22.5 17.3431 22.5 19Z" stroke="#008FFB" stroke-width="1.5"/>
`,
  [WorkflowType.SURVEY]: ``
};
const getPaletteCategoryMap = workflowTypeCategories => {
  return Object.keys(workflowTypeCategories).reduce((record, key) => {
    const paletteSymbol = key;
    workflowTypeCategories[paletteSymbol].forEach(category => {
      record[category] = [...(record[category] ?? []), paletteSymbol];
    });
    return record;
  }, {});
};
// eslint-disable-next-line max-len
const WORKFLOW_BUILDER_STATE_CALLBACK_MAP = {
  [WorkflowType.CANCELLATION]: {
    disabled: [{
      callback: factory => factory.settings.disable_forms,
      attributeNames: ['form_ids', 'thank_you_page_id', 'email_campaign_id', 'cancelled_with_reason_stage_name']
    }]
  },
  [WorkflowType.DECLINE]: {
    disabled: [{
      callback: factory => factory.settings.disable_forms,
      attributeNames: ['form_ids', 'thank_you_page_id', 'email_campaign_id', 'declined_with_reason_stage_name']
    }]
  }
};
// eslint-disable-next-line max-len
let AzavistaWorkflowBuilderBaseDirective = /*#__PURE__*/(() => {
  class AzavistaWorkflowBuilderBaseDirective extends AzavistaExportedElementExporterDirective {
    constructor() {
      super(...arguments);
      this.debugMode = false;
      this.isDemo = false;
      this.stateCallbackMap = WORKFLOW_BUILDER_STATE_CALLBACK_MAP;
      this.propertyOptions = {};
      this.autoHideFieldLabel = false;
      this.hidePaletteList = false;
      /** @default WORKFLOW_TYPE_CATEGORIES */
      this.workflowTypeCategories = WORKFLOW_TYPE_CATEGORIES;
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵAzavistaWorkflowBuilderBaseDirective_BaseFactory;
        return function AzavistaWorkflowBuilderBaseDirective_Factory(__ngFactoryType__) {
          return (ɵAzavistaWorkflowBuilderBaseDirective_BaseFactory || (ɵAzavistaWorkflowBuilderBaseDirective_BaseFactory = i0.ɵɵgetInheritedFactory(AzavistaWorkflowBuilderBaseDirective)))(__ngFactoryType__ || AzavistaWorkflowBuilderBaseDirective);
        };
      })();
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: AzavistaWorkflowBuilderBaseDirective,
        inputs: {
          eventId: "eventId",
          debugMode: "debugMode",
          isDemo: "isDemo",
          stateCallbackMap: "stateCallbackMap",
          propertyOptions: "propertyOptions",
          autoHideFieldLabel: "autoHideFieldLabel",
          deleteWorkflowConfirmation: "deleteWorkflowConfirmation",
          updateProcessCallback: "updateProcessCallback",
          updateAdvancedQueryCallback: "updateAdvancedQueryCallback",
          hidePaletteList: "hidePaletteList",
          defaultScrollSettings: [0, "scrollSettings", "defaultScrollSettings"],
          workflowTypeCategories: "workflowTypeCategories"
        },
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return AzavistaWorkflowBuilderBaseDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let WorkflowBuilderProcessBuilderBaseDirective = /*#__PURE__*/(() => {
  class WorkflowBuilderProcessBuilderBaseDirective {
    constructor() {
      this.showOnlyFlowBuilder = false;
      this.processType = "participant" /* ProcessType.participant */;
    }
    static {
      this.ɵfac = function WorkflowBuilderProcessBuilderBaseDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WorkflowBuilderProcessBuilderBaseDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: WorkflowBuilderProcessBuilderBaseDirective,
        selectors: [["azavista-workflow-builder-process-builder-directive"]],
        inputs: {
          eventId: "eventId",
          getAclObjectForCurrentUser: "getAclObjectForCurrentUser",
          fullProcess: "fullProcess",
          showOnlyFlowBuilder: "showOnlyFlowBuilder",
          processType: "processType"
        },
        standalone: false
      });
    }
  }
  return WorkflowBuilderProcessBuilderBaseDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let WorkflowBuilderNodeItemBase = /*#__PURE__*/(() => {
  class WorkflowBuilderNodeItemBase {
    get workflowId() {
      return getWorkflowIdFromNodeId(this.node.id);
    }
    get controllerData() {
      return this.controller.dataMap[this.workflowId];
    }
    get isWorkflowValid() {
      return this.controller.validityMap[this.workflowId];
    }
    constructor(controller) {
      this.controller = controller;
      this.stateCallbackMap = WORKFLOW_BUILDER_STATE_CALLBACK_MAP;
      this.propertyOptions = {};
      this.autoHideFieldLabel = false;
      this.workflowSettingsChanges = new EventEmitter();
      this.outputPinUpdate = new EventEmitter();
      this.canvasChanges = new EventEmitter();
      this.removeNode = new EventEmitter();
      this.formFieldSubscription = {};
    }
    static {
      this.ɵfac = function WorkflowBuilderNodeItemBase_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WorkflowBuilderNodeItemBase)(i0.ɵɵdirectiveInject(AzavistaWorkflowBuilderController));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: WorkflowBuilderNodeItemBase,
        inputs: {
          node: "node",
          eventId: "eventId",
          stateCallbackMap: "stateCallbackMap",
          propertyOptions: "propertyOptions",
          updateProcessCallback: "updateProcessCallback",
          updateAdvancedQueryCallback: "updateAdvancedQueryCallback",
          autoHideFieldLabel: "autoHideFieldLabel"
        },
        outputs: {
          workflowSettingsChanges: "workflowSettingsChanges",
          outputPinUpdate: "outputPinUpdate",
          canvasChanges: "canvasChanges",
          removeNode: "removeNode"
        }
      });
    }
  }
  return WorkflowBuilderNodeItemBase;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const FIELD_NAME_PROFILE_ID = 'profile_page_id';
const FIELD_NAME_STAGE_ID = 'stage_id';
const getAzavistaServiceLibCacheProxy = (apiSvc, methodNames) => getAzavistaMemoryCache(apiSvc, methodNames);

// eslint-disable-next-line max-len
class WorkflowBuilderProviderApi extends WorkflowBuilderProviderAbstract {
  constructor(apiSvc, controller, sharedSvc) {
    super(controller);
    this.apiSvc = apiSvc;
    this.controller = controller;
    this.sharedSvc = sharedSvc;
    this.cacheService = getAzavistaServiceLibCacheProxy(this.apiSvc, ['getAllPages', 'getAllEventEmailCampaigns', 'getAllUsers', 'searchTeams', 'getAllEvents', 'getAllEventFields', 'getAllProfilePages', 'getAllStages', 'getAllEventParticipantFields', 'getAllEventAssets', 'getEventSettings', 'getProcess', 'getEvent', 'searchIntegrations']);
    this.dataSourceCallbacks = {
      Form: async eventId => this.getAllPageForms(eventId),
      Page: eventId => this.getAllPagesNonForm(eventId),
      Email: eventId => this.getAllPublishedEmailCampaigns(eventId),
      CrmStatus: async () => crmStatusArray,
      Workflow: (eventId, options) => this.getAllWorkflowsForDataSource(options.skippedWorkflowIds),
      ProfilePage: async () => {
        const res = await this.cacheService.getAllProfilePages();
        return res.profile_pages;
      },
      EmailTemplate: eventId => this.getAllPublishedEmailCampaigns(eventId),
      EmailField: eventId => this.getAllEventParticipantEmailFields(eventId),
      IntegerField: eventId => this.getAllEventParticipantIntegerFields(eventId),
      SelectField: eventId => this.getAllEventParticipantSelectFields(eventId),
      Field: eventId => this.getAllEventParticipantFields(eventId)
    };
    this.processDataSourceCallback = {
      users: () => this.cacheService.getAllUsers(),
      event: async eventId => this.getProcessDataSourceEvent(eventId),
      getEventFields: async eventId => this.cacheService.getAllEventFields(eventId),
      integrations: () => this.apiSvc.getAllPagedItems(req => this.cacheService.searchIntegrations(req), res => res.integrations),
      profilePages: async () => {
        return (await this.cacheService.getAllProfilePages()).profile_pages;
      },
      stages: async eventId => {
        return this.cacheService.getAllStages('event', eventId);
      }
    };
  }
  async getAllPageForms(eventId) {
    const allPages = await this.cacheService.getAllPages("Page" /* PageType.page */, eventId);
    return allPages.filter(page => page.is_form && page.is_published);
  }
  async getAllPagesNonForm(eventId) {
    const allPages = await this.cacheService.getAllPages("Page" /* PageType.page */, eventId);
    return allPages.filter(page => !page.is_form && page.is_published);
  }
  async getAllPublishedEmailCampaigns(eventId) {
    const allEmailCampaigns = await this.cacheService.getAllEventEmailCampaigns(eventId);
    const allEmailTemplates = await this.cacheService.getAllPages("Emailtemplate" /* PageType.emailTemplate */, eventId);
    const allEmailTemplatesMap = getMapByValue(allEmailTemplates, 'id');
    return allEmailCampaigns.filter(campaign => campaign.emailtemplate_id && allEmailTemplatesMap[campaign.emailtemplate_id]?.is_published);
  }
  async getAllEventParticipantEmailFields(eventId) {
    const allParticipantFields = await this.cacheService.getAllEventParticipantFields(eventId);
    const allEmailFields = allParticipantFields.filter(field => fieldType(field) === 'email');
    return allEmailFields;
  }
  async getAllEventParticipantIntegerFields(eventId) {
    const allParticipantFields = await this.cacheService.getAllEventParticipantFields(eventId);
    const allIntegerFields = allParticipantFields.filter(field => fieldType(field) === 'integer');
    return allIntegerFields;
  }
  async getAllEventParticipantSelectFields(eventId) {
    const allParticipantFields = await this.cacheService.getAllEventParticipantFields(eventId);
    const allIntegerFields = allParticipantFields.filter(field => fieldType(field) === 'select');
    return allIntegerFields;
  }
  async getAllEventParticipantFields(eventId) {
    const allParticipantFields = await this.cacheService.getAllEventParticipantFields(eventId);
    return allParticipantFields;
  }
  async getAllWorkflowsForInit(eventId) {
    const response = await this.apiSvc.getAllEventWorkflows("event" /* EventWorkflowParentType.event */, eventId);
    return getOrderedIEventWorkflows(response.workflows);
  }
  async saveBuilderData(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  eventId,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  data) {
    // TODO: save workflows action
  }
  async publishBuilderData(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  eventId,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  data) {
    // TODO: publish workflows action
  }
  async getProcessDataSourceEvent(eventId) {
    const eventDetail = await this.cacheService.getEvent(eventId);
    const [assets, participantFields, eventSettings, teams, templateEvents] = await Promise.all([this.cacheService.getAllEventAssets(eventId), this.cacheService.getAllEventParticipantFields(eventId), this.cacheService.getEventSettings(eventId), this.getEventTeams(eventDetail), this.getTemplateEvents(eventDetail)]);
    return {
      detail: eventDetail,
      assets,
      participantFields,
      settings: eventSettings.settings,
      teams,
      templateEvents
    };
  }
  async getEventTeams(event) {
    if (event.type === "workflow" /* EventType.workflow */) {
      const searchTeamsRequest = {
        limit: 50,
        offset: 0
      };
      const params = [{
        field: {
          name: 'id'
        },
        value: event.team_ids,
        operator: 'in'
      }];
      searchTeamsRequest.advancedQuery = flatSearchToRecursive(params, 'name');
      const searchTeamsResponse = await this.cacheService.searchTeams(searchTeamsRequest);
      return searchTeamsResponse.teams;
    }
    return undefined;
  }
  async getTemplateEvents(event) {
    if (event.type === "workflow" /* EventType.workflow */) {
      const allTemplateEvents = await this.apiSvc.getAllEvents("template" /* EventType.template */);
      return allTemplateEvents;
    }
    return undefined;
  }
}
const ZOOM_FACTOR_OPTIONS = [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1, 1.1, 1.2, 1.3, 1.4, 1.5];
const ZOOM_FACTOR_OPTIONS_MAX = ZOOM_FACTOR_OPTIONS.slice(-1)[0];
const ZOOM_FACTOR_OPTIONS_MIN = ZOOM_FACTOR_OPTIONS[0];
const ZOOM_FACTOR_OPTIONS_DELTA = ZOOM_FACTOR_OPTIONS[1] - ZOOM_FACTOR_OPTIONS[0];
const DEFAULT_ZOOM_VALUE = 1;
let AzavistaWorkflowBuilderZoomService = /*#__PURE__*/(() => {
  class AzavistaWorkflowBuilderZoomService {
    constructor() {
      this.zoomOptions = [...ZOOM_FACTOR_OPTIONS];
      this.previousZoomValue = DEFAULT_ZOOM_VALUE;
      // eslint-disable-next-line no-use-before-define
      this.zoomChanges$ = new Subject();
      this._zoomValue = DEFAULT_ZOOM_VALUE;
    }
    get zoomValue() {
      return this._zoomValue;
    }
    set zoomValue(value) {
      this.previousZoomValue = this.zoomValue;
      this._zoomValue = value;
    }
    updateZoom(zoomValue) {
      if (zoomValue === this.zoomValue) {
        return;
      }
      zoomValue = Math.max(Math.min(zoomValue, ZOOM_FACTOR_OPTIONS_MAX), ZOOM_FACTOR_OPTIONS_MIN);
      this.zoomOptions = [...ZOOM_FACTOR_OPTIONS];
      if (!this.zoomOptions.includes(zoomValue)) {
        this.zoomOptions.push(zoomValue);
        this.zoomOptions = this.zoomOptions.sort();
      }
      this.zoomValue = zoomValue;
      this.zoomChanges$.next(this.getZoomChanges());
    }
    resetZoom() {
      this.zoomValue = DEFAULT_ZOOM_VALUE;
      this.previousZoomValue = DEFAULT_ZOOM_VALUE;
    }
    getZoomChanges() {
      return pick(this, ['previousZoomValue', 'zoomValue', 'zoomOptions']);
    }
    static {
      this.ɵfac = function AzavistaWorkflowBuilderZoomService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaWorkflowBuilderZoomService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AzavistaWorkflowBuilderZoomService,
        factory: AzavistaWorkflowBuilderZoomService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AzavistaWorkflowBuilderZoomService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const toAsyncValidator = validator => {
  return async control => {
    return validator(control);
  };
};
let AzavistaWorkflowBuilderFormFieldService = /*#__PURE__*/(() => {
  class AzavistaWorkflowBuilderFormFieldService {
    constructor(sharedSvc, translateSvc) {
      this.sharedSvc = sharedSvc;
      this.translateSvc = translateSvc;
      this.getPageAttributeTranslation = pages => {
        return pages.map(page => ({
          value: page.id,
          trans: {
            [this.translateSvc.currentLang]: page.name
          }
        }));
      };
      this.getFieldAttributeTranslation = fields => {
        return fields.map(field => ({
          value: field.id,
          trans: {
            [this.translateSvc.currentLang]: field.label
          }
        }));
      };
      this.getWorkflowAttributeTranslations = (workflows, skippedId) => {
        return workflows.reduce((result, factory) => {
          const id = factory.getId();
          if (!skippedId?.includes(id)) {
            const workflow = factory.getWorkflow();
            result.push({
              value: id,
              trans: {
                [this.translateSvc.currentLang]: workflow.type
              }
            });
          }
          return result;
        }, []);
      };
      this.getEmailCampaignAttributeTranslations = emails => {
        return emails.map(email => ({
          value: email.id,
          trans: {
            [this.translateSvc.currentLang]: email.name
          }
        }));
      };
      this.getEmailTemplateAttributeTranslations = emails => {
        return emails.map(email => ({
          value: email.emailtemplate_id,
          trans: {
            [this.translateSvc.currentLang]: email.name
          }
        }));
      };
      this.getCrmAttributeTranslations = () => {
        return crmStatusArray.map(crmStatus => ({
          value: crmStatus,
          trans: {
            [this.translateSvc.currentLang]: crmStatus
          }
        }));
      };
      this.translationsMapCallback = {
        CrmStatus: this.getCrmAttributeTranslations,
        Email: this.getEmailCampaignAttributeTranslations,
        Form: this.getPageAttributeTranslation,
        Page: this.getPageAttributeTranslation,
        ProfilePage: this.getPageAttributeTranslation,
        Workflow: this.getWorkflowAttributeTranslations,
        EmailTemplate: this.getEmailTemplateAttributeTranslations,
        EmailField: this.getFieldAttributeTranslation,
        IntegerField: this.getFieldAttributeTranslation,
        SelectField: this.getFieldAttributeTranslation,
        Field: this.getFieldAttributeTranslation
      };
      this.getCanvasDataFields = workflowType => {
        const baseField = {
          category: '',
          builtin: true,
          editable: true,
          mandatory_for_planners: true,
          schema: {
            type: 'string'
          }
        };
        return [{
          ...baseField,
          id: 'name',
          name: 'name',
          label: this.sharedSvc.translate('NAME'),
          placeholder: this.sharedSvc.translate(WORKFLOW_NAME_TRANSLATIONS[workflowType])
        }, {
          ...baseField,
          id: 'description',
          name: 'description',
          label: this.sharedSvc.translate('DESCRIPTION'),
          placeholder: this.sharedSvc.translate(WORKFLOW_EXPLANATION_TRANSLATIONS[workflowType]),
          component: "textarea" /* FieldComponentType.textarea */
        }];
      };
    }
    getFormGroupFromWorkflowFactory(properties, factory, stateCallbackMap) {
      const formGroup = new FormGroup({});
      properties.forEach(property => {
        formGroup.addControl(property.attribute, this.getFormControlFromWorkflowProperty(property, factory, stateCallbackMap));
      });
      return formGroup;
    }
    getFormControlFromWorkflowProperty(property, factory, stateCallbackMap) {
      const {
        type
      } = property;
      const workflowSettings = factory.getWorkflow().settings;
      const validatorRequired = property.mandatory ? [toAsyncValidator(Validators.required)] : [];
      const asyncValidators = async (
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      control) => {
        await delay(ASYNC_VALIDATOR_DELAY);
        const validateResult = validateWorkflowProperty(property, factory, stateCallbackMap, control.value);
        return validateResult.result ? null : {
          [validateResult.errormsg ?? ' ']: {
            value: control.value
          }
        };
      };
      switch (type) {
        case 'multiselect':
          {
            return new FormArray(workflowSettings[property.attribute]?.map(value => {
              return new FormControl(value);
            }) ?? [], [], [...validatorRequired, asyncValidators]);
          }
        case 'number':
          {
            return new FormControl(workflowSettings[property.attribute],
            // property.mandatory ? Validators.required : [],
            [], [...validatorRequired, asyncValidators]);
          }
        case 'select':
        case 'boolean':
        case 'text':
          {
            return new FormControl(workflowSettings[property.attribute],
            // property.mandatory ? Validators.required : [],
            [], [...validatorRequired, asyncValidators]);
          }
        case 'select-limit':
          {
            return createFormGroupFromData(workflowSettings[property.attribute]);
          }
        case 'process':
          {
            return createFormGroupFromData(factory.getCustomProcess(property.attribute) ?? []);
          }
        case 'advanced-query':
          {
            return createFormGroupFromData(workflowSettings[property.attribute] ?? [[]]);
          }
      }
    }
    async getFieldFromWorkflowProperty(property, provider, options) {
      const {
        attribute,
        schema,
        label,
        mandatory,
        type
      } = property;
      const baseField = {
        category: '',
        builtin: true,
        editable: true,
        id: attribute,
        name: attribute,
        label: this.sharedSvc.translate(label),
        mandatory_for_planners: mandatory
      };
      switch (type) {
        case 'select':
          {
            const attributeTranslations = await this.getFieldDataSourceTranslations(property, provider, options);
            return {
              ...baseField,
              type: 'select',
              schema: mergeDeep(schema ?? {}, {
                type: 'string',
                enum: attributeTranslations.map(({
                  value
                }) => value)
              }),
              attributeTranslations
            };
          }
        case 'multiselect':
          {
            const attributeTranslations = await this.getFieldDataSourceTranslations(property, provider, options);
            return {
              ...baseField,
              type: 'multi-select',
              schema: mergeDeep(schema ?? {}, {
                type: 'array',
                items: {
                  type: 'string',
                  enum: attributeTranslations.map(({
                    value
                  }) => value)
                }
              }),
              attributeTranslations
            };
          }
        case 'boolean':
        case 'number':
        case 'text':
          {
            return {
              ...baseField,
              type: type,
              schema: mergeDeep(schema ?? {}, {
                type: type === 'text' ? 'string' : type
              })
            };
          }
        case 'process':
          {
            return {
              ...baseField,
              type: 'boolean',
              schema: {
                type: 'boolean'
              }
            };
          }
        case 'select-limit':
        case 'advanced-query':
          {
            return {
              ...baseField,
              type: 'boolean',
              schema: {
                type: 'boolean'
              }
            };
          }
      }
    }
    async getFieldDataSourceTranslations(property, provider, options) {
      const {
        datasource
      } = property;
      switch (datasource) {
        case 'Options':
          return (property.options || []).map(item => ({
            value: item.value,
            trans: {
              [this.translateSvc.currentLang]: this.sharedSvc.translate(item.label)
            }
          }));
        case 'Form':
        case 'Page':
        case 'Email':
        case 'EmailField':
        case 'CrmStatus':
        case 'Workflow':
        case 'ProfilePage':
        case 'EmailTemplate':
        case 'Field':
        case 'SelectField':
        case 'IntegerField':
          {
            const dataSourceCallback = provider.dataSourceCallbacks[datasource];
            const dataSourceRows = await dataSourceCallback(options.eventId, {
              skippedWorkflowIds: [options.workflowId]
            });
            const translationsCallback = this.translationsMapCallback[datasource];
            return translationsCallback(dataSourceRows);
          }
      }
    }
    static {
      this.ɵfac = function AzavistaWorkflowBuilderFormFieldService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaWorkflowBuilderFormFieldService)(i0.ɵɵinject(i1.AzavistaSharedService), i0.ɵɵinject(i7.TranslateService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AzavistaWorkflowBuilderFormFieldService,
        factory: AzavistaWorkflowBuilderFormFieldService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AzavistaWorkflowBuilderFormFieldService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let WorkflowBuilderService = /*#__PURE__*/(() => {
  class WorkflowBuilderService {
    constructor(apiSvc, controller, sharedSvc, translate) {
      this.apiSvc = apiSvc;
      this.controller = controller;
      this.sharedSvc = sharedSvc;
      this.translate = translate;
      this.dataProvider = new WorkflowBuilderProviderApi(this.apiSvc, this.controller, this.sharedSvc);
    }
    translationsLoaded() {
      if (this.translate.store.translations[this.translate.currentLang]) {
        return of(true);
      }
      return this.translate.onLangChange.pipe(map(res => !!res));
    }
    static {
      this.ɵfac = function WorkflowBuilderService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WorkflowBuilderService)(i0.ɵɵinject(i1$1.AzavistaApiService), i0.ɵɵinject(AzavistaWorkflowBuilderController), i0.ɵɵinject(i1.AzavistaSharedService), i0.ɵɵinject(i7.TranslateService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: WorkflowBuilderService,
        factory: WorkflowBuilderService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return WorkflowBuilderService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ApplyFunctionPipe = /*#__PURE__*/(() => {
  class ApplyFunctionPipe {
    /**
     * @param callbackMethod method that is to be run using `ApplyFunctionPipe`.
     ** please pass an arrow function instead of class method
     */
    transform(value, callbackMethod, ...extra) {
      return callbackMethod(value, ...extra);
    }
    static {
      this.ɵfac = function ApplyFunctionPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ApplyFunctionPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "apply",
        type: ApplyFunctionPipe,
        pure: true,
        standalone: false
      });
    }
  }
  return ApplyFunctionPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let WorkflowBuilderNodeFormHeaderComponent = /*#__PURE__*/(() => {
  class WorkflowBuilderNodeFormHeaderComponent {
    get canvas() {
      return this._canvas;
    }
    set canvas(value) {
      this._canvas = value;
      this.formGroup.patchValue(pick(value, ['name', 'description']), {
        emitEvent: false
      });
    }
    constructor(sharedSvc) {
      this.sharedSvc = sharedSvc;
      this.editMode = false;
      this.disableEditMode = false;
      this.canvasChanges = new EventEmitter();
      this.formGroup = this.createFormGroup();
      this.getWorkflowName = formValueName => {
        return formValueName || (this.workflowType ? this.sharedSvc.translate(WORKFLOW_NAME_TRANSLATIONS[this.workflowType]) : '');
      };
      this.getWorkflowDescription = formValueDescription => {
        return formValueDescription || (this.workflowType ? this.sharedSvc.translate(WORKFLOW_EXPLANATION_TRANSLATIONS[this.workflowType]) : '');
      };
    }
    ngOnInit() {
      this.formGroup.valueChanges.pipe(debounceTime(200)).subscribe(changes => this.canvasChanges.emit(changes));
    }
    createFormGroup() {
      return new FormGroup({
        description: new FormControl(''),
        name: new FormControl('')
      });
    }
    toggleEditMode(forceValue) {
      this.editMode = forceValue ?? !this.editMode;
    }
    static {
      this.ɵfac = function WorkflowBuilderNodeFormHeaderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WorkflowBuilderNodeFormHeaderComponent)(i0.ɵɵdirectiveInject(i1.AzavistaSharedService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: WorkflowBuilderNodeFormHeaderComponent,
        selectors: [["azavista-workflow-builder-node-form-header"]],
        inputs: {
          editMode: "editMode",
          disableEditMode: "disableEditMode",
          controllerData: "controllerData",
          canvas: "canvas",
          workflowType: "workflowType"
        },
        outputs: {
          canvasChanges: "canvasChanges"
        },
        standalone: false,
        decls: 3,
        vars: 4,
        consts: [[1, "workflow-builder-node-item__header"], [4, "ngIf"], [1, "workflow-builder-node-item__header__name"], ["mat-icon-button", "", 3, "click", 4, "ngIf"], [1, "workflow-builder-node-item__header__description"], ["mat-icon-button", "", 3, "click"], ["matInput", "", 3, "formControl", "placeholder"], ["matSuffix", "", 3, "click"], ["matInput", "", "cdkTextareaAutosize", "", 3, "formControl", "placeholder"]],
        template: function WorkflowBuilderNodeFormHeaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, WorkflowBuilderNodeFormHeaderComponent_ng_container_1_Template, 9, 9, "ng-container", 1)(2, WorkflowBuilderNodeFormHeaderComponent_ng_container_2_Template, 11, 8, "ng-container", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("edit-mode", ctx.editMode);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.editMode);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.editMode && ctx.formGroup);
          }
        },
        dependencies: [i4.NgIf, i2.DefaultValueAccessor, i2.NgControlStatus, i2.FormControlDirective, i5.MatFormField, i5.MatSuffix, i4$1.MatInput, i6.CdkTextareaAutosize, i3.MatIconButton, i4$2.MatIcon, i7.TranslatePipe, ApplyFunctionPipe],
        styles: ["*[_ngcontent-%COMP%]{--workflow-builder__diagram__font-size: 12px;--workflow-builder__diagram-form__font-size: 14px}html[_ngcontent-%COMP%]{--mat-form-field-container-height: 36px;--mat-form-field-filled-label-display: none;--mat-form-field-container-vertical-padding: 6px;--mat-form-field-filled-with-label-container-padding-top: 6px;--mat-form-field-filled-with-label-container-padding-bottom: 6px}[_nghost-%COMP%]{display:block}[_nghost-%COMP%]     *{box-sizing:border-box;font-size:var(--workflow-builder__diagram-form__font-size)}.workflow-builder-node-item__header[_ngcontent-%COMP%]{font-weight:600;line-height:24px;font-size:var(--workflow-builder__diagram-form__font-size);color:#797879}.workflow-builder-node-item__header[_ngcontent-%COMP%]   azavista-grouped-field[_ngcontent-%COMP%]{margin-top:8px}.workflow-builder-node-item__header__name[_ngcontent-%COMP%], .workflow-builder-node-item__header__description[_ngcontent-%COMP%]{display:flex;align-items:center;gap:4px;width:100%;text-wrap:pretty;overflow-wrap:anywhere}.workflow-builder-node-item__header__name[_ngcontent-%COMP%]   .mat-mdc-form-field[_ngcontent-%COMP%], .workflow-builder-node-item__header__description[_ngcontent-%COMP%]   .mat-mdc-form-field[_ngcontent-%COMP%]{width:100%}.workflow-builder-node-item__header__name[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .workflow-builder-node-item__header__name[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%], .workflow-builder-node-item__header__description[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .workflow-builder-node-item__header__description[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{font:inherit;background-color:transparent;width:100%;line-height:1.5em}.workflow-builder-node-item__header__name[_ngcontent-%COMP%]{font-size:1.2em;color:#666}.workflow-builder-node-item__header__name[_ngcontent-%COMP%] > button[_ngcontent-%COMP%]{--mdc-icon-button-icon-size: 14px;--mdc-icon-button-state-layer-size: 24px;overflow:hidden;top:0;right:0;padding:0}.workflow-builder-node-item__header__name[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:1rem;padding:2px 0;cursor:pointer}.workflow-builder-node-item__header__description[_ngcontent-%COMP%]{margin-top:8px;font-size:.9em;line-height:1.5em;transition:.1s,opacity .3s ease-in-out}.edit-mode.workflow-builder-node-item__header__name[_ngcontent-%COMP%]{justify-content:flex-end}.edit-mode.workflow-builder-node-item__header__name[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{position:absolute}"]
      });
    }
  }
  return WorkflowBuilderNodeFormHeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let WorkflowBuilderNodeFormFieldBaseComponent = /*#__PURE__*/(() => {
  class WorkflowBuilderNodeFormFieldBaseComponent {
    get propertyName() {
      return this.property.attribute;
    }
    get propertyDatasource() {
      return this.property.datasource;
    }
    constructor(ngZone, host) {
      this.ngZone = ngZone;
      this.host = host;
      this.hideLabel = false;
      this.outputPinUpdate = new EventEmitter();
      this.fieldClick = new EventEmitter();
      this.getErrorMessage = control => {
        if ((control?.touched || control?.dirty) && control?.errors) {
          const errorMessage = Object.keys(control.errors).filter(error => error !== 'required')[0]?.trim();
          if (errorMessage) {
            return errorMessage;
          }
        }
        return null;
      };
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      this.isLabelEllipsisActive = async _ => {
        await firstValueFrom(this.ngZone.onStable);
        const labelEl = this.host.nativeElement.querySelector(`label mat-label`);
        if (!labelEl) {
          return false;
        }
        const isWiderThanParentEl = labelEl.offsetWidth > (labelEl.parentElement?.offsetWidth ?? 0);
        return isWiderThanParentEl || this.isEllipsisActive(labelEl);
      };
      this.isEllipsisActive = element => {
        return element.offsetWidth < element.scrollWidth;
      };
      this.getLabelTooltipAsterisk = isFormValid => {
        return this.property.mandatory && !isFormValid ? '*' : '';
      };
    }
    static {
      this.ɵfac = function WorkflowBuilderNodeFormFieldBaseComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WorkflowBuilderNodeFormFieldBaseComponent)(i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: WorkflowBuilderNodeFormFieldBaseComponent,
        selectors: [["ng-component"]],
        hostVars: 2,
        hostBindings: function WorkflowBuilderNodeFormFieldBaseComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("property-name", ctx.propertyName)("property-datasource", ctx.propertyDatasource);
          }
        },
        inputs: {
          property: "property",
          control: "control",
          workflowId: "workflowId",
          eventId: "eventId",
          fieldState: "fieldState",
          hideLabel: "hideLabel",
          propertyOptions: "propertyOptions",
          workflowItemDestroyed: "workflowItemDestroyed",
          addFormFieldObservableCallback: "addFormFieldObservableCallback"
        },
        outputs: {
          outputPinUpdate: "outputPinUpdate",
          fieldClick: "fieldClick"
        },
        decls: 0,
        vars: 0,
        template: function WorkflowBuilderNodeFormFieldBaseComponent_Template(rf, ctx) {},
        encapsulation: 2
      });
    }
  }
  return WorkflowBuilderNodeFormFieldBaseComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let WorkflowBuilderNodeFormFieldTextComponent = /*#__PURE__*/(() => {
  class WorkflowBuilderNodeFormFieldTextComponent extends WorkflowBuilderNodeFormFieldBaseComponent {
    ngOnDestroy() {
      this.subscription?.unsubscribe();
    }
    onFocus(event) {
      if (this.fieldState?.disabled) {
        event.stopImmediatePropagation();
        event.preventDefault();
        event.target.blur?.();
      } else {
        this.control?.markAsTouched();
      }
    }
    setValue(value) {
      this.control?.setValue(value, {
        emitEvent: true
      });
      this.control?.markAsTouched();
      this.control?.markAsDirty();
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵWorkflowBuilderNodeFormFieldTextComponent_BaseFactory;
        return function WorkflowBuilderNodeFormFieldTextComponent_Factory(__ngFactoryType__) {
          return (ɵWorkflowBuilderNodeFormFieldTextComponent_BaseFactory || (ɵWorkflowBuilderNodeFormFieldTextComponent_BaseFactory = i0.ɵɵgetInheritedFactory(WorkflowBuilderNodeFormFieldTextComponent)))(__ngFactoryType__ || WorkflowBuilderNodeFormFieldTextComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: WorkflowBuilderNodeFormFieldTextComponent,
        selectors: [["azavista-workflow-builder-node-form-field-text"]],
        inputs: {
          property: "property"
        },
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 2,
        consts: [["regularField", ""], [4, "ngIf", "ngIfElse"], [4, "ngIf"], [1, "workflow-builder__node__form__field__duration__label"], [3, "valueChanged", "click", "label", "seconds"], [3, "hideRequiredMarker", "mat-form-field-mandatory", "mat-form-field-not-empty", "mat-form-field-hide-label", "matTooltip", "matTooltipDisabled", "click", 4, "ngIf"], [3, "click", "hideRequiredMarker", "matTooltip", "matTooltipDisabled"], ["type", "text", "matInput", "", 3, "formControl", "required", "focus", 4, "ngIf"], ["type", "number", "matInput", "", 3, "formControl", "required", "focus", 4, "ngIf"], ["type", "text", "matInput", "", 3, "focus", "formControl", "required"], ["type", "number", "matInput", "", 3, "focus", "formControl", "required"]],
        template: function WorkflowBuilderNodeFormFieldTextComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, WorkflowBuilderNodeFormFieldTextComponent_ng_container_0_Template, 2, 1, "ng-container", 1)(1, WorkflowBuilderNodeFormFieldTextComponent_ng_template_1_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const regularField_r8 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", ctx.propertyOptions == null ? null : ctx.propertyOptions.component == null ? null : ctx.propertyOptions.component.type)("ngIfElse", regularField_r8);
          }
        },
        dependencies: [i4.NgIf, i2.DefaultValueAccessor, i2.NumberValueAccessor, i2.NgControlStatus, i2.RequiredValidator, i2.FormControlDirective, i5.MatFormField, i5.MatLabel, i5.MatError, i4$1.MatInput, i5$1.MatTooltip, i6$1.AzavistaDurationComponent, i4.AsyncPipe, i7.TranslatePipe, ApplyFunctionPipe],
        styles: ["[_nghost-%COMP%]{display:block}.workflow-builder__node__form__field__duration__label[_ngcontent-%COMP%]{font-size:11px;margin-bottom:4px;display:block}  input::-webkit-outer-spin-button,   input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}  input[type=number]{-moz-appearance:textfield}"]
      });
    }
  }
  return WorkflowBuilderNodeFormFieldTextComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * [reference] https://material.angular.io/components/input/overview#changing-when-error-messages-are-shown
 */
class CustomErrorStateMatcher {
  constructor(sourceControl) {
    this.sourceControl = sourceControl;
  }
  isErrorState(control) {
    this.control = control;
    if (this.sourceControl.dirty) {
      control?.markAsDirty();
    }
    return (this.sourceControl.dirty || this.sourceControl.touched) && this.sourceControl.invalid;
  }
}
let WorkflowBuilderNodeFormFieldSelectComponent = /*#__PURE__*/(() => {
  class WorkflowBuilderNodeFormFieldSelectComponent extends WorkflowBuilderNodeFormFieldBaseComponent {
    get controlValue() {
      return this.control?.value;
    }
    constructor(fieldSvc, controller, translateSvc, cdr, ngZone, host) {
      super(ngZone, host);
      this.fieldSvc = fieldSvc;
      this.controller = controller;
      this.translateSvc = translateSvc;
      this.cdr = cdr;
      this.ngZone = ngZone;
      this.host = host;
      this.useInlineExpandedOptions = false;
      this.itemSelected = new EventEmitter();
      this.currentLang = this.translateSvc.currentLang;
      this.trackByAttributeTranslations = trackByAttributeTranslations;
      this.isExpanded = false;
      this.dataSourceIcon = {
        Page: 'language',
        Email: 'email',
        Form: 'web',
        CrmStatus: 'event_available',
        ProfilePage: 'account_circle',
        Workflow: 'dataset_outline',
        EmailTemplate: 'email',
        EmailField: 'inbox',
        IntegerField: 'looks_one',
        Options: 'format_list_bulleted',
        Field: 'power_input',
        SelectField: 'power_input'
      };
      this.dataSourceColor = {
        Page: '#4C83FF',
        Email: '#FF786A',
        EmailTemplate: '#FF786A',
        Form: '#FEB002',
        CrmStatus: '#98CA71',
        ProfilePage: '#0F1A43',
        Workflow: '#5D5FEF',
        EmailField: '#A45081',
        Options: '#A45081',
        IntegerField: '#A45081',
        SelectField: '#A45081',
        Field: '#A45081'
      };
      this.isListOptionEllipsisActive = async index => {
        await firstValueFrom(this.ngZone.onStable);
        const listOptionEl = this.host.nativeElement.querySelector(`.${this.getListOptionClassName(index)} .mdc-list-item__content`);
        return !!(listOptionEl && this.isEllipsisActive(listOptionEl));
      };
      this.getListOptionClassName = index => {
        return `node-form-field-select-list-option_${index}`;
      };
      this.getMatSelectPanelClass = useInlineExpandedOptions => {
        return [`panel-select-${this.property.attribute}`, 'workflow-builder__node__form__field__select__panel'].concat(useInlineExpandedOptions ? ['aza-cmp-hidden' /* hide field-select's dropdown popup, because it already displays expansion panel */] : []);
      };
    }
    async ngOnInit() {
      if (this.property && this.controller.dataProvider && this.eventId && this.workflowId && this.control) {
        this.attributeTranslations = await this.fieldSvc.getFieldDataSourceTranslations(this.property, this.controller.dataProvider, {
          eventId: this.eventId,
          workflowId: this.workflowId
        });
        this.matSelectErrorStateMatcher = new CustomErrorStateMatcher(this.control);
      }
    }
    ngAfterViewInit() {
      this.updateSelectElementErrorState();
    }
    async onSelectOpen() {
      this.fieldClick.emit();
      if (this.useInlineExpandedOptions) {
        this.selectElement?.close();
        this.isExpanded = !this.isExpanded;
      }
      if ((this.isExpanded || !this.useInlineExpandedOptions) && !this.control?.touched) {
        this.control?.markAsTouched();
        this.updateSelectElementErrorState();
      }
    }
    async onItemSelected(itemTranslation) {
      if (this.control) {
        this.control.markAsDirty();
        if (this.control instanceof FormArray && itemTranslation) {
          const arrayValues = this.control.value;
          const shouldAdd = !arrayValues.includes(itemTranslation.value);
          if (shouldAdd) {
            this.control.push(new FormControl(itemTranslation.value));
          } else {
            const index = arrayValues.findIndex(value => value === itemTranslation.value);
            this.control.removeAt(index);
          }
        } else {
          // single select
          this.control.setValue(itemTranslation?.value);
          this.isExpanded = false;
        }
        await this.updateSelectElementErrorState();
        this.itemSelected.emit();
      }
    }
    isValueEmpty(controlValue) {
      return !(this.property?.type === 'multiselect' && controlValue instanceof Array ? controlValue.length > 0 : controlValue);
    }
    async updateSelectElementErrorState() {
      this.control?.updateValueAndValidity();
      this.cdr.markForCheck();
      await delay$1(ASYNC_VALIDATOR_DELAY + 10);
      this.selectElement?.updateErrorState();
      this.cdr.markForCheck();
    }
    static {
      this.ɵfac = function WorkflowBuilderNodeFormFieldSelectComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WorkflowBuilderNodeFormFieldSelectComponent)(i0.ɵɵdirectiveInject(AzavistaWorkflowBuilderFormFieldService), i0.ɵɵdirectiveInject(AzavistaWorkflowBuilderController), i0.ɵɵdirectiveInject(i7.TranslateService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: WorkflowBuilderNodeFormFieldSelectComponent,
        selectors: [["azavista-workflow-builder-node-form-field-select"]],
        viewQuery: function WorkflowBuilderNodeFormFieldSelectComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.selectElement = _t.first);
          }
        },
        inputs: {
          property: "property",
          useInlineExpandedOptions: "useInlineExpandedOptions"
        },
        outputs: {
          itemSelected: "itemSelected"
        },
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 4,
        vars: 2,
        consts: [["selectContainerElement", ""], ["matFormFieldElement", ""], ["selectElement", ""], [3, "ngTemplateOutlet"], ["class", "workflow-builder__node__form__field__select__expansion-panel", 3, "expanded", "disabled", "mat-expansion-panel-field-not-empty", "mat-expansion-panel-field-valid", "mat-expansion-panel-hide-label", "mat-expansion-panel-hide-border", "expandedChange", 4, "ngIf"], [1, "workflow-builder__node__form__field__select__expansion-panel", 3, "expandedChange", "expanded", "disabled"], ["color", "primary", 3, "multiple"], [3, "value", "selected", "click", 4, "ngIf"], [3, "value", "selected", "matTooltip", "matTooltipDisabled", "class", "click", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "click", "value", "selected"], [3, "click", "value", "selected", "matTooltip", "matTooltipDisabled"], ["class", "workflow-builder__node__form__field__select__header-select", "appearance", "outline", 3, "hideRequiredMarker", "matTooltip", "matTooltipDisabled", "mat-form-field-mandatory", "mat-form-field-not-empty", "mat-form-field-hide-label", "mat-form-field-arrow-rotated", 4, "ngIf"], ["appearance", "outline", 1, "workflow-builder__node__form__field__select__header-select", 3, "hideRequiredMarker", "matTooltip", "matTooltipDisabled"], ["matPrefix", "", 3, "color", 4, "ngIf"], [3, "required", "value", "multiple", "panelClass", "disabled", "errorStateMatcher", "placeholder", "opened", 4, "ngIf"], [4, "ngIf"], ["matPrefix", ""], [3, "opened", "required", "value", "multiple", "panelClass", "disabled", "errorStateMatcher", "placeholder"], [3, "value", "click", 4, "ngIf"], [3, "value", "click", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "click", "value"]],
        template: function WorkflowBuilderNodeFormFieldSelectComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementContainer(0, 3);
            i0.ɵɵtemplate(1, WorkflowBuilderNodeFormFieldSelectComponent_mat_expansion_panel_1_Template, 4, 14, "mat-expansion-panel", 4)(2, WorkflowBuilderNodeFormFieldSelectComponent_ng_template_2_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const selectContainerElement_r12 = i0.ɵɵreference(3);
            i0.ɵɵproperty("ngTemplateOutlet", selectContainerElement_r12);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.useInlineExpandedOptions && ctx.control && ctx.property);
          }
        },
        dependencies: [i4.NgForOf, i4.NgIf, i4.NgTemplateOutlet, i5.MatFormField, i5.MatLabel, i5.MatError, i5.MatPrefix, i4$2.MatIcon, i7$1.MatExpansionPanel, i4$3.MatSelect, i4$3.MatOption, i9.MatSelectionList, i9.MatListOption, i5$1.MatTooltip, i4.AsyncPipe, i7.TranslatePipe, ApplyFunctionPipe],
        styles: ["[_nghost-%COMP%]{display:block;--mat-expansion-header-collapsed-state-height: 2em;--mat-expansion-header-expanded-state-height: 2em}[_nghost-%COMP%]:has(mat-expansion-panel.mat-expanded)     mat-form-field{background-color:#fff}[_nghost-%COMP%]:has(mat-expansion-panel.mat-expanded)     .mat-mdc-form-field-subscript-wrapper{border-width:0px 1px;border-color:#ccc;border-style:solid}.workflow-builder__node__form__field__select__header-select[_ngcontent-%COMP%]{margin-bottom:-4px;position:relative;z-index:5}mat-expansion-panel.mat-expansion-panel[_ngcontent-%COMP%]{box-shadow:none}mat-expansion-panel.mat-expansion-panel[_ngcontent-%COMP%]     .mat-expansion-panel-body{padding:0}mat-expansion-panel.mat-expansion-panel[_ngcontent-%COMP%]     .mat-mdc-list-base.mat-mdc-selection-list{--mdc-list-list-item-label-text-font: inherit;--mdc-list-list-item-label-text-line-height: 2em;--mdc-list-list-item-label-text-size: 1em;--mdc-list-list-item-one-line-container-height: 3em;--mdc-list-list-item-two-line-container-height: 5em;--mdc-list-list-item-three-line-container-height: 7em}mat-expansion-panel.mat-expansion-panel[_ngcontent-%COMP%]     .mat-mdc-list-base.mat-mdc-selection-list .mat-mdc-list-item{border-radius:0;border-top:1px solid #ccc;margin-bottom:0!important}mat-expansion-panel-header[_ngcontent-%COMP%]{padding:0;background-color:#fff!important;height:min-content}mat-expansion-panel-header[_ngcontent-%COMP%]     .mat-expansion-indicator{padding:4px 1em}mat-expansion-panel-header[_ngcontent-%COMP%]     .mdc-notched-outline__notch{display:flex}mat-expansion-panel-header[_ngcontent-%COMP%]   mat-select[_ngcontent-%COMP%], mat-expansion-panel-header[_ngcontent-%COMP%]   mat-form-field[_ngcontent-%COMP%]{pointer-events:none}mat-expansion-panel.mat-expansion-panel-hide-label[_ngcontent-%COMP%]   mat-expansion-panel-header[_ngcontent-%COMP%]     .mdc-text-field--outlined{--mdc-outlined-text-field-outline-width: 0px}mat-expansion-panel.mat-expansion-panel-hide-label.mat-expansion-panel-field-not-empty.mat-expansion-panel-field-valid[_ngcontent-%COMP%]{--mdc-outlined-text-field-outline-color: #4caf50;border:1px solid var(--mdc-outlined-text-field-outline-color)!important}mat-expansion-panel.mat-expansion-panel-hide-border[_ngcontent-%COMP%]{border:0px!important}.mat-icon[_ngcontent-%COMP%]{font-size:14px;line-height:1em;width:1em;height:1em;padding:.5em}"]
      });
    }
  }
  return WorkflowBuilderNodeFormFieldSelectComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// eslint-disable-next-line max-len
let WorkflowBuilderNodeFormFieldSelectCapacityCapacityTableDialogComponent = /*#__PURE__*/(() => {
  class WorkflowBuilderNodeFormFieldSelectCapacityCapacityTableDialogComponent {
    constructor(sharedSvc, data, dialog, dialogRef) {
      this.sharedSvc = sharedSvc;
      this.data = data;
      this.dialog = dialog;
      this.dialogRef = dialogRef;
      this.columns = this.getColumns();
      this.displayedColumns = this.columns.map(col => col.name);
      this.actions = [{
        label: this.sharedSvc.translate('DELETE'),
        id: 'delete',
        icon: 'delete',
        singleSelectionOnly: false
      }];
      this.maxCapacity = this.data.workflow.number_of_participants;
      this.getAddValueField = rows => {
        const remainingAvailableValues = this.data.availableValues.filter(value => !rows.some(row => row.id === value));
        return {
          ...this.getValueField(),
          schema: {
            type: 'array',
            items: {
              type: 'string',
              enum: remainingAvailableValues
            }
          },
          editable: true
        };
      };
      this.getIsDataValid = () => {
        const assignedCapacities = this.getAssignedCapacities();
        return assignedCapacities > 0 && assignedCapacities === this.maxCapacity;
      };
      const limitMap = data.data?.limit_map || {};
      this.rows = objectKeys(limitMap).map(id => ({
        id,
        capacity: limitMap[id] || 0
      })).filter(({
        id
      }) => data.availableValues.includes(id));
    }
    getColumns() {
      return [this.getValueField(), {
        label: this.sharedSvc.translate('CAPACITY'),
        editable: true,
        name: 'capacity',
        id: 'capacity',
        schema: {
          type: 'integer',
          minimum: 0
        }
      }];
    }
    getValueField(options) {
      return {
        label: this.data.title,
        editable: false,
        name: 'id',
        id: 'id',
        type: 'select',
        schema: {
          type: 'string',
          enum: options?.enums || this.data.availableValues
        }
      };
    }
    onTableAction(action) {
      const actionItem = action.actionItem;
      switch (actionItem.id) {
        case 'delete':
          {
            this.rows = action.allItemsSelected ? [] : this.rows.filter(row => action.selectedRows.includes(row.id));
            this.tableEl?.selection.clear();
          }
      }
    }
    openAddRowDialog() {
      this.dialog.open(this.addValueEl, {
        maxWidth: '250px'
      });
    }
    addRows(valueIds) {
      valueIds.forEach(id => this.addRow(id));
    }
    addRow(valueId) {
      this.rows = [...this.rows, {
        id: valueId,
        capacity: 0
      }];
    }
    saveChanges() {
      const result = this.getTableUpdatedDatasource();
      if (result) {
        this.dialogRef.close(result);
      }
    }
    getTableUpdatedDatasource() {
      if (!this.tableEl) {
        return undefined;
      }
      const result = this.tableEl.dataSource.reduce((record, row) => ({
        ...record,
        [row.id]: row.capacity
      }),
      // eslint-disable-next-line max-len
      {});
      if (result) {
        this.tableEl.modifiedRows.forEach(({
          changedRow
        }) => {
          if (changedRow?.id && result[changedRow.id] != null) {
            result[changedRow?.id] = changedRow?.capacity;
          }
        });
      }
      return result;
    }
    getAssignedCapacities() {
      const updatedData = this.getTableUpdatedDatasource();
      return updatedData ? Object.keys(updatedData).reduce((sum, dataKey) => sum + updatedData[dataKey], 0) : 0;
    }
    static {
      this.ɵfac = function WorkflowBuilderNodeFormFieldSelectCapacityCapacityTableDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WorkflowBuilderNodeFormFieldSelectCapacityCapacityTableDialogComponent)(i0.ɵɵdirectiveInject(i1.AzavistaSharedService), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i2$1.MatDialog), i0.ɵɵdirectiveInject(i2$1.MatDialogRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: WorkflowBuilderNodeFormFieldSelectCapacityCapacityTableDialogComponent,
        selectors: [["azavista-workflow-builder-node-form-field-select-limit-capacity-table"]],
        viewQuery: function WorkflowBuilderNodeFormFieldSelectCapacityCapacityTableDialogComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c1, 5);
            i0.ɵɵviewQuery(_c2, 5);
            i0.ɵɵviewQuery(_c3, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.addValueEl = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.addValueField = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tableEl = _t.first);
          }
        },
        standalone: false,
        decls: 30,
        vars: 33,
        consts: [["tableEl", ""], ["saveButton", ""], ["addValueEl", ""], ["addValueField", ""], ["mat-dialog-title", "", 1, "aza-cmp-flex-row"], [1, "aza-cmp-flex-item-grow"], ["class", "aza-cmp-half-padding", 4, "ngIf"], ["mat-dialog-content", ""], [1, "aza-cmp-flex-row"], [1, "aza-cmp-flex-column"], ["class", "mat-form-field-invalid", 4, "ngIf"], [3, "newAdded", "rowActionSelected", "columns", "dataSource", "displayedColumns", "canEdit", "canAddNew", "editMode", "actions", "compactControls", "addButtonLabel"], ["mat-dialog-actions", "", 1, "aza-cmp-flex-row"], [3, "matDialogClose"], ["color", "primary", 3, "click", "disabled"], [1, "aza-cmp-half-padding"], [3, "ngTemplateOutlet"], [1, "mat-form-field-invalid"], [4, "ngIf"], [1, "aza-cmp-flex-item-grow", 3, "field", "canEdit", "editMode", "fullWidth"], ["matDialogClose", "", "color", "primary", 3, "click", "disabled"]],
        template: function WorkflowBuilderNodeFormFieldSelectCapacityCapacityTableDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 4)(1, "span", 5);
            i0.ɵɵtext(2);
            i0.ɵɵpipe(3, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, WorkflowBuilderNodeFormFieldSelectCapacityCapacityTableDialogComponent_div_4_Template, 2, 1, "div", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 7);
            i0.ɵɵelement(6, "div", 8);
            i0.ɵɵelementStart(7, "div", 9)(8, "div", 8);
            i0.ɵɵtext(9);
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(11, "div", 8);
            i0.ɵɵtext(12);
            i0.ɵɵpipe(13, "translate");
            i0.ɵɵtemplate(14, WorkflowBuilderNodeFormFieldSelectCapacityCapacityTableDialogComponent_span_14_Template, 2, 0, "span", 10);
            i0.ɵɵtext(15, " : ");
            i0.ɵɵelementStart(16, "span");
            i0.ɵɵtext(17);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(18, "azavista-table", 11, 0);
            i0.ɵɵlistener("newAdded", function WorkflowBuilderNodeFormFieldSelectCapacityCapacityTableDialogComponent_Template_azavista_table_newAdded_18_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.openAddRowDialog());
            })("rowActionSelected", function WorkflowBuilderNodeFormFieldSelectCapacityCapacityTableDialogComponent_Template_azavista_table_rowActionSelected_18_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onTableAction($event));
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(20, "div", 12)(21, "azavista-button", 13);
            i0.ɵɵtext(22);
            i0.ɵɵpipe(23, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(24, "azavista-button", 14, 1);
            i0.ɵɵlistener("click", function WorkflowBuilderNodeFormFieldSelectCapacityCapacityTableDialogComponent_Template_azavista_button_click_24_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.saveChanges());
            });
            i0.ɵɵtext(26);
            i0.ɵɵpipe(27, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(28, WorkflowBuilderNodeFormFieldSelectCapacityCapacityTableDialogComponent_ng_template_28_Template, 2, 4, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const tableEl_r7 = i0.ɵɵreference(19);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 23, "CONFIGURE_CAPACITY"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", tableEl_r7.exportedElement == null ? null : tableEl_r7.exportedElement.templateRef);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(10, 25, "CONFIGURE_SELECT_FIELD"), " : ", ctx.data.title, " ");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(13, 27, "TOTAL_ASSIGNED_DIVIDED_BY_CAPACITY"), "");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.getIsDataValid());
            i0.ɵɵadvance(2);
            i0.ɵɵclassProp("mat-form-field-invalid", !ctx.getIsDataValid());
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate2("", ctx.getAssignedCapacities(), " / ", ctx.maxCapacity || 0, "");
            i0.ɵɵadvance();
            i0.ɵɵproperty("columns", ctx.columns)("dataSource", ctx.rows)("displayedColumns", ctx.displayedColumns)("canEdit", true)("canAddNew", ctx.rows.length < ctx.data.availableValues.length)("editMode", true)("actions", ctx.actions)("compactControls", true)("addButtonLabel", ctx.data.title);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("matDialogClose", null);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(23, 29, "CANCEL"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", !ctx.getIsDataValid());
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(27, 31, "SAVE"));
          }
        },
        dependencies: [i4.NgIf, i4.NgTemplateOutlet, i2$1.MatDialogClose, i2$1.MatDialogTitle, i2$1.MatDialogActions, i2$1.MatDialogContent, i4$4.AzavistaButtonComponent, i5$2.AzavistaTableComponent, i6$2.AzavistaInputFieldComponent, i7.TranslatePipe, ApplyFunctionPipe],
        styles: [".mat-mdc-dialog-title.aza-cmp-flex-row[_ngcontent-%COMP%]{display:flex}[_nghost-%COMP%]     .azavista-advanced-search-component-extra-buttons .edit-mode-container{display:none}[_nghost-%COMP%]     azavista-table .title-and-controls-container{background-color:transparent!important}"]
      });
    }
  }
  return WorkflowBuilderNodeFormFieldSelectCapacityCapacityTableDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// eslint-disable-next-line max-len
let WorkflowBuilderNodeFormFieldSelectCapacityComponent = /*#__PURE__*/(() => {
  class WorkflowBuilderNodeFormFieldSelectCapacityComponent extends WorkflowBuilderNodeFormFieldBaseComponent {
    get controlGroup() {
      return this.control;
    }
    get selectFieldIdProperty() {
      return {
        ...this.property,
        type: 'select',
        datasource: 'SelectField'
      };
    }
    constructor(ngZone, host, dialog, controller) {
      super(ngZone, host);
      this.ngZone = ngZone;
      this.host = host;
      this.dialog = dialog;
      this.controller = controller;
      this.objectKeys = objectKeys;
    }
    onSelectFieldIdChange() {
      this.updateCapacityMap({});
      this.configureCapacity();
    }
    async configureCapacity() {
      const dataProvider = this.controller.dataProvider;
      const selectedField = (await dataProvider.dataSourceCallbacks.SelectField(this.eventId, {
        skippedWorkflowIds: []
      })).find(field => field.id === this.controlGroup.value.select_field_id);
      if (!selectedField) {
        return;
      }
      const result = await firstValueFrom(this.dialog.open(
      // eslint-disable-next-line max-len
      WorkflowBuilderNodeFormFieldSelectCapacityCapacityTableDialogComponent, {
        data: {
          title: selectedField.label,
          availableValues: selectedField.schema.enum || [],
          // eslint-disable-next-line max-len
          data: this.controlGroup.value,
          workflow: this.controlGroup.parent // eslint-disable-next-line max-len
          .value
        }
      }).afterClosed());
      if (result) {
        this.updateCapacityMap(result);
      }
    }
    updateCapacityMap(result) {
      this.controlGroup.setControl('limit_map', createFormGroupFromData(result || {}));
      this.controlGroup.controls.limit_map?.markAsDirty();
      this.controlGroup.markAllAsTouched();
    }
    static {
      this.ɵfac = function WorkflowBuilderNodeFormFieldSelectCapacityComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WorkflowBuilderNodeFormFieldSelectCapacityComponent)(i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i2$1.MatDialog), i0.ɵɵdirectiveInject(AzavistaWorkflowBuilderController));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: WorkflowBuilderNodeFormFieldSelectCapacityComponent,
        selectors: [["azavista-workflow-builder-node-form-field-select-capacity"]],
        viewQuery: function WorkflowBuilderNodeFormFieldSelectCapacityComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c4, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.selectFieldEl = _t.first);
          }
        },
        inputs: {
          property: "property"
        },
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 10,
        consts: [["selectFieldEl", ""], [3, "outputPinUpdate", "fieldClick", "itemSelected", "control", "eventId", "workflowId", "property", "workflowItemDestroyed", "addFormFieldObservableCallback", "fieldState"], ["class", "aza-cmp-padding aza-cmp-padding-block", 4, "ngIf"], [1, "aza-cmp-padding", "aza-cmp-padding-block"], [3, "click", "disabled"], ["class", "mat-warn", 4, "ngIf"], [1, "mat-warn"]],
        template: function WorkflowBuilderNodeFormFieldSelectCapacityComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "azavista-workflow-builder-node-form-field-select", 1, 0);
            i0.ɵɵlistener("outputPinUpdate", function WorkflowBuilderNodeFormFieldSelectCapacityComponent_Template_azavista_workflow_builder_node_form_field_select_outputPinUpdate_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.outputPinUpdate.emit($event));
            })("fieldClick", function WorkflowBuilderNodeFormFieldSelectCapacityComponent_Template_azavista_workflow_builder_node_form_field_select_fieldClick_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.fieldClick.emit());
            })("itemSelected", function WorkflowBuilderNodeFormFieldSelectCapacityComponent_Template_azavista_workflow_builder_node_form_field_select_itemSelected_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onSelectFieldIdChange());
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(2, WorkflowBuilderNodeFormFieldSelectCapacityComponent_div_2_Template, 6, 6, "div", 2);
          }
          if (rf & 2) {
            const selectFieldEl_r4 = i0.ɵɵreference(1);
            i0.ɵɵclassProp("workflow-builder-node-form-field--disabled", ctx.fieldState == null ? null : ctx.fieldState[ctx.property.attribute] == null ? null : ctx.fieldState[ctx.property.attribute].disabled);
            i0.ɵɵproperty("control", ctx.controlGroup.controls.select_field_id)("eventId", ctx.eventId)("workflowId", ctx.workflowId)("property", ctx.selectFieldIdProperty)("workflowItemDestroyed", ctx.workflowItemDestroyed)("addFormFieldObservableCallback", ctx.addFormFieldObservableCallback)("fieldState", ctx.fieldState == null ? null : ctx.fieldState[ctx.property.attribute]);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", selectFieldEl_r4 == null ? null : selectFieldEl_r4.attributeTranslations == null ? null : selectFieldEl_r4.attributeTranslations.length);
          }
        },
        dependencies: [i4.NgIf, i4$2.MatIcon, i4$4.AzavistaButtonComponent, WorkflowBuilderNodeFormFieldSelectComponent, i7.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return WorkflowBuilderNodeFormFieldSelectCapacityComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// eslint-disable-next-line max-len
let WorkflowBuilderNodeFormFieldToggleComponent = /*#__PURE__*/(() => {
  class WorkflowBuilderNodeFormFieldToggleComponent extends WorkflowBuilderNodeFormFieldBaseComponent {
    updateValue(isChecked) {
      this.control?.setValue(isChecked);
      this.control?.markAsDirty();
      this.control?.markAsTouched();
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵWorkflowBuilderNodeFormFieldToggleComponent_BaseFactory;
        return function WorkflowBuilderNodeFormFieldToggleComponent_Factory(__ngFactoryType__) {
          return (ɵWorkflowBuilderNodeFormFieldToggleComponent_BaseFactory || (ɵWorkflowBuilderNodeFormFieldToggleComponent_BaseFactory = i0.ɵɵgetInheritedFactory(WorkflowBuilderNodeFormFieldToggleComponent)))(__ngFactoryType__ || WorkflowBuilderNodeFormFieldToggleComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: WorkflowBuilderNodeFormFieldToggleComponent,
        selectors: [["azavista-workflow-builder-node-form-field-toggle"]],
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 1,
        vars: 1,
        consts: [["color", "primary", "labelPosition", "before", 3, "checked", "disabled", "change", "click", 4, "ngIf"], ["color", "primary", "labelPosition", "before", 3, "change", "click", "checked", "disabled"], ["class", "mat-mdc-form-field-required-marker", 4, "ngIf"], [1, "mat-mdc-form-field-required-marker"]],
        template: function WorkflowBuilderNodeFormFieldToggleComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, WorkflowBuilderNodeFormFieldToggleComponent_mat_slide_toggle_0_Template, 4, 6, "mat-slide-toggle", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.control && ctx.property);
          }
        },
        dependencies: [i4.NgIf, i2$2.MatSlideToggle, i7.TranslatePipe],
        styles: ["[_nghost-%COMP%]{display:block}[_nghost-%COMP%]     .mdc-switch{transform:scale(.6)!important}"]
      });
    }
  }
  return WorkflowBuilderNodeFormFieldToggleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// eslint-disable-next-line max-len
let WorkflowBuilderNodeFormFieldProcessComponent = /*#__PURE__*/(() => {
  class WorkflowBuilderNodeFormFieldProcessComponent extends WorkflowBuilderNodeFormFieldBaseComponent {
    constructor(ngZone, host, controller) {
      super(ngZone, host);
      this.ngZone = ngZone;
      this.host = host;
      this.controller = controller;
    }
    async openSteps() {
      this.control?.markAsTouched();
      const fullProcess = {
        name: '',
        steps: this.control && Array.isArray(this.control?.value) ? this.control.value : [],
        // TODO: define trigger
        trigger: undefined,
        stage_submit: '',
        paused: false,
        locked: false
      };
      const dialogData = {
        eventId: this.eventId,
        processType: "participant" /* ProcessType.participant */,
        property: this.property,
        workflowId: this.workflowId,
        isNewBuilderCompatible: this.isNewBuilderCompatible,
        showOnlyFlowBuilder: true,
        fullProcess,
        availableWorkflows: this.controller.getCurrentState().workflows,
        getAclObjectForCurrentUser: () => ({
          allowed: true,
          availableScopes: [],
          requiredScopes: []
        })
      };
      const updateProcess$ = this.updateProcessCallback(dialogData);
      this.fieldClick.emit();
      // this subscription should stay listening even when the nodeItem's form in diagram is either collapsed/expanded
      // but it should stop listening when workflow is deleted
      this.addFormFieldObservableCallback(this.property, updateProcess$);
      updateProcess$.pipe(takeUntil(this.workflowItemDestroyed)).subscribe(results => {
        this.handleUpdateResults(results);
      });
    }
    handleUpdateResults(results) {
      if (results && this.control && this.control instanceof FormArray) {
        const controlArray = this.control;
        const controlArrayToRemove = controlArray.controls.length;
        for (let index = 0; index < controlArrayToRemove; index++) {
          controlArray.removeAt(0);
        }
        results.forEach(step => controlArray.push(createFormGroupFromData(step)));
        if (this.workflowId && this.property) {
          controlArray.markAsTouched();
          controlArray.markAsDirty();
        }
      }
    }
    static {
      this.ɵfac = function WorkflowBuilderNodeFormFieldProcessComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WorkflowBuilderNodeFormFieldProcessComponent)(i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(AzavistaWorkflowBuilderController));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: WorkflowBuilderNodeFormFieldProcessComponent,
        selectors: [["azavista-workflow-builder-node-form-field-process"]],
        inputs: {
          property: "property",
          updateProcessCallback: "updateProcessCallback",
          isNewBuilderCompatible: "isNewBuilderCompatible"
        },
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 1,
        vars: 1,
        consts: [[4, "ngIf"], ["mat-flat-button", "", 3, "click", "disabled"]],
        template: function WorkflowBuilderNodeFormFieldProcessComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, WorkflowBuilderNodeFormFieldProcessComponent_ng_container_0_Template, 6, 8, "ng-container", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.property);
          }
        },
        dependencies: [i4.NgIf, i3.MatButton, i4$2.MatIcon, i7.TranslatePipe],
        styles: ["[_nghost-%COMP%]{display:block}button[_ngcontent-%COMP%]{width:100%;border:2px dashed #C2D8F8;border-radius:4px;padding-left:1em;padding-right:1em}button[_ngcontent-%COMP%]:hover{background-color:#eee;border-width:3px;padding-left:calc(1em - 1px);padding-right:calc(1em - 1px)}button[_ngcontent-%COMP%]:hover     .mat-mdc-button-persistent-ripple:before, button[_ngcontent-%COMP%]:hover   .mat-mdc-unelevated-button[_ngcontent-%COMP%]:hover   .mat-mdc-button-persistent-ripple[_ngcontent-%COMP%]:before{opacity:0}button.has-steps[_ngcontent-%COMP%]{background-color:#e4ffd7}button.has-steps[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{order:2;margin:0}button.has-steps[_ngcontent-%COMP%]     .mdc-button__label{flex:1;text-align:left}"]
      });
    }
  }
  return WorkflowBuilderNodeFormFieldProcessComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// eslint-disable-next-line max-len
let WorkflowBuilderNodeFormFieldAdvancedQueryComponent = /*#__PURE__*/(() => {
  class WorkflowBuilderNodeFormFieldAdvancedQueryComponent extends WorkflowBuilderNodeFormFieldBaseComponent {
    constructor(ngZone, host, controller) {
      super(ngZone, host);
      this.ngZone = ngZone;
      this.host = host;
      this.controller = controller;
      this.isAdvancedQueryConditionConfigured = isAdvancedQueryConditionConfigured;
    }
    async openCondition() {
      const factory = this.getFactory();
      this.control?.markAsTouched();
      const outputTypes = getSplitterOutputFromCondition(factory.type, this.property.attribute);
      const nextWorkflows = factory.getNextWorkflows();
      this.fieldClick.emit();
      const results = await this.updateAdvancedQueryCallback({
        condition: this.getCondition(),
        property: this.property,
        workflowId: this.workflowId,
        allowEmptyConditions: !outputTypes?.some(pin => nextWorkflows[pin])
      });
      if (results !== undefined && this.control && this.control instanceof FormArray) {
        const controlArray = this.control;
        const controlArrayToRemove = controlArray.controls.length;
        for (let index = 0; index < controlArrayToRemove; index++) {
          controlArray.removeAt(0);
        }
        (results ?? []).forEach(conditionItem => controlArray.push(createFormGroupFromData(conditionItem)));
        const updatedSettings = {
          ...factory.settings,
          [this.property.attribute]: results
        };
        this.control?.markAsDirty();
        if (this.workflowId && this.property) {
          this.controller.updateWorkflowSettings(this.workflowId, updatedSettings);
          if (results === null) {
            PROPERTY_ATTRIBUTE_TO_OUTPUT_PINS_DEPENDENTS[this.getFactory().type]?.[this.property.attribute]?.forEach(outputPin => {
              this.outputPinUpdate.emit({
                pin: outputPin,
                workflowId: null
              });
            });
          }
        }
      }
    }
    getFactory() {
      return this.controller.dataMap[this.workflowId]?.factory;
    }
    getCondition() {
      return this.getFactory()?.settings[this.property.attribute] ?? [];
    }
    static {
      this.ɵfac = function WorkflowBuilderNodeFormFieldAdvancedQueryComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WorkflowBuilderNodeFormFieldAdvancedQueryComponent)(i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(AzavistaWorkflowBuilderController));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: WorkflowBuilderNodeFormFieldAdvancedQueryComponent,
        selectors: [["azavista-workflow-builder-node-form-field-advanced-query"]],
        inputs: {
          property: "property",
          updateAdvancedQueryCallback: "updateAdvancedQueryCallback"
        },
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 1,
        vars: 1,
        consts: [[4, "ngIf"], ["mat-flat-button", "", 3, "click", "disabled"], [1, "is-configured-icon"]],
        template: function WorkflowBuilderNodeFormFieldAdvancedQueryComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, WorkflowBuilderNodeFormFieldAdvancedQueryComponent_ng_container_0_Template, 8, 6, "ng-container", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.property);
          }
        },
        dependencies: [i4.NgIf, i3.MatButton, i4$2.MatIcon, i7.TranslatePipe],
        styles: ["[_nghost-%COMP%]{display:block}button[_ngcontent-%COMP%]{width:100%;border:2px dashed #C2D8F8;border-radius:4px;padding-left:1em;padding-right:1em}button[_ngcontent-%COMP%] > mat-icon.is-configured-icon[_ngcontent-%COMP%]{display:none}button[_ngcontent-%COMP%]:hover{background-color:#eee;border-width:3px;padding-left:calc(1em - 1px);padding-right:calc(1em - 1px)}button[_ngcontent-%COMP%]:hover     .mat-mdc-button-persistent-ripple:before, button[_ngcontent-%COMP%]:hover   .mat-mdc-unelevated-button[_ngcontent-%COMP%]:hover   .mat-mdc-button-persistent-ripple[_ngcontent-%COMP%]:before{opacity:0}button.is-configured[_ngcontent-%COMP%]{background-color:#e4ffd7}button.is-configured[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{order:2;margin:0;display:none}button.is-configured[_ngcontent-%COMP%]   mat-icon.is-configured-icon[_ngcontent-%COMP%]{display:inline-block}button.is-configured[_ngcontent-%COMP%]     .mdc-button__label{flex:1;text-align:left}"]
      });
    }
  }
  return WorkflowBuilderNodeFormFieldAdvancedQueryComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let WorkflowBuilderNodeFormComponent = /*#__PURE__*/(() => {
  class WorkflowBuilderNodeFormComponent extends WorkflowBuilderNodeItemBase {
    get formContainer() {
      return this._formContainer;
    }
    set formContainer(value) {
      this._formContainer = value;
      if (value) {
        this.formLoaded.emit(value?.nativeElement);
      }
    }
    constructor(sharedSvc, host, controller, ngZone, cdr, formFieldService) {
      super(controller);
      this.sharedSvc = sharedSvc;
      this.host = host;
      this.controller = controller;
      this.ngZone = ngZone;
      this.cdr = cdr;
      this.formFieldService = formFieldService;
      this.fieldClick = new EventEmitter();
      this.formLoaded = new EventEmitter();
      this.attrNodeId = '';
      this.canDelete = false;
      this.alwaysExpandPanels = true;
      this.showFormEditHeader = false;
      this.hasBackground = false;
      this.properties = [];
      this.fields = [];
      this.trackByWorkflowProperty = trackByWorkflowProperty;
      this.formDestroyed$ = new Subject();
      this.getAttributePropertyOptions = attributeName => {
        const workflowType = this.controllerData?.factory?.type;
        return workflowType && this.propertyOptions?.[workflowType]?.[attributeName];
      };
      this.isBuilderCompatible = customProcessName => {
        return !!this.controllerData?.factory.isBuilderCompatible(customProcessName);
      };
    }
    ngOnDestroy() {
      this.formDestroyed$.next();
      this.formDestroyed$.complete();
    }
    async ngOnInit() {
      this.attrNodeId = this.node.id;
      const {
        controllerData
      } = this;
      if (!controllerData) {
        return;
      }
      this.workflowSettingsGroupedFieldData = await this.createWorkflowSettingsGroupFieldData(controllerData);
      this.initFormGroup(controllerData);
      this.canvasGroupFieldData = this.createCanvasGroupedFieldsData(controllerData);
      await firstValueFrom(this.ngZone.onStable);
      this.loadFieldsCssClass();
      this.cdr.detectChanges();
    }
    onKeyDown(event) {
      // prevent when typing on form get treated as moving or deleting workflow item
      event.stopPropagation();
    }
    initFormGroup(controllerData) {
      const {
        factory: originalFactory
      } = controllerData;
      const factory = copyWorkflowFactory(originalFactory);
      this.properties = factory.getProperties();
      this.formGroup = this.formFieldService.getFormGroupFromWorkflowFactory(this.properties, factory, this.stateCallbackMap);
      this.loadFieldState(factory);
      this.formGroup.valueChanges.pipe(debounceTime(200)).subscribe(async () => {
        const formDirtyValues = getFormDirtyValues(this.formGroup);
        factory.setValues(formDirtyValues);
        this.workflowSettingsChanges.emit(formDirtyValues);
        this.loadFieldState(factory);
      });
      this.formGroup.statusChanges.pipe(filter(status => status !== 'PENDING')).subscribe(() => {
        this.isFormValid = !this.formGroup?.invalid;
        this.cdr.detectChanges();
      });
    }
    loadFieldState(factory) {
      const stateCallbacks = this.stateCallbackMap[factory.type];
      this.fieldState = {};
      if (stateCallbacks) {
        objectKeys(stateCallbacks).forEach(key => {
          const stateCallbackItems = stateCallbacks[key];
          if (stateCallbackItems) {
            stateCallbackItems.forEach(stateCallback => {
              const stateValue = stateCallback.callback(factory);
              stateCallback.attributeNames.forEach(attributeName => {
                this.fieldState = {
                  ...this.fieldState,
                  [attributeName]: {
                    ...this.fieldState?.[attributeName],
                    [key]: stateValue
                  }
                };
              });
            });
          }
        });
      }
    }
    async createWorkflowSettingsGroupedFieldFields(factory) {
      const {
        dataProvider
      } = this.controller;
      if (!dataProvider) {
        return [];
      }
      return Promise.all(factory.getPropertiesWithSchema().map(property => {
        return this.formFieldService.getFieldFromWorkflowProperty(property, dataProvider, {
          eventId: this.eventId,
          workflowId: this.workflowId
        });
      }));
    }
    // eslint-disable-next-line max-len
    async createWorkflowSettingsGroupFieldData(controllerData) {
      const {
        factory
      } = controllerData;
      this.properties = factory.getProperties();
      const fields = await this.createWorkflowSettingsGroupedFieldFields(factory);
      this.fields = fields;
      this.workflowItem = factory.getWorkflow();
      return {
        singleColumn: true,
        editModeForAllFields: true,
        disableAutoOrdering: true,
        fieldsOptions: [{
          fieldId: 'sad',
          options: {}
        }],
        fieldsWithEntity: {
          entity: factory.getWorkflow().settings,
          fields
        },
        expandPanels: this.alwaysExpandPanels
      };
    }
    async toggleExpandPanels(expandPanels) {
      if (this.workflowSettingsGroupedFieldData) {
        this.workflowSettingsGroupedFieldData.expandPanels = expandPanels ?? !this.workflowSettingsGroupedFieldData.expandPanels;
      }
    }
    createCanvasGroupedFieldsData(controllerData) {
      const {
        name,
        description,
        factory: {
          type
        }
      } = controllerData;
      return {
        expandPanels: true,
        editModeForAllFields: true,
        singleColumn: true,
        disableAutoOrdering: true,
        fieldsWithEntity: {
          fields: this.formFieldService.getCanvasDataFields(type),
          entity: {
            name: name ?? this.sharedSvc.translate(WORKFLOW_NAME_TRANSLATIONS[type]),
            description: description ?? this.sharedSvc.translate(WORKFLOW_EXPLANATION_TRANSLATIONS[type])
          }
        }
      };
    }
    onUpdateCanvasFields(data) {
      this.canvasChanges.emit(data);
      if (this.canvasGroupFieldData?.fieldsWithEntity.entity) {
        this.canvasGroupFieldData.fieldsWithEntity.entity = {
          ...this.canvasGroupFieldData?.fieldsWithEntity.entity,
          ...data
        };
      }
    }
    loadFieldsCssClass() {
      this.controllerData?.factory.getProperties().forEach(properties => {
        const {
          attribute,
          datasource
        } = properties;
        if (datasource) {
          this.host.nativeElement.querySelector(`azavista-input-field[field-id=${attribute}]`)?.classList.add(`datasource-${datasource}`);
        }
      });
    }
    openProcessPopup() {
      alert('Opening Process Popup');
    }
    static {
      this.ɵfac = function WorkflowBuilderNodeFormComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WorkflowBuilderNodeFormComponent)(i0.ɵɵdirectiveInject(i1.AzavistaSharedService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(AzavistaWorkflowBuilderController), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(AzavistaWorkflowBuilderFormFieldService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: WorkflowBuilderNodeFormComponent,
        selectors: [["azavista-workflow-builder-node-form"]],
        viewQuery: function WorkflowBuilderNodeFormComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c6, 5, AzavistaGroupedFieldsComponent);
            i0.ɵɵviewQuery(_c7, 5);
            i0.ɵɵviewQuery(_c8, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.workflowSettingsGroupedFieldEl = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.formContainer = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.formHeader = _t.first);
          }
        },
        hostVars: 3,
        hostBindings: function WorkflowBuilderNodeFormComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown", function WorkflowBuilderNodeFormComponent_keydown_HostBindingHandler($event) {
              return ctx.onKeyDown($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("nodeId", ctx.attrNodeId);
            i0.ɵɵclassProp("workflow-builder-node-form--has-background", ctx.hasBackground);
          }
        },
        inputs: {
          workflowItemDestroyed: "workflowItemDestroyed",
          addFormFieldObservableCallback: "addFormFieldObservableCallback"
        },
        outputs: {
          fieldClick: "fieldClick",
          formLoaded: "formLoaded"
        },
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 2,
        vars: 2,
        consts: [["formContainer", ""], ["formHeader", ""], ["class", "workflow-builder-node-item", 3, "workflow-builder-node-item--valid", 4, "ngIf"], ["mode", "indeterminate", 4, "ngIf"], [1, "workflow-builder-node-item"], [3, "canvas", "workflowType", "canvasChanges", 4, "ngIf"], [1, "workflow-builder-node-item__fields"], [4, "ngIf"], ["class", "workflow-builder-node-item__footer", 4, "ngIf"], [1, "workflow-builder-node-item__absolute-elements"], ["class", "workflow-builder-node-item__absolute-elements__button-delete", "mat-icon-button", "", "color", "warn", 3, "click", 4, "ngIf"], [3, "canvasChanges", "canvas", "workflowType"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "eventId", "workflowId", "property", "hideLabel", "control", "workflowItemDestroyed", "addFormFieldObservableCallback", "fieldState", "workflow-builder-node-form-field--disabled", "propertyOptions", "outputPinUpdate", "fieldClick", 4, "ngIf"], [3, "eventId", "workflowId", "hideLabel", "property", "control", "workflowItemDestroyed", "addFormFieldObservableCallback", "fieldState", "propertyOptions", "workflow-builder-node-form-field--disabled", "outputPinUpdate", "fieldClick", 4, "ngIf"], [3, "eventId", "workflowId", "property", "hideLabel", "control", "workflowItemDestroyed", "addFormFieldObservableCallback", "fieldState", "propertyOptions", "updateProcessCallback", "isNewBuilderCompatible", "workflow-builder-node-form-field--disabled", "outputPinUpdate", "fieldClick", 4, "ngIf"], [3, "eventId", "workflowId", "property", "hideLabel", "updateAdvancedQueryCallback", "control", "workflowItemDestroyed", "addFormFieldObservableCallback", "fieldState", "propertyOptions", "workflow-builder-node-form-field--disabled", "outputPinUpdate", "fieldClick", 4, "ngIf"], [3, "outputPinUpdate", "fieldClick", "eventId", "workflowId", "property", "hideLabel", "control", "workflowItemDestroyed", "addFormFieldObservableCallback", "fieldState", "propertyOptions"], [3, "outputPinUpdate", "fieldClick", "eventId", "workflowId", "hideLabel", "property", "control", "workflowItemDestroyed", "addFormFieldObservableCallback", "fieldState", "propertyOptions"], [3, "outputPinUpdate", "fieldClick", "eventId", "workflowId", "property", "hideLabel", "control", "workflowItemDestroyed", "addFormFieldObservableCallback", "fieldState", "propertyOptions", "updateProcessCallback", "isNewBuilderCompatible"], [3, "outputPinUpdate", "fieldClick", "eventId", "workflowId", "property", "hideLabel", "updateAdvancedQueryCallback", "control", "workflowItemDestroyed", "addFormFieldObservableCallback", "fieldState", "propertyOptions"], [1, "workflow-builder-node-item__footer"], ["color", "primary", 3, "click"], ["mat-icon-button", "", "color", "warn", 1, "workflow-builder-node-item__absolute-elements__button-delete", 3, "click"], ["mode", "indeterminate"]],
        template: function WorkflowBuilderNodeFormComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, WorkflowBuilderNodeFormComponent_div_0_Template, 8, 8, "div", 2)(1, WorkflowBuilderNodeFormComponent_mat_progress_bar_1_Template, 1, 0, "mat-progress-bar", 3);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.workflowSettingsGroupedFieldData && ctx.canvasGroupFieldData);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.formContainer);
          }
        },
        dependencies: [i4.NgForOf, i4.NgIf, i3.MatIconButton, i4$2.MatIcon, i7$2.MatProgressBar, i4$4.AzavistaButtonComponent, WorkflowBuilderNodeFormHeaderComponent, WorkflowBuilderNodeFormFieldTextComponent, WorkflowBuilderNodeFormFieldSelectComponent, WorkflowBuilderNodeFormFieldSelectCapacityComponent, WorkflowBuilderNodeFormFieldToggleComponent, WorkflowBuilderNodeFormFieldProcessComponent, WorkflowBuilderNodeFormFieldAdvancedQueryComponent, i7.TranslatePipe, ApplyFunctionPipe],
        styles: ["*[_ngcontent-%COMP%]{--workflow-builder__diagram__font-size: 12px;--workflow-builder__diagram-form__font-size: 14px}[_nghost-%COMP%]{font-size:var(--workflow-builder__diagram-form__font-size);display:flex;position:relative;width:100%;max-width:100%;height:min-content;box-sizing:border-box;transition:opacity .3s}.workflow-builder-node-form--has-background[_nghost-%COMP%]{border:1px solid #ccc;background-color:#f5f4f5;border-radius:4px;padding:1em}[_nghost-%COMP%]     *, [_nghost-%COMP%]     .mat-mdc-slide-toggle .mdc-label{font-size:var(--workflow-builder__diagram-form__font-size);font-family:var(--azavista-font)}[_nghost-%COMP%]    {--mat-form-field-container-height: 36px;--mat-form-field-filled-label-display: none;--mat-form-field-container-vertical-padding: 6px;--mat-form-field-filled-with-label-container-padding-top: 6px;--mat-form-field-filled-with-label-container-padding-bottom: 6px}[_nghost-%COMP%]    {--mat-select-arrow-transform: none}[_nghost-%COMP%]     .mat-mdc-form-field .mat-mdc-text-field-wrapper{background-color:#fff}[_nghost-%COMP%]     .mat-mdc-form-field .mat-mdc-form-field-flex{height:auto!important;max-height:unset!important}[_nghost-%COMP%]     .mat-mdc-form-field .mat-mdc-text-field-wrapper.mdc-text-field--outlined{height:auto!important;max-height:unset!important}[_nghost-%COMP%]     .mat-mdc-form-field .mat-mdc-text-field-wrapper.mdc-text-field--outlined:hover{background-color:transparent}[_nghost-%COMP%]     .mat-mdc-form-field .mat-mdc-text-field-wrapper.mdc-text-field--outlined .mat-mdc-form-field-infix{padding:4px 0!important;min-height:auto}[_nghost-%COMP%]     .mat-mdc-form-field .mat-mdc-form-field-required-marker{color:var(--palette-warn-500)!important}[_nghost-%COMP%]     .mat-mdc-form-field.mat-form-field-not-empty.mat-form-field-hide-label .mdc-notched-outline__notch, [_nghost-%COMP%]     .mat-mdc-form-field.mat-focused.mat-form-field-hide-label .mdc-notched-outline__notch{width:0px!important;padding:0}[_nghost-%COMP%]     .mat-mdc-form-field.mat-form-field-not-empty.mat-form-field-hide-label label, [_nghost-%COMP%]     .mat-mdc-form-field.mat-focused.mat-form-field-hide-label label{display:none}[_nghost-%COMP%]     .mat-mdc-form-field.mat-form-field-not-empty:not(.mat-form-field-invalid){--mdc-outlined-text-field-outline-color: #4caf50}[_nghost-%COMP%]     .mat-mdc-form-field.mat-form-field-arrow-rotated .mat-mdc-select-arrow-wrapper{transform:rotate(180deg)}[_nghost-%COMP%]     azavista-duration .duration-container azavista-input-field:first-child{width:80px}[_nghost-%COMP%]     azavista-duration .duration-container azavista-input-field:last-child{width:calc(100% - 90px)}.hidden.hidden[class][_ngcontent-%COMP%]{display:none}.workflow-builder-node-item[_ngcontent-%COMP%]{display:flex;flex-direction:column;max-width:100%;width:100%;height:min-content;max-height:calc(var(--diagram-height) - 4em);gap:.8em}.workflow-builder-node-item__fields[_ngcontent-%COMP%]{display:flex;flex-direction:column;gap:.8em;height:0px;transition:.2s linear}.workflow-builder-node-item__fields--expanded[_ngcontent-%COMP%]{flex:1;min-height:4em;--padding-value: 8px;margin-inline-end:calc(0px - var(--padding-value));padding-inline-end:var(--padding-value);padding-block:var(--padding-value);overflow-y:auto;overflow-x:hidden}.workflow-builder-node-item__fields[_ngcontent-%COMP%]     mat-form-field{width:100%}.workflow-builder-node-item__fields[_ngcontent-%COMP%]     mat-form-field label:not(.mdc-floating-label--float-above){display:flex}.workflow-builder-node-item__fields[_ngcontent-%COMP%]     mat-form-field label:not(.mdc-floating-label--float-above) mat-label{flex:1 1 auto;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.workflow-builder-node-item__footer[_ngcontent-%COMP%]{display:flex;flex-direction:column}.workflow-builder-node-item__footer[_ngcontent-%COMP%]     .azavista-button-component.button-container{width:100%}.workflow-builder-node-item__footer[_ngcontent-%COMP%]     .azavista-button-component.button-container button{width:inherit;background-color:var(--palette-warn-500)}.workflow-builder-node-item__footer[_ngcontent-%COMP%]     .azavista-button-component.button-container .mdc-button__label{text-transform:uppercase}.workflow-builder-node-item__absolute-elements[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{position:absolute}.workflow-builder-node-item__absolute-elements__button-delete[_ngcontent-%COMP%]{--mdc-icon-button-icon-size: 16px;--mdc-icon-button-state-layer-size: calc(2 * var(--mdc-icon-button-icon-size));font-size:var(--mdc-icon-button-icon-size)!important;overflow:hidden;top:2px;right:2px;padding:8px}.workflow-builder-node-item__absolute-elements__button-delete[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{height:1em;width:1em;font-size:var(--mdc-icon-button-icon-size)}.workflow-builder-node-item--valid[_ngcontent-%COMP%]   .workflow-builder-node-item__footer[_ngcontent-%COMP%]     .azavista-button-component.button-container button{background-color:#98ca71}.workflow-builder-node-form-field--disabled[_ngcontent-%COMP%], .workflow-builder-node-form-field--disabled[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{opacity:.5;pointer-events:none;cursor:not-allowed}.workflow-builder-node-form-field--disabled[_ngcontent-%COMP%]:after{display:block;position:absolute;width:100%;height:100%;pointer-events:none}"]
      });
    }
  }
  return WorkflowBuilderNodeFormComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let WorkflowBuilderNodeItemEditDialogComponent = /*#__PURE__*/(() => {
  class WorkflowBuilderNodeItemEditDialogComponent {
    constructor(dialogRef, data) {
      this.dialogRef = dialogRef;
      this.data = data;
      this.result = undefined;
      this.formLoaded = new BehaviorSubject(undefined);
      this.hostClass = 'aza-cmp-padding-block';
    }
    updateResult(property, value) {
      this.result = {
        ...(this.result ?? {}),
        [property]: value
      };
    }
    onFieldClick(fieldProperty) {
      switch (fieldProperty.type) {
        case 'process':
          this.dialogRef.close(this.result);
          break;
        default:
          break;
      }
    }
    static {
      this.ɵfac = function WorkflowBuilderNodeItemEditDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WorkflowBuilderNodeItemEditDialogComponent)(i0.ɵɵdirectiveInject(i2$1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: WorkflowBuilderNodeItemEditDialogComponent,
        selectors: [["azavista-workflow-builder-node-item-edit-dialog"]],
        hostVars: 2,
        hostBindings: function WorkflowBuilderNodeItemEditDialogComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.hostClass);
          }
        },
        standalone: false,
        decls: 16,
        vars: 25,
        consts: [["formElement", ""], ["formHeader", ""], ["mat-dialog-title", "", 1, "aza-cmp-flex-column", "aza-cmp-half-gap"], [1, "aza-cmp-no-padding", "aza-cmp-no-margin"], [3, "canvas", "workflowType", "canvasChanges", 4, "ngIf"], ["mat-dialog-content", ""], [3, "canvasChanges", "outputPinUpdate", "workflowSettingsChanges", "fieldClick", "formLoaded", "node", "eventId", "stateCallbackMap", "updateAdvancedQueryCallback", "updateProcessCallback", "autoHideFieldLabel", "propertyOptions", "workflowItemDestroyed", "addFormFieldObservableCallback"], ["mat-dialog-actions", "", 1, "aza-cmp-flex-row", "aza-cmp-padding-inline-start", "aza-cmp-padding-inline-end"], [1, "aza-cmp-flex-row", "aza-cmp-flex-item-grow", 3, "mat-dialog-close", "containerCssClasses"], ["color", "primary", 1, "aza-cmp-flex-row", "aza-cmp-flex-item-grow", 3, "mat-dialog-close", "containerCssClasses"], [3, "canvasChanges", "canvas", "workflowType"]],
        template: function WorkflowBuilderNodeItemEditDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 2)(1, "h5", 3);
            i0.ɵɵtext(2);
            i0.ɵɵpipe(3, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, WorkflowBuilderNodeItemEditDialogComponent_azavista_workflow_builder_node_form_header_4_Template, 2, 2, "azavista-workflow-builder-node-form-header", 4);
            i0.ɵɵelement(5, "mat-divider");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 5)(7, "azavista-workflow-builder-node-form", 6, 0);
            i0.ɵɵlistener("canvasChanges", function WorkflowBuilderNodeItemEditDialogComponent_Template_azavista_workflow_builder_node_form_canvasChanges_7_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.updateResult("canvasChanges", $event));
            })("outputPinUpdate", function WorkflowBuilderNodeItemEditDialogComponent_Template_azavista_workflow_builder_node_form_outputPinUpdate_7_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.updateResult("outputPinUpdate", $event));
            })("workflowSettingsChanges", function WorkflowBuilderNodeItemEditDialogComponent_Template_azavista_workflow_builder_node_form_workflowSettingsChanges_7_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.updateResult("workflowSettingsChanges", $event));
            })("fieldClick", function WorkflowBuilderNodeItemEditDialogComponent_Template_azavista_workflow_builder_node_form_fieldClick_7_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onFieldClick($event));
            })("formLoaded", function WorkflowBuilderNodeItemEditDialogComponent_Template_azavista_workflow_builder_node_form_formLoaded_7_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.formLoaded.next($event));
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(9, "div", 7)(10, "azavista-button", 8);
            i0.ɵɵtext(11);
            i0.ɵɵpipe(12, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(13, "azavista-button", 9);
            i0.ɵɵtext(14);
            i0.ɵɵpipe(15, "translate");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 17, "EDIT_DETAILS"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.data.controllerData && ctx.data.controllerData);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("node", ctx.data.node)("eventId", ctx.data.eventId)("stateCallbackMap", ctx.data.stateCallbackMap)("updateAdvancedQueryCallback", ctx.data.updateAdvancedQueryCallback)("updateProcessCallback", ctx.data.updateProcessCallback)("autoHideFieldLabel", ctx.data.autoHideFieldLabel)("propertyOptions", ctx.data.propertyOptions)("workflowItemDestroyed", ctx.data.workflowItemDestroyed)("addFormFieldObservableCallback", ctx.data.addFormFieldObservableCallback);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("mat-dialog-close", undefined)("containerCssClasses", i0.ɵɵpureFunction0(23, _c9));
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 19, "CANCEL"), "");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("mat-dialog-close", ctx.result)("containerCssClasses", i0.ɵɵpureFunction0(24, _c9));
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 21, "SAVE"));
          }
        },
        dependencies: [i4.NgIf, i9.MatDivider, i2$1.MatDialogClose, i2$1.MatDialogTitle, i2$1.MatDialogActions, i2$1.MatDialogContent, i4$4.AzavistaButtonComponent, WorkflowBuilderNodeFormComponent, WorkflowBuilderNodeFormHeaderComponent, i7.TranslatePipe],
        styles: ["[_nghost-%COMP%]{display:block;position:relative;width:100%}[mat-dialog-title][_ngcontent-%COMP%]{border:0px;border-bottom:0px;display:flex}[mat-dialog-title][_ngcontent-%COMP%]:before{display:none}[mat-dialog-actions][_ngcontent-%COMP%]{border:0px;border-top:0px;padding:0px var(--aza-cmp-double-stack-gap);justify-content:center;width:100%}.sticky-top[_ngcontent-%COMP%]{position:sticky;top:0}azavista-button.aza-cmp-flex-item-grow[_ngcontent-%COMP%]     button{width:100%}  .mat-mdc-dialog-container:has(azavista-workflow-builder-node-item-edit-dialog){min-width:unset!important;width:360px}"],
        changeDetection: 0
      });
    }
  }
  return WorkflowBuilderNodeItemEditDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ClickOutsideDirective = /*#__PURE__*/(() => {
  class ClickOutsideDirective {
    constructor(elementRef) {
      this.elementRef = elementRef;
      this.clickOutside = new EventEmitter();
    }
    onMouseEnter(event) {
      const targetElement = event.target;
      const clickedInside = this.elementRef.nativeElement.contains(targetElement);
      if (!clickedInside) {
        this.clickOutside.emit(null);
      }
    }
    static {
      this.ɵfac = function ClickOutsideDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ClickOutsideDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: ClickOutsideDirective,
        selectors: [["", "clickOutside", ""]],
        hostBindings: function ClickOutsideDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function ClickOutsideDirective_click_HostBindingHandler($event) {
              return ctx.onMouseEnter($event);
            }, false, i0.ɵɵresolveDocument);
          }
        },
        outputs: {
          clickOutside: "clickOutside"
        }
      });
    }
  }
  return ClickOutsideDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * The `WorkflowBuilderNodeItemComponent` should not be destroyed unless the workflow is deleted
 * This is because we depend on `WorkflowBuilderNodeItemComponent.workflowItemDestroyed` to stop the updateProcess's Observable
 */
let WorkflowBuilderNodeItemComponent = /*#__PURE__*/(() => {
  class WorkflowBuilderNodeItemComponent extends WorkflowBuilderNodeItemBase {
    constructor(controller, dialog, ngZone, cdr) {
      super(controller);
      this.controller = controller;
      this.dialog = dialog;
      this.ngZone = ngZone;
      this.cdr = cdr;
      this.isMenuOpen = false;
      /** Currently, we assume the workflow-item will be destroyed only when the workflow is deleted */
      this.workflowItemDestroyed$ = new Subject();
    }
    ngOnInit() {
      this.formHeaderCanvas = this.controllerData;
    }
    ngOnDestroy() {
      this.workflowItemDestroyed$.next();
      this.workflowItemDestroyed$.complete();
    }
    toggleIsMenuOpen(forceValue) {
      const newIsMenuOpenValue = forceValue ?? !this.isMenuOpen;
      if (this.controllerData?.locked && newIsMenuOpenValue) {
        return;
      }
      this.isMenuOpen = newIsMenuOpenValue;
      this.cdr.markForCheck();
    }
    async toggleCanvasLocked(forceValue) {
      const newLockedValue = forceValue ?? !this.controllerData?.locked;
      this.canvasChanges.emit({
        locked: newLockedValue
      });
      await delay$1(200);
      this.toggleIsMenuOpen(!newLockedValue);
    }
    async openEditDialog() {
      const addFormFieldObservableCallback = (property, observable) => {
        if (!this.formFieldSubscription[property.attribute]) {
          this.formFieldSubscription[property.attribute] = observable.pipe(takeUntil(this.workflowItemDestroyed$)).subscribe(result => {
            if (result !== undefined) {
              switch (property.type) {
                case 'process':
                  this.controller.updateWorkflowProcess(this.workflowId, property.attribute, result);
                  break;
                default:
                  break;
              }
            }
          });
        }
      };
      const dialogData = {
        ...pick(this, ['node', 'eventId', 'stateCallbackMap', 'propertyOptions', 'updateProcessCallback', 'updateAdvancedQueryCallback', 'autoHideFieldLabel', 'controllerData']),
        workflowItemDestroyed: this.workflowItemDestroyed$,
        addFormFieldObservableCallback
      };
      const dialogRef = this.dialog.open(WorkflowBuilderNodeItemEditDialogComponent, {
        data: dialogData
      });
      firstValueFrom(dialogRef.afterClosed()).then(dialogResult => this.handleEditDialogResult(dialogResult));
      return dialogRef;
    }
    handleEditDialogResult(dialogResult) {
      if (dialogResult) {
        objectKeys(dialogResult).forEach(propertyKey => {
          const propertyValue = dialogResult[propertyKey];
          if (propertyValue !== undefined) {
            this[propertyKey].emit(propertyValue);
            if (propertyKey === 'canvasChanges') {
              this.formHeaderCanvas = propertyValue;
              this.formHeaderEl?.ngOnInit();
            }
          }
        });
      }
    }
    onMouseEvent(type) {
      switch (type) {
        case 'mouseup':
          {
            const now = new Date();
            const timeDifference = now.getTime() - (this.mouseDownTime?.getTime() || 0);
            if (timeDifference < 500) {
              this.toggleIsMenuOpen(true);
            }
            break;
          }
        case 'mousedown':
          {
            this.mouseDownTime = new Date();
            break;
          }
      }
    }
    static {
      this.ɵfac = function WorkflowBuilderNodeItemComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WorkflowBuilderNodeItemComponent)(i0.ɵɵdirectiveInject(AzavistaWorkflowBuilderController), i0.ɵɵdirectiveInject(i2$1.MatDialog), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: WorkflowBuilderNodeItemComponent,
        selectors: [["azavista-workflow-builder-node-item"]],
        viewQuery: function WorkflowBuilderNodeItemComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c10, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.formHeaderEl = _t.first);
          }
        },
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 6,
        vars: 11,
        consts: [["formHeaderEl", ""], [1, "workflow-builder-node-item", 3, "mousedown", "clickOutside", "mouseup"], ["class", "workflow-builder-node-item__menu", 4, "ngIf"], [1, "workflow-builder-node-item__content", 3, "ngClass"], [3, "canvas", "workflowType", "disableEditMode", 4, "ngIf"], [1, "workflow-builder-node-item__floating-content"], ["class", "workflow-builder-node-item__floating-content__button-unlock", 3, "click", 4, "ngIf"], [1, "workflow-builder-node-item__menu"], [1, "workflow-builder-node-item__menu__edit", 3, "click"], ["class", "workflow-builder-node-item__menu__button-lock", 3, "click", 4, "ngIf"], ["color", "warn", 1, "workflow-builder-node-item__menu__delete", 3, "click"], [1, "workflow-builder-node-item__menu__button-lock", 3, "click"], [1, "workflow-builder-node-item__menu__button-lock__icon-lock"], [1, "workflow-builder-node-item__menu__button-lock__icon-unlock"], [3, "canvas", "workflowType", "disableEditMode"], [1, "workflow-builder-node-item__floating-content__button-unlock", 3, "click"], [1, "workflow-builder-node-item__floating-content__button-unlock__icon-lock"], [1, "workflow-builder-node-item__floating-content__button-unlock__icon-unlock"]],
        template: function WorkflowBuilderNodeItemComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵlistener("mousedown", function WorkflowBuilderNodeItemComponent_Template_div_mousedown_0_listener() {
              return ctx.onMouseEvent("mousedown");
            })("clickOutside", function WorkflowBuilderNodeItemComponent_Template_div_clickOutside_0_listener() {
              return ctx.toggleIsMenuOpen(false);
            })("mouseup", function WorkflowBuilderNodeItemComponent_Template_div_mouseup_0_listener() {
              return ctx.onMouseEvent("mouseup");
            });
            i0.ɵɵtemplate(1, WorkflowBuilderNodeItemComponent_div_1_Template, 10, 4, "div", 2);
            i0.ɵɵelementStart(2, "div", 3);
            i0.ɵɵtemplate(3, WorkflowBuilderNodeItemComponent_azavista_workflow_builder_node_form_header_3_Template, 2, 3, "azavista-workflow-builder-node-form-header", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 5);
            i0.ɵɵtemplate(5, WorkflowBuilderNodeItemComponent_azavista_flat_button_5_Template, 5, 0, "azavista-flat-button", 6);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("workflow-builder-node-item--invalid", !ctx.isWorkflowValid)("workflow-builder-node-item--locked", ctx.controllerData == null ? null : ctx.controllerData.locked);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isMenuOpen);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(8, _c11, !(ctx.controllerData == null ? null : ctx.controllerData.locked), !(ctx.controllerData == null ? null : ctx.controllerData.locked)));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.controllerData && ctx.formHeaderCanvas);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.controllerData == null ? null : ctx.controllerData.locked);
          }
        },
        dependencies: [i4.NgClass, i4.NgIf, i4$2.MatIcon, i4$4.AzavistaFlatButtonComponent, ClickOutsideDirective, WorkflowBuilderNodeFormHeaderComponent, i7.TranslatePipe],
        styles: ["azavista-workflow-builder-node-item{display:block}.workflow-builder-node-item{display:block;-webkit-user-select:none;-ms-user-select:none;user-select:none}.workflow-builder-node-item__menu{display:flex;gap:.5em;align-items:center;width:min-content;position:absolute;bottom:calc(100% + .5em);left:50%;transform:translate(-50%);padding:.5em 1em;border-radius:.5em;border:1px solid #f5f4f5;background-color:#fff;box-shadow:0 2px 8px #0000004d}.workflow-builder-node-item__menu{--mdc-text-button-container-height: 24px}.workflow-builder-node-item__menu{--mdc-filled-button-container-height: 24px}.workflow-builder-node-item__menu{--mdc-protected-button-container-height: 24px}.workflow-builder-node-item__menu{--mdc-outlined-button-container-height: 24px}.workflow-builder-node-item__menu{--mat-text-button-touch-target-display: none}.workflow-builder-node-item__menu{--mat-filled-button-touch-target-display: none}.workflow-builder-node-item__menu{--mat-protected-button-touch-target-display: none}.workflow-builder-node-item__menu{--mat-outlined-button-touch-target-display: none}.workflow-builder-node-item__menu button{padding:0 2px;min-width:unset}.workflow-builder-node-item__menu__button-lock__icon-lock{display:none}.workflow-builder-node-item__menu__button-lock:hover .workflow-builder-node-item__menu__button-lock__icon-lock{display:inline-block}.workflow-builder-node-item__menu__button-lock:hover .workflow-builder-node-item__menu__button-lock__icon-unlock{display:none}.workflow-builder-node-item__content{display:flex;flex-direction:column;padding:1em;border-radius:.5em;border:1px solid #f5f4f5;background-color:#fff;box-shadow:0 1px 2px #0006}.workflow-builder-node-item__floating-content{position:absolute;right:.5em;top:.5em}.workflow-builder-node-item__floating-content{--mdc-text-button-container-height: 24px}.workflow-builder-node-item__floating-content{--mdc-filled-button-container-height: 24px}.workflow-builder-node-item__floating-content{--mdc-protected-button-container-height: 24px}.workflow-builder-node-item__floating-content{--mdc-outlined-button-container-height: 24px}.workflow-builder-node-item__floating-content{--mat-text-button-touch-target-display: none}.workflow-builder-node-item__floating-content{--mat-filled-button-touch-target-display: none}.workflow-builder-node-item__floating-content{--mat-protected-button-touch-target-display: none}.workflow-builder-node-item__floating-content{--mat-outlined-button-touch-target-display: none}.workflow-builder-node-item__floating-content button{padding:0 2px;min-width:unset}.workflow-builder-node-item__floating-content__button-unlock mat-icon{transition:.1s}.workflow-builder-node-item__floating-content__button-unlock__icon-unlock{display:none}.workflow-builder-node-item__floating-content__button-unlock:hover .workflow-builder-node-item__floating-content__button-unlock__icon-unlock{display:inline-block}.workflow-builder-node-item__floating-content__button-unlock:hover .workflow-builder-node-item__floating-content__button-unlock__icon-lock{display:none}.workflow-builder-node-item--invalid .workflow-builder-node-item__header__name:after,.workflow-builder-node-item--invalid .workflow-builder-node-item__menu__edit .mdc-button__label:after{display:inline-flex;content:\"*\";color:var(--palette-warn-500)}.workflow-builder-node-item--locked:hover .workflow-builder-node-item__floating-content__button-unlock mat-icon{font-size:20px;filter:drop-shadow(0px 0px 4px var(--palette-primary-300))}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return WorkflowBuilderNodeItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let WorkflowBuilderLocalConfigService = /*#__PURE__*/(() => {
  class WorkflowBuilderLocalConfigService {
    constructor() {
      this.storageKey = `azavista.workflow-builder.local-config`;
      this.config$ = new BehaviorSubject(this.getCurrentConfig());
    }
    async readItem(key) {
      const currentConfig = await this.getCurrentConfig();
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return currentConfig?.[key] ?? null;
    }
    getCurrentConfig() {
      const formattedKey = this.storageKey;
      const stringValue = localStorage?.getItem(formattedKey);
      return stringValue && jsonParse$1(stringValue) || null;
    }
    async assignItem(key, newValue) {
      const formattedKey = this.storageKey;
      const currentConfig = await this.getCurrentConfig();
      const newConfig = {
        ...currentConfig,
        [key]: newValue
      };
      this.config$.next(newConfig);
      const valueToStore = JSON.stringify(newConfig);
      localStorage.setItem(formattedKey, valueToStore);
    }
    static {
      this.ɵfac = function WorkflowBuilderLocalConfigService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WorkflowBuilderLocalConfigService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: WorkflowBuilderLocalConfigService,
        factory: WorkflowBuilderLocalConfigService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return WorkflowBuilderLocalConfigService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let WorkflowBuilderDiagramNodeAutoHeightDirective = /*#__PURE__*/(() => {
  class WorkflowBuilderDiagramNodeAutoHeightDirective {
    constructor(host, resize$, ngZone) {
      this.host = host;
      this.resize$ = resize$;
      this.ngZone = ngZone;
    }
    ngOnInit() {
      this.resize$.pipe(debounceTime$1(50)).subscribe(async () => {
        this.updateNodeInstanceHeight();
        await firstValueFrom$1(this.ngZone.onStable);
        this.updateNodeInstanceHeight();
        await firstValueFrom$1(this.ngZone.onStable);
        this.updateNodeInstanceHeight();
      });
    }
    updateNodeInstanceHeight() {
      const rect = this.host.nativeElement.getBoundingClientRect();
      const nodeInstance = this.getNodeInstance();
      if (nodeInstance && nodeInstance.height !== rect?.height) {
        nodeInstance.height = rect?.height;
      }
    }
    getNodeInstance() {
      return getDiagramNodeInstance(this.diagramEl, this.node.id);
    }
    static {
      this.ɵfac = function WorkflowBuilderDiagramNodeAutoHeightDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WorkflowBuilderDiagramNodeAutoHeightDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1$2.NgResizeObserver), i0.ɵɵdirectiveInject(i0.NgZone));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: WorkflowBuilderDiagramNodeAutoHeightDirective,
        selectors: [["", "azavistaWorkflowBuilderDiagramNodeAutoHeight", ""]],
        inputs: {
          diagramEl: "diagramEl",
          node: "node"
        },
        features: [i0.ɵɵProvidersFeature([...ngResizeObserverProviders])]
      });
    }
  }
  return WorkflowBuilderDiagramNodeAutoHeightDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let WorkflowBuilderPaletteComponent = /*#__PURE__*/(() => {
  class WorkflowBuilderPaletteComponent {
    set workflowTypeCategories(value) {
      this.paletteCategoryMap = getPaletteCategoryMap(value);
    }
    constructor(sharedSvc, ngZone, builderService) {
      this.sharedSvc = sharedSvc;
      this.ngZone = ngZone;
      this.builderService = builderService;
      this.palettes = [];
      this.paletteCategories = PALETTE_CATEGORIES_ORDER;
      this.expandMode = 'Multiple';
      this.trackByString = (index, data) => data;
      this.getPalettesFromPaletteCategories = async searchText => {
        await firstValueFrom(this.builderService.translationsLoaded());
        return PALETTE_CATEGORIES_ORDER.map(category => this.getPaletteModelFromPaletteCategory(searchText, category));
      };
      /** `getSymbolInfo` should use arrow-function instead of method, because the method later is bind with syncfusion instead of current component  */
      this.getSymbolInfo = (
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      symbol) => {
        return {
          fit: true,
          width: 100,
          height: 72,
          tooltip: ' ',
          description: {
            text: '',
            wrap: 'Wrap',
            overflow: 'Wrap',
            margin: {
              left: 0,
              right: 0,
              top: 0,
              bottom: 0
            }
          }
        };
      };
      this.getPaletteModelFromPaletteCategory = (searchText, category) => {
        const symbols = this.paletteCategoryMap?.[category]?.filter(paletteSymbol => this.isWorkflowNameContainsSearchText(searchText, paletteSymbol))?.map(paletteSymbol => getNodeModelForPalette(paletteSymbol, this.sharedSvc)) ?? [];
        const paletteModel = {
          id: category,
          title: `${this.sharedSvc.translate(category)} ${searchText ? `(${symbols?.length ?? 0})` : ''}`,
          expanded: true,
          symbols
        };
        return paletteModel;
      };
      this.isWorkflowNameContainsSearchText = (searchText, paletteSymbol) => {
        return this.sharedSvc.translate(WORKFLOW_NAME_TRANSLATIONS[paletteSymbol]).toLowerCase()?.includes(searchText.toLowerCase());
      };
      this.getPalettesFromPaletteCategories('').then(palettes => {
        this.palettes = palettes;
      });
    }
    onHostClick(event) {
      const srcElement = event.srcElement;
      const paletteCategoryHeaderEl = this.getPaletteCategoryHeaderElementFromParent(srcElement);
      if (paletteCategoryHeaderEl) {
        const paletteCategoryContainerEl = this.getPaletteCategoryContainerElementFromParent(paletteCategoryHeaderEl);
        paletteCategoryContainerEl?.classList.toggle('e-acrdn-item--hide-content');
      }
    }
    getPaletteCategoryHeaderElementFromParent(element) {
      if (element.classList.contains('e-acrdn-header')) {
        return element;
      }
      if (this.isElementPaletteCategoryContainer(element) || this.isElementHostContainer(element)) {
        return null;
      }
      return element.parentElement ? this.getPaletteCategoryHeaderElementFromParent(element.parentElement) : null;
    }
    getPaletteCategoryContainerElementFromParent(element) {
      if (this.isElementPaletteCategoryContainer(element)) {
        return element;
      }
      if (this.isElementHostContainer(element)) {
        return null;
      }
      return element.parentElement ? this.getPaletteCategoryContainerElementFromParent(element.parentElement) : null;
    }
    isElementHostContainer(element) {
      return element.tagName === 'azavista-workflow-builder-workflow-builder-palette';
    }
    isElementPaletteCategoryContainer(element) {
      return element.classList.contains('e-acrdn-item');
    }
    static {
      this.ɵfac = function WorkflowBuilderPaletteComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WorkflowBuilderPaletteComponent)(i0.ɵɵdirectiveInject(i1.AzavistaSharedService), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(WorkflowBuilderService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: WorkflowBuilderPaletteComponent,
        selectors: [["azavista-workflow-builder-workflow-builder-palette"]],
        hostBindings: function WorkflowBuilderPaletteComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function WorkflowBuilderPaletteComponent_click_HostBindingHandler($event) {
              return ctx.onHostClick($event);
            });
          }
        },
        inputs: {
          workflowTypeCategories: "workflowTypeCategories"
        },
        standalone: false,
        decls: 8,
        vars: 12,
        consts: [["searchText", ""], ["symbolpalette", ""], ["matInput", "", 3, "placeholder"], ["id", "symbolpalette", 3, "enableAnimation", "expandMode", "palettes", "getSymbolInfo"]],
        template: function WorkflowBuilderPaletteComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-form-field");
            i0.ɵɵelement(1, "input", 2, 0);
            i0.ɵɵpipe(3, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(4, "ejs-symbolpalette", 3, 1);
            i0.ɵɵpipe(6, "apply");
            i0.ɵɵpipe(7, "async");
          }
          if (rf & 2) {
            const searchText_r1 = i0.ɵɵreference(2);
            i0.ɵɵadvance();
            i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(3, 5, "TYPE_TO_FILTER_BLOCKS"));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("enableAnimation", true)("expandMode", ctx.expandMode)("palettes", i0.ɵɵpipeBind1(7, 10, i0.ɵɵpipeBind2(6, 7, searchText_r1.value, ctx.getPalettesFromPaletteCategories)))("getSymbolInfo", ctx.getSymbolInfo);
          }
        },
        dependencies: [i5.MatFormField, i4$1.MatInput, i5$3.SymbolPaletteComponent, i4.AsyncPipe, i7.TranslatePipe, ApplyFunctionPipe],
        styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;position:relative;overflow:visible;font-size:12px;height:100%}[_nghost-%COMP%]     *{font-size:12px}html[_ngcontent-%COMP%]{--mat-form-field-container-height: 36px;--mat-form-field-filled-label-display: none;--mat-form-field-container-vertical-padding: 6px;--mat-form-field-filled-with-label-container-padding-top: 6px;--mat-form-field-filled-with-label-container-padding-bottom: 6px}mat-form-field[_ngcontent-%COMP%]{width:100%;padding:.5em 10px 1em;box-sizing:border-box}mat-form-field[_ngcontent-%COMP%]     .mat-mdc-text-field-wrapper{background-color:#fff;border-radius:0!important}mat-form-field[_ngcontent-%COMP%]     .mat-mdc-form-field-flex{height:auto!important;max-height:unset!important}mat-form-field[_ngcontent-%COMP%]     .mat-mdc-text-field-wrapper.mdc-text-field--outlined{height:auto!important;max-height:unset!important}mat-form-field[_ngcontent-%COMP%]     .mat-mdc-text-field-wrapper.mdc-text-field--outlined .mat-mdc-form-field-infix{padding:8px 0!important;min-height:auto}ejs-symbolpalette[_ngcontent-%COMP%]{display:block;position:relative;overflow:auto;margin-top:-4px}ejs-symbolpalette[_ngcontent-%COMP%]     .e-acrdn-header{display:flex;align-items:center;justify-content:flex-start;gap:.2em;margin:0 10px;border-radius:4px;padding:4px 0;font-weight:500;color:#666;cursor:pointer}ejs-symbolpalette[_ngcontent-%COMP%]     .e-acrdn-header-content{order:1;flex:1;font-size:1.2em;font-weight:600}ejs-symbolpalette[_ngcontent-%COMP%]     .e-acrdn-content .e-symbol-draggable{cursor:grab}ejs-symbolpalette[_ngcontent-%COMP%]     .e-acrdn-content:after{display:block;height:1px;background-color:#eee;width:calc(100% - 2em);margin:1em auto .5em;content:\"\"}ejs-symbolpalette[_ngcontent-%COMP%]     .e-remove-palette{overflow:hidden}ejs-symbolpalette[_ngcontent-%COMP%]     .e-toggle-icon{transition:.3s;transform:rotate(180deg)}ejs-symbolpalette[_ngcontent-%COMP%]     .e-tgl-collapse-icon.e-icons:before{font-family:Material Icons;content:\"\\e5c7\";font-size:2em;line-height:1em;transition:.3s}ejs-symbolpalette[_ngcontent-%COMP%]     .e-acrdn-item.e-acrdn-item--hide-content .e-toggle-icon{transform:rotate(90deg);color:#ccc}ejs-symbolpalette[_ngcontent-%COMP%]     .e-acrdn-item.e-acrdn-item--hide-content .e-remove-palette{height:0px;opacity:0}  .e-symbol-draggable>canvas{background-color:transparent}  .palette-item{box-sizing:border-box;display:flex;flex-direction:column;gap:4px;position:relative;width:100%;min-width:115px;height:100%;padding:2px 4px;align-items:center;justify-content:space-evenly;background-color:#f5f6f8;border-radius:10px}  .palette-item__inner{display:flex;position:relative;width:40px;height:24px;border-radius:4px;align-items:center;justify-content:center;box-sizing:border-box;color:transparent}  .palette-item__inner svg{height:100%}  .palette-item__title{font-size:10px;text-align:center;margin:0 auto;text-transform:uppercase}  .palette-item__icon{color:#a6a6a6;font-size:40px;margin:auto;position:absolute}  .palette-item__input,   .palette-item__output,   .palette-item__decline-input,   .palette-item__decline-output,   .palette-item__cancellation-input,   .palette-item__cancellation-output{display:block;border-radius:50%;background-color:#fff;border:1px solid #a6a6a6;height:4.9px;width:4.9px;position:absolute;top:50%;transform:translateY(-50%)}  .palette-item__input{left:2px}  .palette-item__output{border-color:#bbb;right:0}  .palette-item__decline-input,   .palette-item__cancellation-input{top:4px;left:50%;transform:translateY(-50%) translate(-40%)}  .palette-item__decline-output,   .palette-item__cancellation-output{top:100%;left:50%;transform:translateY(-100%) translate(-50%)}  #create-work-block_container{pointer-events:none;opacity:.2}mat-expansion-panel[_ngcontent-%COMP%]{border:none!important;background:transparent;box-shadow:none!important;margin:0}mat-expansion-panel[_ngcontent-%COMP%]     .mat-expansion-panel-body{padding:0}.mat-expansion-panel-header[_ngcontent-%COMP%]{background-color:#fff!important;margin:0 10px;border:1px solid #a6a6a6}"]
      });
    }
  }
  return WorkflowBuilderPaletteComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaWorkflowBuilderZoomSelectComponent = /*#__PURE__*/(() => {
  class AzavistaWorkflowBuilderZoomSelectComponent {
    constructor(zoomSvc) {
      this.zoomSvc = zoomSvc;
      this.zoomChanges = new EventEmitter();
    }
    updateZoom(newZoomValue) {
      this.zoomSvc.updateZoom(newZoomValue);
      this.zoomChanges.emit(this.zoomSvc.getZoomChanges());
    }
    static {
      this.ɵfac = function AzavistaWorkflowBuilderZoomSelectComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaWorkflowBuilderZoomSelectComponent)(i0.ɵɵdirectiveInject(AzavistaWorkflowBuilderZoomService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AzavistaWorkflowBuilderZoomSelectComponent,
        selectors: [["azavista-workflow-builder-zoom-select"]],
        outputs: {
          zoomChanges: "zoomChanges"
        },
        standalone: false,
        decls: 8,
        vars: 6,
        consts: [["matInput", "", 1, "workflow-builder-div__diagram-area__toolbar__tool-zoom", 3, "selectionChange", "value"], [1, "aza-cmp-flex-row", "aza-cmp-no-gap"], ["class", "workflow-builder-div__diagram-area__toolbar__tool-zoom__option", 3, "value", 4, "ngFor", "ngForOf"], [1, "workflow-builder-div__diagram-area__toolbar__tool-zoom__option", 3, "value"]],
        template: function AzavistaWorkflowBuilderZoomSelectComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-select", 0);
            i0.ɵɵlistener("selectionChange", function AzavistaWorkflowBuilderZoomSelectComponent_Template_mat_select_selectionChange_0_listener($event) {
              return ctx.updateZoom($event.value);
            });
            i0.ɵɵelementStart(1, "mat-select-trigger")(2, "div", 1)(3, "mat-icon");
            i0.ɵɵtext(4, "zoom_in");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(5);
            i0.ɵɵpipe(6, "number");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(7, AzavistaWorkflowBuilderZoomSelectComponent_mat_option_7_Template, 3, 5, "mat-option", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("value", ctx.zoomSvc.zoomValue);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(6, 3, ctx.zoomSvc.zoomValue * 100, "1.0-0"), " % ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.zoomSvc.zoomOptions);
          }
        },
        dependencies: [i4.NgForOf, i4$2.MatIcon, i4$3.MatSelect, i4$3.MatSelectTrigger, i4$3.MatOption, i4.DecimalPipe],
        styles: ["[_nghost-%COMP%]{display:flex;align-items:center;border:1px solid #ccc;background-color:#fff;border-radius:8px;box-shadow:0 0 1em #ccc}[_nghost-%COMP%]   *[_ngcontent-%COMP%]{font-size:14px}[_nghost-%COMP%]   mat-select[_ngcontent-%COMP%]{display:flex;align-items:center;padding:4px}[_nghost-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:2em;height:1em;width:1em}"]
      });
    }
  }
  return AzavistaWorkflowBuilderZoomSelectComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/ban-ts-comment */
let WorkflowBuilderComponent = /*#__PURE__*/(() => {
  class WorkflowBuilderComponent extends AzavistaWorkflowBuilderBaseDirective {
    get nodeItems() {
      return this._nodeItems;
    }
    set nodeItems(value) {
      this._nodeItems = value;
      if (value) {
        this.nodeItemsLoaded.emit(Array.from(value));
      }
    }
    constructor(builderSvc, controller, host, resize$, sharedSvc, notificationSvc, translateService, zoomSvc, ngZone, sanitizer, localConfigService) {
      super(ngZone);
      this.builderSvc = builderSvc;
      this.controller = controller;
      this.host = host;
      this.resize$ = resize$;
      this.sharedSvc = sharedSvc;
      this.notificationSvc = notificationSvc;
      this.translateService = translateService;
      this.zoomSvc = zoomSvc;
      this.ngZone = ngZone;
      this.sanitizer = sanitizer;
      this.localConfigService = localConfigService;
      /** Fill this to use custom dataProvider */
      this.dataProvider = this.builderSvc.dataProvider;
      this.nodeItemsLoaded = new EventEmitter();
      this.diagramConfig = {
        constraints: DiagramConstraints.Default & ~DiagramConstraints.Tooltip,
        snapSettings: {
          constraints: SnapConstraints.SnapToObject
        },
        getConnectorDefaults: () => ({
          ...DEFAULT_CONNECTOR
        }),
        drawingObject: {
          ...DEFAULT_CONNECTOR
        }
      };
      this.tool = DiagramTools.SingleSelect | DiagramTools.ZoomPan;
      this.paletteConfig = {
        palettes: [],
        getSymbolInfo: () => {}
      };
      this.isInitialized = false;
      this.ongoingValidNextWorkflowIdMap = null;
      this.isDraggingConnector = false;
      this.isHidingPalette = false;
      this.currentZoom = DEFAULT_ZOOM_VALUE;
      this.localConfig$ = this.localConfigService.config$;
      this.onDestroyed$ = new Subject();
      this.hasNodeSelectedAndExpanded = selectedNodes => {
        const selectedNodeMap = getMapByValue(selectedNodes, 'id');
        return !!this.nodeForms?.some(node => !!selectedNodeMap[node.node.id] && (!!node.formHeader?.editMode || !!node.workflowSettingsGroupedFieldData?.expandPanels));
      };
      this.areWorkflowsValid = validityMap => {
        return Object.values(validityMap).every(isValid => isValid);
      };
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      this.getScrollSettings = zoomValue => {
        return {
          horizontalOffset: 0,
          padding: {
            left: 300 * zoomValue,
            right: 300 * zoomValue,
            bottom: 200 * zoomValue,
            top: 200 * zoomValue
          },
          ...(this.defaultScrollSettings ?? {}),
          zoomFactor: ZOOM_FACTOR_OPTIONS_DELTA / zoomValue,
          minZoom: ZOOM_FACTOR_OPTIONS[0],
          maxZoom: ZOOM_FACTOR_OPTIONS.slice(-1)[0]
        };
      };
      this.getCssSizeValue = (value, unit = 'px') => {
        return typeof value === 'string' && (value.includes('px') || value.includes('em') || value.includes('%')) ? value : `${value}${unit}`;
      };
      this.getConnectorPortsStyles = connectors => {
        const coloredPortSvgIds = [];
        let connectorAnnotationStyle = ``;
        connectors.forEach(connector => {
          if (connector.sourcePortID) {
            coloredPortSvgIds.push(`#${connector.sourceID}_${connector.sourcePortID}_groupElement path`);
          }
          if (connector.targetPortID) {
            coloredPortSvgIds.push(`#${connector.targetID}_${connector.targetPortID}_groupElement path`);
          }
          if (connector.sourceID) {
            const outputPin = getOutputPinFromConnector(connector);
            const workflowId = getWorkflowIdFromNodeId(connector.sourceID);
            const workflow = this.controller.dataMap[workflowId];
            const outputPinColor = getConnectorAnnotationColor(workflow.factory.type, outputPin);
            if (outputPinColor) {
              connectorAnnotationStyle += `#${connector.id}_groupElement> g:has(text) > rect {
                      fill: var(--palette-${outputPinColor}-100);
                      stroke: var(--palette-${outputPinColor}-100);
                      stroke-width: 4px;
                      rx: 4px;
                      ry: 4px;
                      filter: drop-shadow(0px 0px 2px var(--palette-${outputPinColor}-500));
                  }`;
            }
          }
        }, []);
        const coloredPortSvgIdsStyle = coloredPortSvgIds.length > 0 ? `${coloredPortSvgIds.join(', ')} { fill: var(--diagram-highlight-color) !important; }` : '';
        return connectors.length > 0 ? this.sanitizer.bypassSecurityTrustHtml(`<style>
                  ${coloredPortSvgIdsStyle}

                  ${connectorAnnotationStyle}
                  </style>`) : '';
      };
    }
    async ngOnInit() {
      this.zoomSvc.resetZoom();
      this.zoomSvc.zoomChanges$.pipe(debounceTime(50), filter(change => change.zoomValue !== this.currentZoom)).subscribe(change => this.zoomTo(change, true));
      this.controller.isDebugCallback = () => this.debugMode;
      if (this.dataProvider) {
        this.builderSvc.dataProvider = this.dataProvider;
      }
      if (!this.eventId) {
        throw new Error('Please assign eventId to WorkflowBuilderComponent');
      }
    }
    async ngAfterViewInit() {
      await firstValueFrom(this.ngZone.onStable); // delay to wait until html is fully rendered
      this.updateDiagramSize();
      this.resize$.pipe(startWith(), debounceTime(100)).subscribe(async () => {
        await firstValueFrom(this.ngZone.onStable);
        this.updateDiagramSize();
      });
    }
    ngOnDestroy() {
      this.onDestroyed$.next();
    }
    async onDiagramLoad() {
      await this.controller.initFromProvider(this.dataProvider, this.eventId, this.stateCallbackMap);
      const {
        connectors,
        nodes
      } = getNodeAndConnectorsFromCanvasControllerData(Object.values(this.controller.dataMap), this.sharedSvc);
      nodes.forEach(node => this.diagramEl.addNode({
        ...node,
        shape: {
          type: 'HTML'
        },
        style: {
          fill: 'blue'
        }
      }));
      connectors.forEach(connector => this.diagramEl.addConnector(connector));
      this.log('onDiagramLoad - controller.dataMap', this.controller.dataMap, nodes, connectors);
      await firstValueFrom(this.ngZone.onStable);
      this.diagramEl.reset();
      this.panDiagramToCenter();
      this.diagramEl.clearSelection();
    }
    async onPublish() {
      this.log('onPublish', this.controller.getCurrentState());
      this.controller.publish();
    }
    log(logName, ...params) {
      if (this.debugMode) {
        console.groupCollapsed(`WorkflowBuilderComponent - ${logName}`);
        console.trace(params);
        console.groupEnd();
      }
    }
    getSymbolInfo(symbol) {
      // Defines the symbol description
      return {
        width: 75,
        height: 40,
        description: {
          text: symbol.addInfo['description']
        }
      };
    }
    onConnectionPointChange(event) {
      this.log('connectionPointChange', event);
      const {
        connector,
        state,
        name
      } = event;
      if (state !== 'Completed' && name === 'targetPointChange') {
        const connectorModel = connector;
        this.highlightValidWorkflowTarget(connectorModel, false);
        return;
      }
      this.stopHighlightValidWorkflowTarget();
      this.handleConnectorPorts(connector);
    }
    async onElementDraw(event) {
      this.log('elementDraw', event);
      const {
        objectType,
        state,
        source
      } = event;
      const connectorEvent = event;
      if (state === 'Start') {
        switch (objectType) {
          case 'Connector':
            {
              this.isDraggingConnector = true;
              if (source instanceof Node) {
                this.elementDrawNode = source;
              }
            }
        }
        // this is required to remove the selection-border that causes the connector to lose its sourceId
        this.diagramEl.clearSelection();
        this.diagramEl.clearSelectorLayer();
      }
      // TODO: fix problem when user starts dragging on the edge of the port, this causes the connectorEvent.source.sourceID to become empty. and the created connector will not be valid
      if (state !== 'Completed') {
        switch (objectType) {
          case 'Connector':
            {
              const connectorModel = connectorEvent.source;
              connectorModel.sourceID ||= this.elementDrawNode?.id; // this is to fix issue where sometime the connector has empty sourceID
              this.highlightValidWorkflowTarget(connectorModel, true);
            }
        }
        return;
      }
      if (state === 'Completed') {
        switch (objectType) {
          case 'Connector':
            {
              await this.onConnectionAddedByDrawing(connectorEvent.source);
            }
        }
        this.elementDrawNode = undefined;
      }
    }
    highlightValidWorkflowTarget(connectorModel, isNewConnection) {
      if (!this.ongoingValidNextWorkflowIdMap && connectorModel instanceof Connector && connectorModel?.sourceID) {
        this.isDraggingConnector = true;
        const workflowId = getWorkflowIdFromNodeId(connectorModel.sourceID);
        const workflow = this.controller.dataMap[workflowId];
        const outputPin = getOutputPinFromConnector(connectorModel);
        const workflowOutputIsSet = workflow.factory.getNextWorkflows()[outputPin];
        const possibleNextWorkflowIds = isNewConnection && workflowOutputIsSet ? [] : this.controller.getPossibleNextWorkflowIds(workflow, outputPin);
        this.ongoingValidNextWorkflowIdMap = possibleNextWorkflowIds.concat([workflowId]) // source workflowId is included so it not get blurred
        .reduce((record, id) => ({
          ...record,
          [getNodeIdFromWorkflowId(id)]: true
        }), {});
        if (possibleNextWorkflowIds.length === 0) {
          this.warnNoPossibleNextWorkflows(workflow, outputPin);
        }
        this.log('possibleNextWorkflowIds', possibleNextWorkflowIds);
      }
    }
    warnNoPossibleNextWorkflows(workflow, outputPin) {
      const expectedWorkflowTypes = getPossibleNextWorkflowTypes(workflow, outputPin);
      if (expectedWorkflowTypes.some(type => WORKFLOW_WARNING_NO_POSSIBLE_NEXT_WORKFLOW[type])) {
        this.notificationSvc.showMessage("error" /* NotificationMessageType.error */, this.translateService.instant('WORKFLOW_NO_POSSIBLE_NEXT_WORKFLOW_MESSAGE', {
          workflowTypeNames: expectedWorkflowTypes.map(type => this.sharedSvc.translate(WORKFLOW_NAME_TRANSLATIONS[type])).join(` ${this.sharedSvc.translate('OR').toLowerCase()} `),
          outputPinName: this.sharedSvc.translate(OUTPUT_PIN_TRANSLATIONS[outputPin] ?? '')
        }));
      }
    }
    async onCollectionChange(event) {
      this.log('collectionChange', event);
      const {
        type,
        state,
        element
      } = event;
      if (state !== 'Changed') {
        return;
      }
      if (element instanceof Node) {
        switch (type) {
          case 'Addition':
            {
              await delay(300);
              this.onDropPalette(element);
              break;
            }
          case 'Removal':
            {
              this.deleteWorkflow(getWorkflowIdFromNodeId(element.id));
              break;
            }
        }
      }
      if (element instanceof Connector) {
        switch (type) {
          case 'Removal':
            {
              const sourceWorkflowId = getWorkflowIdFromNodeId(element.sourceID);
              const targetWorkflowId = getWorkflowIdFromNodeId(element.targetID);
              const elementConnector = element;
              const sourceWorkflow = this.controller.dataMap[sourceWorkflowId];
              const outputPin = getOutputPinFromConnector(elementConnector);
              if (targetWorkflowId === sourceWorkflow?.factory.getNextWorkflows()[outputPin]) {
                this.controller.updateWorkflowNextWorkflow(outputPin, sourceWorkflowId, null);
              }
              break;
            }
          case 'Addition':
            {
              break;
            }
        }
      }
    }
    async onSelectionChange(event) {
      this.log('selectionChange', event);
      const {
        state
      } = event;
      if (state !== 'Changed') {
        return;
      }
      // handle connectors selection indicator
      const selectedConnectorsMaps = getMapByValue(this.diagramEl.selectedItems.connectors ?? [], 'id');
      this.diagramEl.connectors.forEach(item => {
        const selectedStrokeWidth = DEFAULT_STROKE_WIDTH * 2;
        const isSelectedItem = !!selectedConnectorsMaps[item.id];
        if (item.style?.strokeWidth) {
          if (item.style.strokeWidth !== DEFAULT_STROKE_WIDTH && !isSelectedItem) {
            item.style.strokeWidth = DEFAULT_STROKE_WIDTH;
          }
          if (item.style.strokeWidth !== selectedStrokeWidth && isSelectedItem) {
            item.style.strokeWidth = selectedStrokeWidth;
          }
        }
      });
      // make selected node on top of z-index
      const selectedNodesMaps = getMapByValue(this.diagramEl.selectedItems.nodes ?? [], 'id');
      this.diagramEl.nodes.forEach(item => {
        const isSelectedItem = !!selectedNodesMaps[item.id];
        const nodeElement = this.host.nativeElement.querySelector(`#${item.id}_content_html_element`);
        if (nodeElement) {
          nodeElement.classList.toggle('diagram-node__selected', isSelectedItem);
        }
      });
    }
    onScrollChange(event) {
      this.log('onScrollChange', event);
      if (event.newValue.CurrentZoom && event.oldValue.CurrentZoom !== this.currentZoom) {
        const zoomValue = event.newValue.CurrentZoom;
        this.currentZoom = zoomValue;
        this.zoomSvc.updateZoom(zoomValue);
      }
    }
    async zoomTo(changes, shouldPanDiagramToCenter = false) {
      const {
        zoomValue
      } = changes;
      const latestDiagramZoom = this.zoomSvc.previousZoomValue;
      this.diagramEl?.zoom(zoomValue / latestDiagramZoom);
      await firstValueFrom(this.ngZone.onStable);
      if (shouldPanDiagramToCenter) {
        this.panDiagramToCenter();
      }
    }
    async onPropertyChange(change) {
      this.log('onPropertyChange', change);
      if (change.element instanceof Node) {
        const changeNode = change;
        const node = changeNode.element;
        const nodeFormElement = this.host.nativeElement.querySelector(`.workflow-builder-div__diagram-area__diagram__workflow-item[nodeid="${node.id}"]`);
        if (nodeFormElement) {
          await firstValueFrom(this.ngZone.onStable);
          const correctZoomedHeight = Math.round(nodeFormElement.getBoundingClientRect().height / this.zoomSvc.zoomValue);
          if (node.height !== correctZoomedHeight) {
            node.height = correctZoomedHeight;
          }
        }
      }
    }
    deleteWorkflow(workflowId) {
      this.controller.deleteWorkflow(workflowId);
    }
    /** Handle when dragging the tip end/start of a connector */
    async onConnectionChange(event) {
      this.log('connectionChange', event);
      const {
        state,
        newValue,
        oldValue,
        connectorEnd,
        connector
      } = event;
      const connectorModel = connector;
      if (state !== 'Changed') {
        return;
      }
      // @ts-ignore
      const newValueNodeId = newValue.nodeId;
      // @ts-ignore
      const oldValueNodeId = oldValue.nodeId;
      const outputPin = getOutputPinFromConnector(connectorModel);
      // the highlight is started on diagram.targetPointChange() event
      this.stopHighlightValidWorkflowTarget();
      if (newValueNodeId != null && oldValueNodeId != null && newValueNodeId !== oldValueNodeId) {
        if (connectorEnd === 'ConnectorSourceEnd') {
          const oldWorkflowSourceId = getWorkflowIdFromNodeId(oldValueNodeId);
          const newWorkflowSourceId = getWorkflowIdFromNodeId(newValueNodeId);
          const newWorkflowTargetId = connector.targetID ? getWorkflowIdFromNodeId(connector.targetID) : null;
          const isValidNextWorkflow = this.controller.isValidNextWorkflow(outputPin, newWorkflowSourceId, newWorkflowTargetId);
          if (isValidNextWorkflow) {
            this.controller.updateWorkflowNextWorkflow(outputPin, oldWorkflowSourceId, null);
            if (newValueNodeId) {
              this.controller.updateWorkflowNextWorkflow(outputPin, newWorkflowSourceId, newWorkflowTargetId);
            }
          } else {
            connector.sourceID = oldValueNodeId;
          }
          this.checkConnector(connector.id, newWorkflowSourceId);
        }
        if (connectorEnd === 'ConnectorTargetEnd' && connector.sourceID?.startsWith(PREFIX_NODE)) {
          const workflowSourceId = getWorkflowIdFromNodeId(connector.sourceID);
          const newWorkflowTargetId = newValueNodeId ? getWorkflowIdFromNodeId(newValueNodeId) : null;
          const isValidNextWorkflow = this.controller.isValidNextWorkflow(outputPin, workflowSourceId, newWorkflowTargetId);
          if (isValidNextWorkflow) {
            this.controller.updateWorkflowNextWorkflow(outputPin, workflowSourceId, newWorkflowTargetId);
          } else {
            connector.targetID = oldValueNodeId;
          }
          this.checkConnector(connector.id, workflowSourceId);
        }
      }
    }
    async onDropPalette(node) {
      const paletteAddInfo = node?.addInfo;
      if (workflowTypeArray.includes(paletteAddInfo?.type)) {
        const newControllerData = this.controller.addWorkflow(paletteAddInfo?.type, {
          coordinate: {
            x: node.offsetX,
            y: node.offsetY
          },
          name: this.sharedSvc.translate(WORKFLOW_NAME_TRANSLATIONS[paletteAddInfo.type]),
          description: this.sharedSvc.translate(WORKFLOW_EXPLANATION_TRANSLATIONS[paletteAddInfo.type])
        });
        const newNodeData = getNodeFromCanvasControllerData(newControllerData, this.sharedSvc);
        this.diagramEl.addNode(newNodeData);
        this.diagramEl.remove(node);
      }
    }
    onPositionChange(event) {
      this.log('positionChange', event);
      const {
        state,
        newValue,
        source
      } = event;
      if (state !== 'Completed') {
        return;
      }
      const sourceNode = source.nodes?.[0] ?? source;
      if (sourceNode?.id?.startsWith(PREFIX_NODE)) {
        this.controller.updateWorkflowCoordinate(getWorkflowIdFromNodeId(sourceNode.id), {
          x: newValue.offsetX,
          y: newValue.offsetY
        });
      }
    }
    async onConnectionAddedByDrawing(connector) {
      this.log('onConnectionAddedByDrawing', connector);
      this.stopHighlightValidWorkflowTarget();
      const workflowSourceId = getWorkflowIdFromNodeId(connector.sourceID);
      const workflowTargetId = getWorkflowIdFromNodeId(connector.targetID);
      const connectorModel = connector;
      const outputPin = getOutputPinFromConnector(connectorModel);
      const isValidNextWorkflow = this.controller.isValidNextWorkflow(outputPin, workflowSourceId, workflowTargetId, true);
      if (isValidNextWorkflow) {
        const updateWorkflowNextWorkflow = () => this.controller.updateWorkflowNextWorkflow(outputPin, workflowSourceId, workflowTargetId);
        if (outputPin === OutputPin.SPLITTER_OUTPUT1 || outputPin === OutputPin.SPLITTER_OUTPUT2) {
          const shouldApplyNextWorkflowOnSplitter = await this.getShouldApplyNextWorkflowOnSplitter(outputPin, workflowSourceId, workflowTargetId);
          if (shouldApplyNextWorkflowOnSplitter) {
            updateWorkflowNextWorkflow();
          } else {
            await this.cancelAddConnector(connector);
          }
        } else {
          updateWorkflowNextWorkflow();
        }
        this.checkConnector(connector.id, workflowSourceId);
      } else {
        await this.cancelAddConnector(connector);
      }
    }
    stopHighlightValidWorkflowTarget() {
      this.isDraggingConnector = false;
      this.ongoingValidNextWorkflowIdMap = null;
    }
    async cancelAddConnector(connector) {
      await delay(300);
      this.diagramEl.remove(connector);
    }
    async getShouldApplyNextWorkflowOnSplitter(outputType, sourceWorkflowId, targetWorkflowId) {
      if (!sourceWorkflowId || !targetWorkflowId) {
        return false;
      }
      const {
        factory
      } = this.controller.dataMap[sourceWorkflowId];
      const factoryWorkflowSplitter = factory;
      const conditionPropertyName = getConditionFromSplitterOutput(outputType, factoryWorkflowSplitter.type);
      const conditionValue = conditionPropertyName && factoryWorkflowSplitter.settings[conditionPropertyName];
      const conditionIsConfigured = !!conditionValue && isAdvancedQueryConditionConfigured(conditionValue);
      if (!conditionIsConfigured && conditionPropertyName) {
        const conditionValueAsCriteria = conditionValue ?? [];
        const updatedCondition = await this.updateAdvancedQueryCallback({
          condition: conditionValueAsCriteria,
          property: factory.getProperties().find(({
            attribute
          }) => attribute === conditionPropertyName),
          workflowId: sourceWorkflowId,
          allowEmptyConditions: false
        });
        if (updatedCondition) {
          const updatedSetting = this.sharedSvc.clone(factoryWorkflowSplitter.settings);
          updatedSetting[conditionPropertyName] = updatedCondition;
          this.controller.updateWorkflowSettings(sourceWorkflowId, updatedSetting);
          return true;
        }
      }
      return conditionIsConfigured;
    }
    checkConnector(connectorId, workflowSourceId) {
      const connector = this.diagramEl.connectors.find(({
        id
      }) => id === connectorId);
      if (!connector) {
        return;
      }
      connector.style = {
        ...connector.style,
        strokeColor: connector.sourceID && connector.targetID && connector.sourceID !== connector.targetID ? DEFAULT_STROKE_COLOR : DEFAULT_ERROR_STROKE_COLOR
      };
      const connectorInstance = connector;
      const connectorModel = connector;
      const outputPin = getOutputPinFromConnector(connectorModel);
      connectorInstance.constraints = ConnectorConstraints.Default - ConnectorConstraints.DragSourceEnd;
      const workflow = this.controller.dataMap[workflowSourceId];
      if (connectorInstance.annotations?.[0]) {
        connectorInstance.annotations[0].content = getConnectorAnnotation(outputPin, workflow.factory, this.sharedSvc)[0].content;
      } else {
        this.diagramEl.addConnectorLabels(connector, getConnectorAnnotation(outputPin, workflow.factory, this.sharedSvc));
      }
      this.handleConnectorPorts(connectorInstance);
      this.diagramEl.dataBind();
    }
    handleConnectorPorts(connector) {
      const connectorModel = connector;
      const outputPin = getOutputPinFromConnector(connectorModel);
      if (outputPin) {
        if (connectorModel.sourceID) {
          if (!connectorModel.sourcePortID) {
            connectorModel.sourcePortID = getNodeOutputPortId(outputPin);
          }
        }
        if (connectorModel.targetID && !connectorModel.targetPortID) {
          connectorModel.targetPortID = `${PREFIX_PORT}_${OUTPUT_PIN_PAIR[outputPin]}_pin`;
        }
      }
    }
    updateWorkflowSettings(nodeId, data) {
      if (data) {
        this.controller.updateWorkflowSettings(getWorkflowIdFromNodeId(nodeId), data);
      }
    }
    updateNextWorkflow(nodeId, data) {
      const workflowId = getWorkflowIdFromNodeId(nodeId);
      this.controller.updateWorkflowNextWorkflow(data.pin, workflowId, data.workflowId);
      const existingConnector = this.diagramEl.connectors.find(({
        sourceID,
        sourcePortID
      }) => sourceID === nodeId && sourcePortID === getNodeOutputPortId(data.pin));
      if (existingConnector) {
        this.diagramEl?.remove(existingConnector);
      }
      if (data.workflowId && this.controller.dataMap[workflowId]) {
        const newConnector = getConnectorFromWorkflowOutputPin(this.controller.dataMap[workflowId].factory, data.pin, data.workflowId, this.sharedSvc);
        this.diagramEl.add(newConnector);
      }
    }
    /**
     * @param nodeId `NodeIdModel<string>`
     */
    updateWorkflowCanvas(nodeId, data) {
      this.controller.updateWorkflowCanvas(getWorkflowIdFromNodeId(nodeId), data);
      if (data.locked != null) {
        const node = getDiagramNodeInstance(this.diagramEl, nodeId);
        if (node) {
          node.constraints = getNodeConstraints(!!data.locked);
        }
      }
    }
    async deleteNode(nodeModel) {
      if ((await this.deleteWorkflowConfirmation?.(nodeModel)) !== true) {
        return;
      }
      const nodeInstance = this.diagramEl.nodes.find(({
        id
      }) => id === nodeModel.id);
      nodeInstance.constraints = NodeConstraints.Default;
      this.diagramEl.remove(nodeInstance);
    }
    async updateDiagramSize() {
      const rect = this.host.nativeElement.querySelector('ejs-diagram')?.getBoundingClientRect();
      this.diagramConfig.height = rect?.height;
      this.diagramConfig.width = rect?.width;
      this.diagramRectHeight = rect?.height;
    }
    saveState() {
      // TODO
    }
    hasNodeSelectedAndExpanded2() {
      const selectedNodeMap = getMapByValue(this.diagramEl?.selectedItems.nodes ?? [], 'id');
      return !!this.nodeForms?.some(node => !!selectedNodeMap[node.node.id] && !!node.workflowSettingsGroupedFieldData?.expandPanels);
    }
    panDiagramToCenter() {
      const hostElement = this.host.nativeElement;
      const diagramRect = hostElement.querySelector('#diagramcontent')?.getBoundingClientRect();
      if (!diagramRect) {
        return false;
      }
      const workflowItemElements = Array.from(hostElement.querySelectorAll('#diagram_htmlLayer_div [id$=_content_html_element]'));
      if (workflowItemElements.length === 0) {
        return false;
      }
      const boundary = workflowItemElements.reduce((rect, element) => {
        const elementRect = element.getBoundingClientRect();
        const left = elementRect.left - diagramRect.left;
        const right = left + elementRect.width;
        const top = elementRect.top - diagramRect.top;
        const bottom = top + elementRect.height;
        return {
          left: rect.left != null ? Math.min(left, rect.left) : left,
          right: rect.right != null ? Math.max(right, rect.right) : right,
          top: rect.top != null ? Math.min(top, rect.top) : top,
          bottom: rect.bottom != null ? Math.max(bottom, rect.bottom) : bottom
        };
      }, {});
      this.diagramEl.pan(boundary.left - (diagramRect.width - (boundary.right - boundary.left)) / 2, boundary.top - (diagramRect.height - (boundary.bottom - boundary.top)) / 2);
      return true;
    }
    async toggleIsHidingPalette(forceValue) {
      this.isHidingPalette = forceValue ?? !this.isHidingPalette;
      // use loop for smoother animation when diagram updates its width
      for (let i = 0; i < 5; i++) {
        await delay(i * 100);
        this.diagramEl.width = `${this.diagramHtmlEl.nativeElement.getBoundingClientRect().width}px`;
        this.diagramEl.dataBind();
      }
    }
    toggleHideWorkflowDescription(forceValue) {
      this.localConfigService.assignItem('hideWorkflowDescription', forceValue ?? !this.localConfig$.value?.hideWorkflowDescription);
    }
    async openWorkflowDialog(workflowId, processAttributeName) {
      await firstValueFrom(this.ngZone.onStable);
      await delay(0);
      this.nodeItems?.forEach(async nodeItem => {
        if (nodeItem.workflowId === workflowId) {
          const dialogRef = await nodeItem.openEditDialog();
          if (processAttributeName) {
            const formEL = await firstValueFrom(dialogRef.componentInstance.formLoaded.pipe(filter(form => !!form)));
            await firstValueFrom(this.ngZone.onStable);
            await delay(0);
            formEL.querySelector(`azavista-workflow-builder-node-form-field-process[property-name="${processAttributeName}"] button`)?.click();
          }
        }
      });
    }
    static {
      this.ɵfac = function WorkflowBuilderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WorkflowBuilderComponent)(i0.ɵɵdirectiveInject(WorkflowBuilderService), i0.ɵɵdirectiveInject(AzavistaWorkflowBuilderController), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1$2.NgResizeObserver), i0.ɵɵdirectiveInject(i1.AzavistaSharedService), i0.ɵɵdirectiveInject(i1.NotificationsService), i0.ɵɵdirectiveInject(i7.TranslateService), i0.ɵɵdirectiveInject(AzavistaWorkflowBuilderZoomService), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i7$3.DomSanitizer), i0.ɵɵdirectiveInject(WorkflowBuilderLocalConfigService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: WorkflowBuilderComponent,
        selectors: [["azavista-workflow-builder"]],
        viewQuery: function WorkflowBuilderComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c12, 5);
            i0.ɵɵviewQuery(_c12, 5, ElementRef);
            i0.ɵɵviewQuery(WorkflowBuilderNodeFormComponent, 5);
            i0.ɵɵviewQuery(WorkflowBuilderNodeItemComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.diagramEl = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.diagramHtmlEl = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.nodeForms = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.nodeItems = _t);
          }
        },
        inputs: {
          dataProvider: "dataProvider"
        },
        outputs: {
          nodeItemsLoaded: "nodeItemsLoaded"
        },
        standalone: false,
        features: [i0.ɵɵProvidersFeature([...ngResizeObserverProviders]), i0.ɵɵInheritDefinitionFeature],
        decls: 35,
        vars: 46,
        consts: [["diagram", ""], ["nodeTemplate", ""], [1, "workflow-builder-div"], [1, "workflow-builder-div__diagram-area"], [1, "workflow-builder-div__diagram-area__toolbar"], [1, "workflow-builder-div__diagram-area__toolbar__left"], ["color", "primary", 3, "click", "disabled"], [3, "click", 4, "ngIf"], [4, "ngIf"], [1, "workflow-builder-div__diagram-area__toolbar__right"], ["id", "diagram", 3, "created", "connectionChange", "elementDraw", "commandExecute", "dataLoaded", "dragEnter", "dragLeave", "dragOver", "drop", "mouseup", "fixedUserHandleClick", "load", "positionChange", "propertyChange", "rotateChange", "scrollChange", "segmentChange", "segmentCollectionChange", "selectionChange", "sizeChange", "sourcePointChange", "targetPointChange", "collectionChange", "width", "height", "tool", "tooltip", "scrollSettings", "constraints", "snapSettings", "getConnectorDefaults"], [1, "workflow-builder-div__diagram-area__float-actions", "workflow-builder-div__diagram-area__float-actions--top"], ["color", "primary", 1, "workflow-builder-div__diagram-area__float-actions__item", "workflow-builder-div__diagram-area__float-actions__hide-workflow-description", 3, "change", "checked"], [1, "workflow-builder-div__diagram-area__float-actions__item", "workflow-builder-div__diagram-area__float-actions__zoom"], [1, "workflow-builder-div__diagram-area__float-actions__item", "workflow-builder-div__diagram-area__float-actions__fullscreen"], [3, "click", "checked"], [1, "workflow-builder-div__diagram-area__float-actions", "workflow-builder-div__diagram-area__float-actions--bottom"], ["mat-fab", "", "color", "primary", 1, "workflow-builder-div__diagram-area__float-actions__button-add", 3, "click"], ["class", "workflow-builder-div__palette-area", 4, "ngIf"], ["class", "aza-cmp-hidden", 3, "innerHTML", 4, "ngIf"], [3, "click"], ["azavistaWorkflowBuilderDiagramNodeAutoHeight", "", 1, "workflow-builder-div__diagram-area__diagram__workflow-item", 3, "workflowSettingsChanges", "canvasChanges", "outputPinUpdate", "removeNode", "node", "diagramEl", "eventId", "stateCallbackMap", "updateAdvancedQueryCallback", "propertyOptions", "autoHideFieldLabel", "updateProcessCallback"], [1, "workflow-builder-div__palette-area"], [3, "label"], [3, "workflowTypeCategories"], [1, "workflow-builder-div__palette-area__actions"], ["mat-icon-button", "", 1, "workflow-builder-div__palette-area__actions__button-close", 3, "click"], [1, "aza-cmp-hidden", 3, "innerHTML"]],
        template: function WorkflowBuilderComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 2);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵelementStart(2, "div", 3);
            i0.ɵɵpipe(3, "apply");
            i0.ɵɵelementStart(4, "azavista-exported-element-wrapper")(5, "div", 4)(6, "div", 5)(7, "azavista-button", 6);
            i0.ɵɵpipe(8, "apply");
            i0.ɵɵlistener("click", function WorkflowBuilderComponent_Template_azavista_button_click_7_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onPublish());
            });
            i0.ɵɵtext(9);
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(11, WorkflowBuilderComponent_azavista_button_11_Template, 3, 3, "azavista-button", 7)(12, WorkflowBuilderComponent_strong_12_Template, 2, 0, "strong", 8);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(13, "div", 9);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(14, "ejs-diagram", 10, 0);
            i0.ɵɵpipe(16, "apply");
            i0.ɵɵlistener("created", function WorkflowBuilderComponent_Template_ejs_diagram_created_14_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onDiagramLoad());
            })("connectionChange", function WorkflowBuilderComponent_Template_ejs_diagram_connectionChange_14_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onConnectionChange($event));
            })("elementDraw", function WorkflowBuilderComponent_Template_ejs_diagram_elementDraw_14_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onElementDraw($event));
            })("commandExecute", function WorkflowBuilderComponent_Template_ejs_diagram_commandExecute_14_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.log("commandExecute", $event));
            })("created", function WorkflowBuilderComponent_Template_ejs_diagram_created_14_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.log("created", $event));
            })("dataLoaded", function WorkflowBuilderComponent_Template_ejs_diagram_dataLoaded_14_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.log("dataLoaded", $event));
            })("dragEnter", function WorkflowBuilderComponent_Template_ejs_diagram_dragEnter_14_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.log("dragEnter", $event));
            })("dragLeave", function WorkflowBuilderComponent_Template_ejs_diagram_dragLeave_14_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.log("dragLeave", $event));
            })("dragOver", function WorkflowBuilderComponent_Template_ejs_diagram_dragOver_14_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.log("dragOver", $event));
            })("drop", function WorkflowBuilderComponent_Template_ejs_diagram_drop_14_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.log("drop", $event));
            })("mouseup", function WorkflowBuilderComponent_Template_ejs_diagram_mouseup_14_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.stopHighlightValidWorkflowTarget());
            })("fixedUserHandleClick", function WorkflowBuilderComponent_Template_ejs_diagram_fixedUserHandleClick_14_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.log("fixedUserHandleClick", $event));
            })("load", function WorkflowBuilderComponent_Template_ejs_diagram_load_14_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.log("load", $event));
            })("positionChange", function WorkflowBuilderComponent_Template_ejs_diagram_positionChange_14_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onPositionChange($event));
            })("propertyChange", function WorkflowBuilderComponent_Template_ejs_diagram_propertyChange_14_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onPropertyChange($event));
            })("rotateChange", function WorkflowBuilderComponent_Template_ejs_diagram_rotateChange_14_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.log("rotateChange", $event));
            })("scrollChange", function WorkflowBuilderComponent_Template_ejs_diagram_scrollChange_14_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onScrollChange($event));
            })("segmentChange", function WorkflowBuilderComponent_Template_ejs_diagram_segmentChange_14_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.log("segmentChange", $event));
            })("segmentCollectionChange", function WorkflowBuilderComponent_Template_ejs_diagram_segmentCollectionChange_14_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.log("segmentCollectionChange", $event));
            })("selectionChange", function WorkflowBuilderComponent_Template_ejs_diagram_selectionChange_14_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onSelectionChange($event));
            })("sizeChange", function WorkflowBuilderComponent_Template_ejs_diagram_sizeChange_14_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.log("sizeChange", $event));
            })("sourcePointChange", function WorkflowBuilderComponent_Template_ejs_diagram_sourcePointChange_14_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onConnectionPointChange($event));
            })("targetPointChange", function WorkflowBuilderComponent_Template_ejs_diagram_targetPointChange_14_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onConnectionPointChange($event));
            })("collectionChange", function WorkflowBuilderComponent_Template_ejs_diagram_collectionChange_14_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onCollectionChange($event));
            });
            i0.ɵɵtemplate(17, WorkflowBuilderComponent_ng_template_17_Template, 1, 10, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(19, "div", 11)(20, "mat-slide-toggle", 12);
            i0.ɵɵpipe(21, "async");
            i0.ɵɵlistener("change", function WorkflowBuilderComponent_Template_mat_slide_toggle_change_20_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.toggleHideWorkflowDescription($event.checked));
            });
            i0.ɵɵtext(22);
            i0.ɵɵpipe(23, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(24, "azavista-workflow-builder-zoom-select", 13);
            i0.ɵɵelementStart(25, "mat-button-toggle-group", 14)(26, "mat-button-toggle", 15);
            i0.ɵɵlistener("click", function WorkflowBuilderComponent_Template_mat_button_toggle_click_26_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.toggleIsHidingPalette());
            });
            i0.ɵɵelementStart(27, "mat-icon");
            i0.ɵɵtext(28, "fullscreen");
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(29, "div", 16)(30, "button", 17);
            i0.ɵɵlistener("click", function WorkflowBuilderComponent_Template_button_click_30_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.toggleIsHidingPalette(false));
            });
            i0.ɵɵelementStart(31, "mat-icon");
            i0.ɵɵtext(32, "add");
            i0.ɵɵelementEnd()()()();
            i0.ɵɵtemplate(33, WorkflowBuilderComponent_div_33_Template, 9, 4, "div", 18);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(34, WorkflowBuilderComponent_div_34_Template, 1, 1, "div", 19);
          }
          if (rf & 2) {
            let tmp_4_0;
            let tmp_20_0;
            const diagram_r7 = i0.ɵɵreference(15);
            i0.ɵɵclassProp("workflow-builder-div--isDraggingConnector", ctx.isDraggingConnector)("workflow-builder-div--isHidingPalette", ctx.isHidingPalette)("workflow-builder-div--isHideWorkflowDescription", (tmp_4_0 = i0.ɵɵpipeBind1(1, 29, ctx.localConfig$)) == null ? null : tmp_4_0.hideWorkflowDescription);
            i0.ɵɵadvance(2);
            i0.ɵɵstyleProp("--diagram-height", ctx.diagramRectHeight && i0.ɵɵpipeBind2(3, 31, ctx.diagramRectHeight, ctx.getCssSizeValue));
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("disabled", !i0.ɵɵpipeBind2(8, 34, ctx.controller.validityMap, ctx.areWorkflowsValid));
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 37, "PUBLISH"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.dataProvider.revertPublishedBuilderData);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isDemo);
            i0.ɵɵadvance(2);
            i0.ɵɵclassProp("ejs-diagram--has-node-selected", diagram_r7.selectedItems.nodes && diagram_r7.selectedItems.nodes.length > 0)("ejs-diagram--has-node-selected-and-expanded", ctx.hasNodeSelectedAndExpanded2());
            i0.ɵɵproperty("width", ctx.diagramConfig.width)("height", ctx.diagramConfig.height)("tool", ctx.tool)("tooltip", ctx.diagramConfig.tooltip)("scrollSettings", i0.ɵɵpipeBind2(16, 39, ctx.zoomSvc.zoomValue, ctx.getScrollSettings))("constraints", ctx.diagramConfig.constraints)("snapSettings", ctx.diagramConfig.snapSettings)("getConnectorDefaults", ctx.diagramConfig.getConnectorDefaults);
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("checked", (tmp_20_0 = i0.ɵɵpipeBind1(21, 42, ctx.localConfig$)) == null ? null : tmp_20_0.hideWorkflowDescription);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(23, 44, "ONLY_FLOW_NAME"), " ");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("checked", ctx.isHidingPalette);
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("ngIf", !ctx.hidePaletteList);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.diagramEl == null ? null : ctx.diagramEl.connectors);
          }
        },
        dependencies: [i4.NgIf, i3.MatIconButton, i3.MatFabButton, i11.MatButtonToggleGroup, i11.MatButtonToggle, i4$2.MatIcon, i2$2.MatSlideToggle, i14.MatTab, i14.MatTabGroup, i5$3.DiagramComponent, i4$4.AzavistaButtonComponent, i17.AzavistaExportedElementWrapperComponent, WorkflowBuilderDiagramNodeAutoHeightDirective, WorkflowBuilderPaletteComponent, WorkflowBuilderNodeItemComponent, AzavistaWorkflowBuilderZoomSelectComponent, i4.AsyncPipe, i7.TranslatePipe, ApplyFunctionPipe],
        styles: ["*[_ngcontent-%COMP%]{--workflow-builder__diagram__font-size: 12px;--workflow-builder__diagram-form__font-size: 14px}[_nghost-%COMP%]{--palette-success-50: rgb(229, 245, 236);--palette-success-50-no-rgb: 229, 245, 236;--palette-success-100: rgb(190, 231, 207);--palette-success-100-no-rgb: 190, 231, 207;--palette-success-200: rgb(147, 215, 176);--palette-success-200-no-rgb: 147, 215, 176;--palette-success-300: rgb(104, 198, 144);--palette-success-300-no-rgb: 104, 198, 144;--palette-success-400: rgb(71, 186, 120);--palette-success-400-no-rgb: 71, 186, 120;--palette-success-500: rgb(39, 174, 96);--palette-success-500-no-rgb: 39, 174, 96;--palette-success-600: rgb(35, 167, 88);--palette-success-600-no-rgb: 35, 167, 88;--palette-success-700: rgb(29, 157, 78);--palette-success-700-no-rgb: 29, 157, 78;--palette-success-800: rgb(23, 148, 68);--palette-success-800-no-rgb: 23, 148, 68;--palette-success-900: rgb(14, 132, 51);--palette-success-900-no-rgb: 14, 132, 51;--palette-success-A100: rgb(181, 255, 201);--palette-success-A100-no-rgb: 181, 255, 201;--palette-success-A200: rgb(130, 255, 164);--palette-success-A200-no-rgb: 130, 255, 164;--palette-success-A400: rgb(79, 255, 127);--palette-success-A400-no-rgb: 79, 255, 127;--palette-success-A700: rgb(54, 255, 109);--palette-success-A700-no-rgb: 54, 255, 109;--palette-success-contrast-50: var(--dark-text-contrast);--palette-success-contrast-50-no-rgb: var(--dark-text-contrast-no-rgb);--palette-success-contrast-100: var(--dark-text-contrast);--palette-success-contrast-100-no-rgb: var(--dark-text-contrast-no-rgb);--palette-success-contrast-200: var(--dark-text-contrast);--palette-success-contrast-200-no-rgb: var(--dark-text-contrast-no-rgb);--palette-success-contrast-300: var(--dark-text-contrast);--palette-success-contrast-300-no-rgb: var(--dark-text-contrast-no-rgb);--palette-success-contrast-400: var(--dark-text-contrast);--palette-success-contrast-400-no-rgb: var(--dark-text-contrast-no-rgb);--palette-success-contrast-500: var(--dark-text-contrast);--palette-success-contrast-500-no-rgb: var(--dark-text-contrast-no-rgb);--palette-success-contrast-600: var(--dark-text-contrast);--palette-success-contrast-600-no-rgb: var(--dark-text-contrast-no-rgb);--palette-success-contrast-700: var(--dark-text-contrast);--palette-success-contrast-700-no-rgb: var(--dark-text-contrast-no-rgb);--palette-success-contrast-800: var(--dark-text-contrast);--palette-success-contrast-800-no-rgb: var(--dark-text-contrast-no-rgb);--palette-success-contrast-900: var(--light-text-contrast);--palette-success-contrast-900-no-rgb: var(--light-text-contrast-no-rgb);display:block;position:relative;min-width:inherit;max-width:inherit;min-height:inherit;max-height:inherit;height:inherit;width:inherit}[_nghost-%COMP%]     *{font-size:var(--workflow-builder__diagram__font-size)}.workflow-builder-div[_ngcontent-%COMP%]{display:flex;min-width:inherit;max-width:inherit;min-height:inherit;max-height:inherit;height:inherit}.workflow-builder-div__diagram-area[_ngcontent-%COMP%]{position:relative;display:flex;flex-direction:column;width:calc(100% - 264px);height:inherit;overflow:hidden;padding:2px;gap:4px;transition:width .3s}.workflow-builder-div__diagram-area__toolbar[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:space-between;height:var(--mdc-secondary-navigation-tab-container-height);padding:0 24px;border:none;margin:5px 0}.workflow-builder-div__diagram-area__toolbar__left[_ngcontent-%COMP%]{display:flex;align-items:center;gap:1em}.workflow-builder-div__diagram-area__toolbar__tool-zoom[_ngcontent-%COMP%]{border-radius:8px;border:2px solid #777;padding:2px 6px}.workflow-builder-div__diagram-area__float-actions[_ngcontent-%COMP%]{position:absolute;top:1em;right:1em;display:flex;align-items:center;gap:.5em}.workflow-builder-div__diagram-area__float-actions__item[_ngcontent-%COMP%]{display:flex;align-items:center;border:1px solid #ccc;background-color:#fff;border-radius:8px;box-shadow:0 0 1em #ccc!important}.workflow-builder-div__diagram-area__float-actions__fullscreen[_ngcontent-%COMP%]{--mat-standard-button-toggle-height: 36px}.workflow-builder-div__diagram-area__float-actions__fullscreen[_ngcontent-%COMP%]   .mat-button-toggle-checked[_ngcontent-%COMP%]{--mat-standard-button-toggle-selected-state-background-color: var(--palette-primary-500);--mat-standard-button-toggle-selected-state-text-color: var(--palette-primary-50)}.workflow-builder-div__diagram-area__float-actions__fullscreen[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{font-size:2em;height:1em;width:1em;line-height:1em}.workflow-builder-div__diagram-area__float-actions__fullscreen[_ngcontent-%COMP%]     mat-button-toggle button{padding-left:0}.workflow-builder-div__diagram-area__float-actions__button-add[_ngcontent-%COMP%]{--mdc-text-button-container-height: 24px}.workflow-builder-div__diagram-area__float-actions__button-add[_ngcontent-%COMP%]{--mdc-filled-button-container-height: 24px}.workflow-builder-div__diagram-area__float-actions__button-add[_ngcontent-%COMP%]{--mdc-protected-button-container-height: 24px}.workflow-builder-div__diagram-area__float-actions__button-add[_ngcontent-%COMP%]{--mdc-outlined-button-container-height: 24px}.workflow-builder-div__diagram-area__float-actions__button-add[_ngcontent-%COMP%]{--mat-text-button-touch-target-display: none}.workflow-builder-div__diagram-area__float-actions__button-add[_ngcontent-%COMP%]{--mat-filled-button-touch-target-display: none}.workflow-builder-div__diagram-area__float-actions__button-add[_ngcontent-%COMP%]{--mat-protected-button-touch-target-display: none}.workflow-builder-div__diagram-area__float-actions__button-add[_ngcontent-%COMP%]{--mat-outlined-button-touch-target-display: none}.workflow-builder-div__diagram-area__float-actions__button-add[_ngcontent-%COMP%]{display:none;position:absolute;right:1em;bottom:1em}.workflow-builder-div__diagram-area__float-actions__button-add[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{font-size:2em}.workflow-builder-div__diagram-area__float-actions__hide-workflow-description[_ngcontent-%COMP%]     .mdc-form-field{transform:scale(.8)}.workflow-builder-div__diagram-area__float-actions__hide-workflow-description[_ngcontent-%COMP%]     .mdc-switch{--mdc-switch-track-width: 2em;margin-right:0!important}.workflow-builder-div__diagram-area__float-actions__hide-workflow-description[_ngcontent-%COMP%]     .mdc-label{font-size:1.2em}.workflow-builder-div__diagram-area__float-actions--bottom[_ngcontent-%COMP%]{bottom:1em}.workflow-builder-div__palette-area[_ngcontent-%COMP%]{position:relative;max-height:inherit;overflow-y:auto;width:264px;padding:2px;transition:width .3s}.workflow-builder-div__palette-area__actions[_ngcontent-%COMP%]{position:absolute;top:1em;right:1em;display:flex;align-items:center;z-index:1}.workflow-builder-div__palette-area__actions__button-close[_ngcontent-%COMP%]{color:#c2c2c2;padding:4px;--mdc-icon-button-state-layer-size: 30px}.workflow-builder-div__palette-area__actions__button-close[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{font-size:24px}.workflow-builder-div[_ngcontent-%COMP%]     g[id^=connector_]{transition:opacity .3s}.workflow-builder-div--isDraggingConnector[_ngcontent-%COMP%]     .workflow-builder-div__diagram-area__diagram__workflow-item.valid-next-workflow-target{box-shadow:0 0 1em #ccc;border-width:3px;border-color:#98ca71}.workflow-builder-div--isDraggingConnector[_ngcontent-%COMP%]     .workflow-builder-div__diagram-area__diagram__workflow-item:not(.valid-next-workflow-target), .workflow-builder-div--isDraggingConnector[_ngcontent-%COMP%]     g[id^=connector_]:not(:has(*[stroke-width=\"4\"])){opacity:30%;cursor:not-allowed}.workflow-builder-div--isHidingPalette[_ngcontent-%COMP%]   .workflow-builder-div__diagram-area[_ngcontent-%COMP%]{width:100%}.workflow-builder-div--isHidingPalette[_ngcontent-%COMP%]   .workflow-builder-div__diagram-area__float-actions__button-add[_ngcontent-%COMP%]{display:block}.workflow-builder-div--isHidingPalette[_ngcontent-%COMP%]   .workflow-builder-div__palette-area[_ngcontent-%COMP%]{width:0px}.workflow-builder-div--isHideWorkflowDescription[_ngcontent-%COMP%]   .workflow-builder-div__diagram-area__diagram__workflow-item[_ngcontent-%COMP%]     .workflow-builder-node-item__header__name{justify-content:center}.workflow-builder-div--isHideWorkflowDescription[_ngcontent-%COMP%]   .workflow-builder-div__diagram-area__diagram__workflow-item[_ngcontent-%COMP%]     .workflow-builder-node-item__header__description{height:0px;max-height:0px;opacity:0;margin:0}mat-tab-group[_ngcontent-%COMP%]{max-height:100%;height:100%;position:relative;display:flex}mat-tab-group[_ngcontent-%COMP%]     .mat-mdc-tab-body-wrapper{height:100%;overflow:hidden}mat-tab-group[_ngcontent-%COMP%]     .mat-mdc-tab-header, mat-tab-group[_ngcontent-%COMP%]     .mat-mdc-tab-body-wrapper{background-color:#fff}mat-tab-group[_ngcontent-%COMP%]     .mat-mdc-tab-body.mat-mdc-tab-body-active, mat-tab-group[_ngcontent-%COMP%]     .mat-mdc-tab-body-content{overflow:hidden}  .mat-mdc-tab-header{margin-bottom:0}ejs-diagram[_ngcontent-%COMP%]{display:block;flex:1 1 auto;height:auto!important;width:100%!important;max-width:100%;box-shadow:0 0 2px #0000009c;border-radius:4px;background-color:#fbfbfb}ejs-diagram.ejs-diagram--has-node-selected-and-expanded[_ngcontent-%COMP%]     #diagram_htmlLayer{z-index:1}ejs-diagram[_ngcontent-%COMP%]    {--diagram-highlight-color: var(--palette-primary-500)}ejs-diagram[_ngcontent-%COMP%]     #diagram_editTextBoxDiv{display:none}ejs-diagram[_ngcontent-%COMP%]     #diagram_SelectorElement #borderRect{stroke:var(--diagram-highlight-color);stroke-dasharray:0;stroke-width:2px;opacity:50%;rx:8px;ry:8px}ejs-diagram[_ngcontent-%COMP%]     #diagram_diagramPorts g[id^=node_][id*=_port__][id$=pin_groupElement] path{fill:#ccc;stroke:#fff}  .e-tooltip-wrap{pointer-events:none}  *:not(:has([id^=node_][id*=_port__]:hover)) .e-tooltip-wrap,   *:has(.workflow-builder-div--isDraggingConnector) .e-tooltip-wrap{display:none}  [class].diagram-node__selected{z-index:99999999}  [class].diagram-node__ineligible{opacity:.5}  .workflow-builder-div__diagram-area__toolbar__tool-zoom__option.mat-mdc-option{font-size:var(--workflow-builder__diagram__font-size)}  .workflow-builder-div__diagram-area__toolbar__tool-zoom__option.mat-mdc-option .mdc-list-item__primary-text{white-space:pre;text-align:right;min-width:max-content}"]
      });
    }
  }
  return WorkflowBuilderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaWorkflowBuilderWithStateApiService = /*#__PURE__*/(() => {
  class AzavistaWorkflowBuilderWithStateApiService extends AzavistaApiService {
    constructor(apiSvc) {
      super(apiSvc['http'], apiSvc['utilsSvc']);
      this.apiSvc = apiSvc;
      this.init(this.apiSvc['config']);
    }
    async saveDraft(eventId, current_revision, patches) {
      const path = this.utilsSvc.prefixWithBaseUrl(`/event/${eventId}/workflow_builder/draft`);
      const payload = {
        current_revision,
        patches
      };
      const res = await this.put(path, payload, 'workflowBuilderSaveDraft');
      return res;
    }
    revertToPublishedDraft(eventId) {
      return this.apiSvc.revertPublishedEventWorkflowBuilder(eventId);
    }
    publishDraft(eventId) {
      return this.apiSvc.publishEventWorkflowBuilder(eventId);
    }
    isOutOfSyncError(err) {
      return err?.communicationError?.body?.code === 'UpdatesReceivedByServer';
    }
    async fetchDraftAndRevision(eventId) {
      const path = this.utilsSvc.prefixWithBaseUrl(`/event/${eventId}/workflow_builder/draft`);
      const queryParams = {};
      const res = await this.getWithQuery(path, queryParams, 'workflowBuilderFetchDraftAndRevision');
      return res;
    }
    async fetchNewRevisions(eventId, revision) {
      const path = this.utilsSvc.prefixWithBaseUrl(`/event/${eventId}/workflow_builder/draft/revisions`);
      const queryParams = {
        revision
      };
      const res = await this.getWithQuery(path, queryParams, 'workflowBuilderFetchNewRevisions');
      return res;
    }
    static {
      this.ɵfac = function AzavistaWorkflowBuilderWithStateApiService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaWorkflowBuilderWithStateApiService)(i0.ɵɵinject(i1$1.AzavistaApiService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AzavistaWorkflowBuilderWithStateApiService,
        factory: AzavistaWorkflowBuilderWithStateApiService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AzavistaWorkflowBuilderWithStateApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// eslint-disable-next-line max-len
class WorkflowBuilderWithStateProvider extends WorkflowBuilderProviderApi {
  constructor(servicelibApiSvc, controller, sharedSvc, getAllWorkflowsForInit, saveBuilderData, publishBuilderData, revertPublishedBuilderData) {
    super(servicelibApiSvc, controller, sharedSvc);
    this.servicelibApiSvc = servicelibApiSvc;
    this.controller = controller;
    this.sharedSvc = sharedSvc;
    this.getAllWorkflowsForInit = getAllWorkflowsForInit;
    this.saveBuilderData = saveBuilderData;
    this.publishBuilderData = publishBuilderData;
    this.revertPublishedBuilderData = revertPublishedBuilderData;
    this.apiSvc = new AzavistaWorkflowBuilderWithStateApiService(this.servicelibApiSvc);
  }
}
let WorkflowBuilderWithStateComponent = /*#__PURE__*/(() => {
  class WorkflowBuilderWithStateComponent extends AzavistaWorkflowBuilderBaseDirective {
    get builder() {
      return this._builder;
    }
    set builder(value) {
      this._builder = value;
      if (value) {
        this.builderEvent.emit({
          type: 'loaded',
          builder: value
        });
      }
    }
    get workflowBuilder() {
      return this._workflowBuilder;
    }
    set workflowBuilder(value) {
      if (value?.workflows) {
        const fixedWorkflowBuilder = fixWorkflowBuilderData(value);
        this._workflowBuilder = pick(fixedWorkflowBuilder, ['workflows']);
      } else {
        this._workflowBuilder = value;
      }
    }
    constructor(apiSvc, builderSvc, controller, sharedSvc, cdr, ngZone) {
      super(ngZone);
      this.apiSvc = apiSvc;
      this.builderSvc = builderSvc;
      this.controller = controller;
      this.sharedSvc = sharedSvc;
      this.cdr = cdr;
      this.ngZone = ngZone;
      /**
       * @default 80 milliseconds
       */
      this.saveChangesDebounceMillis = 80;
      this.beforeReDraw = new EventEmitter();
      this.afterReDraw = new EventEmitter();
      this.afterError = new EventEmitter();
      this.publishJobId = new EventEmitter();
      this.builderEvent = new EventEmitter();
      /** Builder is forced to be hidden in order to re-init them */
      this.shouldShowBuilder = false;
      this.uiStateOnDraftBefore = async (draft, cause) => {
        this.log('uiStateOnDraftBefore', cause, draft);
        this.beforeReDraw.emit([draft, cause]);
        switch (cause) {
          case 'save':
            {
              break;
            }
          case 'revert_to_published':
          case 'redraw':
          case 'save_failed':
          case 'start':
            {
              this.workflowBuilder = draft;
              this.shouldShowBuilder = false;
              this.cdr.detectChanges();
              this.shouldShowBuilder = true;
              this.cdr.detectChanges();
            }
        }
        await firstValueFrom(this.ngZone.onStable);
        this.afterReDraw.emit([draft, cause]);
      };
    }
    async ngOnInit() {
      if (this.eventId) {
        this.state = new StateMachine(this.eventId, this.apiSvc, {
          onDraft: this.uiStateOnDraftBefore,
          onError: error => this.afterError.emit(error),
          onPublishJob: jobID => this.publishJobId.emit(jobID)
        }, this.pollingIntervalMillis, this.saveChangesDebounceMillis);
        this.dataProvider = new WorkflowBuilderWithStateProvider(this.apiSvc, this.controller, this.sharedSvc, async () => this.workflowBuilder?.workflows ?? [], async (eventId, data) => this.state?.saveChanges(data),
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        async (eventId, data) => this.state?.publish(),
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        async () => this.state?.revertToPublished());
        this.state.start();
      }
    }
    ngOnDestroy() {
      this.log('stop');
      this.state?.stop();
    }
    log(logName, ...params) {
      if (this.debugMode) {
        console.groupCollapsed(`WorkflowBuilderWithStateComponent - ${logName}`);
        console.trace(params);
        console.groupEnd();
      }
    }
    static {
      this.ɵfac = function WorkflowBuilderWithStateComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WorkflowBuilderWithStateComponent)(i0.ɵɵdirectiveInject(AzavistaWorkflowBuilderWithStateApiService), i0.ɵɵdirectiveInject(WorkflowBuilderService), i0.ɵɵdirectiveInject(AzavistaWorkflowBuilderController), i0.ɵɵdirectiveInject(i1.AzavistaSharedService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.NgZone));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: WorkflowBuilderWithStateComponent,
        selectors: [["azavista-workflow-builder-with-state"]],
        viewQuery: function WorkflowBuilderWithStateComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(WorkflowBuilderComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.builder = _t.first);
          }
        },
        inputs: {
          pollingIntervalMillis: "pollingIntervalMillis",
          saveChangesDebounceMillis: "saveChangesDebounceMillis"
        },
        outputs: {
          beforeReDraw: "beforeReDraw",
          afterReDraw: "afterReDraw",
          afterError: "afterError",
          publishJobId: "publishJobId",
          builderEvent: "builderEvent"
        },
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 1,
        vars: 1,
        consts: [[3, "dataProvider", "eventId", "debugMode", "isDemo", "stateCallbackMap", "propertyOptions", "autoHideFieldLabel", "updateProcessCallback", "updateAdvancedQueryCallback", "deleteWorkflowConfirmation", "hidePaletteList", "workflowTypeCategories", "scrollSettings", "nodeItemsLoaded", 4, "ngIf"], [3, "nodeItemsLoaded", "dataProvider", "eventId", "debugMode", "isDemo", "stateCallbackMap", "propertyOptions", "autoHideFieldLabel", "updateProcessCallback", "updateAdvancedQueryCallback", "deleteWorkflowConfirmation", "hidePaletteList", "workflowTypeCategories", "scrollSettings"]],
        template: function WorkflowBuilderWithStateComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, WorkflowBuilderWithStateComponent_azavista_workflow_builder_0_Template, 1, 13, "azavista-workflow-builder", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.shouldShowBuilder && ctx.dataProvider && ctx.eventId);
          }
        },
        dependencies: [i4.NgIf, WorkflowBuilderComponent],
        styles: ["[_nghost-%COMP%]{display:block;position:relative;min-width:inherit;max-width:inherit;min-height:inherit;max-height:inherit;height:inherit;width:inherit}"]
      });
    }
  }
  return WorkflowBuilderWithStateComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaWorkflowBuilderModule = /*#__PURE__*/(() => {
  class AzavistaWorkflowBuilderModule {
    static {
      this.ɵfac = function AzavistaWorkflowBuilderModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaWorkflowBuilderModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AzavistaWorkflowBuilderModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, ReactiveFormsModule, FormsModule, MatFormFieldModule, MatInputModule, MatButtonModule, MatButtonToggleModule, MatIconModule, MatExpansionModule, MatSelectModule, MatCheckboxModule, MatListModule, MatSlideToggleModule, MatTabsModule, MatDialogModule, MatTooltipModule, MatProgressBarModule, TranslateModule, DiagramModule, SymbolPaletteModule,
        // AzavistaGroupedFieldsModule,
        AzavistaServicelibModule, AzavistaJobsStatusModule, AzavistaButtonModule, AzavistaFlowBuilderModule, AzavistaDurationModule, AzavistaExportedElementModule, AzavistaTableModule, AzavistaInputFieldModule]
      });
    }
  }
  return AzavistaWorkflowBuilderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of workflow-builder
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ASYNC_VALIDATOR_DELAY, AzavistaWorkflowBuilderBaseDirective, AzavistaWorkflowBuilderController, AzavistaWorkflowBuilderFormFieldService, AzavistaWorkflowBuilderModule, AzavistaWorkflowBuilderWithStateApiService, AzavistaWorkflowBuilderZoomSelectComponent, AzavistaWorkflowBuilderZoomService, DEFAULT_CONNECTOR, DEFAULT_ERROR_STROKE_COLOR, DEFAULT_NODE_HEIGHT, DEFAULT_NODE_WIDTH, DEFAULT_PORT_SIZE, DEFAULT_PORT_STROKE_WIDTH, DEFAULT_SELECTED_STROKE_COLOR, DEFAULT_STROKE_COLOR, DEFAULT_STROKE_WIDTH, DEFAULT_ZOOM_VALUE, FIELD_NAME_PROFILE_ID, FIELD_NAME_STAGE_ID, ISO_LANGUAGES, OUTPUT_PIN_PAIR, OUTPUT_PIN_TRANSLATIONS, OUTPUT_PIN_TRANSLATIONS_COLOR, OUTPUT_PIN_TRANSLATIONS_COLOR_CUSTOM_BY_WORKFLOW_TYPE, OUTPUT_PIN_TRANSLATIONS_CUSTOM_BY_WORKFLOW_TYPE, PALETTE_CATEGORIES_INDEX, PALETTE_CATEGORIES_ORDER, PREFIX_CONNECTOR, PREFIX_NODE, PREFIX_PORT, PROPERTY_ATTRIBUTE_TO_OUTPUT_PINS_DEPENDENTS, WORKFLOW_BUILDER_STATE_CALLBACK_MAP, WORKFLOW_EXPLANATION_TRANSLATIONS, WORKFLOW_NAME_TRANSLATIONS, WORKFLOW_TYPE_CATEGORIES, WORKFLOW_TYPE_ORDER, WORKFLOW_TYPE_PALETTE_SVG, WORKFLOW_WARNING_NO_POSSIBLE_NEXT_WORKFLOW, WorkflowBuilderComponent, WorkflowBuilderNodeItemBase, WorkflowBuilderPaletteComponent, WorkflowBuilderProcessBuilderBaseDirective, WorkflowBuilderProviderAbstract, WorkflowBuilderProviderApi, WorkflowBuilderService, WorkflowBuilderWithStateComponent, WorkflowBuilderWithStateProvider, ZOOM_FACTOR_OPTIONS, ZOOM_FACTOR_OPTIONS_DELTA, ZOOM_FACTOR_OPTIONS_MAX, ZOOM_FACTOR_OPTIONS_MIN, copyWorkflowFactory, createFormGroupFromData, crmStatusArray, delay, fixWorkflowBuilderData, getAzavistaServiceLibCacheProxy, getBuilderWorkflowFromLocalStorage, getConditionFromSplitterOutput, getConnectorAnnotation, getConnectorAnnotationColor, getConnectorFromWorkflowOutputPin, getConnectorId, getCrmStatusArray, getDefaultInputPinPort, getDefaultNode, getDefaultNodeConstraint, getDefaultOutputPinPort, getDiagramNodeInstance, getFormDirtyValues, getGroupByValue, getMapByValue, getMapByValueFromFn, getMultipleOutputPorts, getNodeAndConnectorsFromCanvasControllerData, getNodeConstraints, getNodeFromCanvasControllerData, getNodeIdFromWorkflowId, getNodeModelForPalette, getNodeModelForPaletteFromWorkflowType, getNodeOutputPortId, getNodePortsFromFactory, getOrderedIEventWorkflows, getOutputNonSidePins, getOutputPinFromConnector, getOutputPinTranslationKey, getOutputSidePins, getPaletteCategoryMap, getPossibleNextWorkflowTypes, getSplitterOutputFromCondition, getValidConnectorsFromWorkflowFactory, getWorkflowFactory, getWorkflowIdFromNodeId, getWorkflowTypeArray, isObject, mergeDeep, nodeModelForPaletteCreateWorkBlock, objectKeys, omit, reorderWorkflowsByPaletteCategory, saveBuilderWorkflowToLocalStorage, trackBy, trackByAttributeTranslations, trackByWorkflowProperty, validateWorkflowProperty, workflowTypeArray };
